export const drugData = [
    "Maxidex",
    "Meaningful Beauty Cindy Crawford Skin Brightening Décolleté And Neck Treatment Spf 15",
    "Medicated Acne Gel",
    "Men Advanced Series Charcoal",
    "Men Advanced Series Full & Thick",
    "Men Advanced Series Pure Sport",
    "Men Advanced Series Refreshing Menthol",
    "Men Advanced Series Swagger",
    "Men Expert Anti-dandruff 2 In 1",
    "Men's Rogaine Foam 5%",
    "Micatin Miconazole Nitrate Cream 2% Usp",
    "Mineral Oil Usp",
    "Mk Men Advanced Facial Hydrator Sunscreen Spf 30",
    "Moisture Oil-free Spf 30",
    "Moisture Rescue Spf 15",
    "Moisture Sun Protector",
    "Moisture Surge Sheertint Hydrator Spf 25",
    "Moisturizing Antioxidant Day Crème Spf 20",
    "Multi-action Cream Spf 30",
    "Myoflex Extra Strength",
    "Myoflex Maximum Strength",
    "Myoflex Regular Strength",
    "Nature Republic California Moisturizing Aloe Daily Sun Cream Spf 50+",
    "Neutrogena Clear Face",
    "Neutrogena Healthy Skin Anti-wrinkle Cream Spf 15",
    "Neutrogena Healthy Skin Face Lotion Spf 15",
    "Neutrogena Moisture Oil-free Spf 15",
    "Neutrogena Ultra Sheer Body Mist Sunscreen Spf 60",
    "Nidagel Vaginal Gel 0.75%",
    "Nivea Sun",
    "No 7 Beautiful Skin Day Cream Normal/oily Spf 15",
    "No 7 Men Protect & Perfect Intense Moisturiser Spf 15",
    "No 7 Restore & Renew Day Cream Spf 15",
    "No7 Beautiful Skin Day Cream Normal/dry Spf 15",
    "No7 Early Defence Glow Activating Day Cream",
    "No7 Lift & Luminate Triple Action Day Cream",
    "No7 Protect & Perfect Intense Advanced Day Cream",
    "Noritate",
    "Nourishing Care",
    "Nourishing Care 2in1",
    "Nourishing Day Cream",
    "Octinoxate Lotion Spf 18",
    "Odan Clobetasol Spray",
    "Odor-eaters",
    "Ointment With Moisturizing Vitamin E",
    "Olay Age Defying Advanced With Hyaluronic Acid Hydrating Moisturizer Lotion With Sunscreen",
    "Olay Age Defying Anti Wrinkle Day Lotion With Spf 15",
    "Olay Age Defying Classic Daily Renewal Lotion With Sunscreen",
    "Olay Complete All Day Moisture Cream",
    "Olay Complete All Day Moisture With Sunscreen Broad Spectrum Spf 30 Sensitive",
    "Olay Complete Uv365* Daily Moisturizing Cream With Sunscreen Broad Spectrum Spf 15 Sensitive",
    "Olay Complete Uv365* Daily Moisturizing Lotion With Sunscreen Broad Spectrum Spf 15 Sensitive",
    "Olay Luminous Whip",
    "Olay Regenerist Enhancing Uv Lotion With Spf 15",
    "Olay Regenerist Micro-sculpting Cream With Sunscreen",
    "Olay Regenerist Micro-sculpting Cream With Sunscreen Broad Spectrum Spf 30",
    "Olay Regenerist Whip",
    "Olay Regenerist Whip Sun Protection Factor 40",
    "Olay Sensitive",
    "Docetaxel Injection",
    "Docetaxel Injection Usp",
    "Docusate Sodium",
    "Doloral 1",
    "Doloral 5 Sirop 5mg/ml",
    "Dopamine Hcl 0.8mg/ml Dextrose 5% Inj Usp",
    "Dopamine Hcl 1.6mg/ml Dextrose 5% Inj Usp",
    "Dopamine Hcl 3.2mg/ml Dextrose 5% Inj Usp",
    "Dorzolamide And Timolol Eye Drops Bp",
    "Dotarem",
    "Doxorubicin",
    "Doxorubicin Hydrochloride Injection",
    "Doxorubicin Hydrochloride Injection, Usp",
    "Doxorubicin Injection, Bp",
    "Dry Cough Relief Extra Strength",
    "Duodopa",
    "Dupixent",
    "Elaprase",
    "Elixir De Theophylline",
    "Emerade",
    "Emgality",
    "Enalaprilat Injection Usp",
    "Enbrel",
    "Enspryng",
    "Entyvio",
    "Ephedrine Sulfate Injection Usp",
    "Epinephrine Injection Usp",
    "Epipen",
    "Epipen Jr",
    "Epirubicin For Injection",
    "Erbitux",
    "Erelzi",
    "Erfa-amikacin",
    "Erfa-tranexamic",
    "Ergonovine Maleate Injection Usp",
    "Etoposide Injection",
    "Evenity",
    "Exelon",
    "Expectorant (extra Strength) Syrup",
    "Extra Strength Bismuth",
    "Extra Strength Bismuth Subsalicylate Liquid",
    "Extra Strength Tylenol Complete Cold, Cough & Flu Plus Mucus Relief",
    "Extra Strength Tylenol Complete Cold, Cough & Flu Plus Mucus Relief Nighttime",
    "Eylea",
    "Famotidine Omega   -(with Preservative,benzyl Alcohol)",
    "Famotidine Omega  -(without Preservative)",
    "Fasenra",
    "Fasenra Pen",
    "Faslodex",
    "Ferriprox",
    "Ferrlecit",
    "Firazyr",
    "Fluanxol Depot 10%- Liq Im 100mg/ml",
    "Fluanxol Depot 2% -liq Im 20mg/ml",
    "Fluconazole In Sodium Chloride Injection Usp",
    "Fluconazole Injection Sdz",
    "Fludarabine Phosphate For Injection",
    "Flumazenil Injection",
    "Fluorouracil Injection",
    "Fluorouracil Injection Usp",
    "Folic Acid Injection Usp",
    "Folic Acid Injection, Usp",
    "Folotyn",
    "Fondaparinux Sodium Injection",
    "Fulphila",
    "Fulvestrant Injection",
    "Furosemide Inj Usp",
    "Furosemide Injection Sdz",
    "Furosemide Injection Usp",
    "Furosemide Special",
    "Gadovist 1.0",
    "Gazyva",
    "Gemcitabine Injection",
    "Gentamicin Injection Usp",
    "Gentamicin(e)",
    "Genteal",
    "Givlaari",
    "Glatect",
    "Glycerolyte 57 Solution",
    "Glycine Irrigation Usp",
    "Glycopyrrolate Injection",
    "Glycopyrrolate Injection Multidose",
    "Glycopyrrolate Injection Usp",
    "Granisetron Hydrochloride Injection",
    "Gravol Im",
    "Hair Regrowth Formula",
    "Halaven",
    "Haloperidol Inj 5mg/ml Usp",
    "Haloperidol Injection",
    "Haloperidol Injection, Usp",
    "Haloperidol La",
    "Hemangiol",
    "Hemlibra",
    "Heparin Sod And 0.9% Sod Chloride Inj",
    "Heptovir",
    "Herceptin Sc",
    "Histatrol",
    "Hizentra",
    "Humira",
    "Hydromorphone Hp 10",
    "Hydromorphone Hp 20",
    "Hydromorphone Hp 50",
    "Hydromorphone Hp Forte Injection",
    "Hydromorphone Hydrochloride Injection",
    "Hydromorphone Hydrochloride Injection Hp 10",
    "Hydromorphone Hydrochloride Injection Hp 50",
    "Hydromorphone Hydrochloride Injection Hp Forte",
    "Hydromorphone Hydrochloride Injection Usp",
    "Hydromorphone Hydrochloride Injection, Usp",
    "Hydroxyzine Hydrochloride Injection Usp",
    "Hyoscine Butylbromide Injection Sandoz Standard",
    "Ilaris",
    "Imfinzi",
    "Imitrex",
    "Imodium Calming Liquid",
    "Infacol",
    "Infants' Motrin",
    "Infants' Tylenol",
    "Infants' Tylenol Fever & Sore Throat Pain",
    "Injectable Naloxone Hydrochloride",
    "Integrilin",
    "Invega Sustenna",
    "Invega Trinza",
    "Ipratropium Bromide And Salbutamol Sulphate Inhalation Solution",
    "Irinotecan",
    "Irinotecan For Injection",
    "Irinotecan Hydrochloride Injection",
    "Irinotecan Hydrochloride Injection Usp",
    "Isocaine Hcl Inj 2%",
    "Isocaine Hcl Inj 3%",
    "Isolyte S (multi-electrolyte Injection)",
    "Isoproterenol Hydrochloride Injection Usp",
    "Nat-pregabalin",
    "Nat-quetiapine",
    "Nat-rizatriptan Odt",
    "Nat-tenofovir",
    "Nat-zolmitriptan",
    "Neo-laryngobis",
    "Neoral 100mg",
    "Neoral 10mg",
    "Neoral 25mg",
    "Neoral 50mg",
    "Nerlynx",
    "Nesina",
    "Neuleptil",
    "Neurontin",
    "Nexavar",
    "Nexium - 20mg",
    "Nexium - 40mg",
    "Nexium 24hr",
    "Nexplanon",
    "Nifedipine",
    "Nifedipine Er",
    "Nighttime Cold & Flu Liquid Capsules",
    "Nighttime Flu, Cough & Cold Complete Relief Extra Strength",
    "Nighttime Pain Relief",
    "Nighttime Sleep Aid",
    "Nighttime Total Cold And Flu",
    "Nimotop",
    "Ninlaro",
    "Nitisinone Tablets",
    "Nitoman",
    "Nitrofurantoin",
    "Nitrostat",
    "Nolvadex-d Tab 20mg",
    "Norfloxacin",
    "Norlutate",
    "Norprolac",
    "Norvasc",
    "Norvir",
    "Novamilor",
    "Novamoxin",
    "Novasen",
    "Novo-docusate",
    "Novo-gesic",
    "Novo-gesic Forte",
    "Novo-hydroxyzin",
    "Novo-profen",
    "Nra-amlodipine",
    "Nra-atorvastatin",
    "Nra-azithromycin",
    "Nra-celecoxib",
    "Nra-ciprofloxacin",
    "Nra-citalopram",
    "Nra-clindamycin",
    "Nra-clopidogrel",
    "Nra-duloxetine",
    "Nra-escitalopram",
    "Nra-ezetimibe",
    "Nra-fluoxetine",
    "Nra-montelukast",
    "Nra-olmesartan",
    "Nra-omeprazole",
    "Nra-pantoprazole",
    "Nra-paroxetine",
    "Nra-perindopril",
    "Nra-pregabalin",
    "Nra-quetiapine",
    "Nra-ramipril",
    "Nra-rizatriptan Odt",
    "Nra-rosuvastatin",
    "Nra-sertraline",
    "Nra-sildenafil",
    "Nra-zolmitriptan",
    "Nra-zopiclone",
    "Nubeqa",
    "Nucynta Extended-release",
    "Nucynta Ir",
    "Nuvaring",
    "Nyquil Complete + Vicks Vapocool",
    "Nyquil Sinus Liquicaps",
    "Nytol Extra Strength Sleep Aid Caplet 50mg",
    "Ocaliva",
    "Odefsey",
    "Odomzo",
    "Ofev",
    "Olanzapine",
    "Olanzapine Odt",
    "Olmesartan",
    "Olmetec",
    "Olmetec Plus",
    "Olumiant",
    "Omeprazole",
    "Omeprazole Magnesium Delayed Release Tablets",
    "Omeprazole-20",
    "Ondansetron",
    "Ondansetron Odt",
    "Ondissolve Odf",
    "Onglyza",
    "Onstryv",
    "Opsumit",
    "Orfadin",
    "Orfenace Tablet 100mg",
    "Orilissa",
    "Orkambi",
    "Oseltamivir Phosphate Capsules",
    "Otezla",
    "Ovol For Gas 180 Mg Capsule",
    "Ovol For Gas 180 Mg Tablet",
    "Ovol For Gas 80 Mg Tablet",
    "Oxazepam 10 Tab 10mg",
    "Oxazepam 15 Tab 15mg",
    "Oxazepam 30 Tab 30mg",
    "Oxy.ir",
    "Ach-fingolimod",
    "Ach-imatinib",
    "Ach-mycophenolate",
    "Ach-olmesartan",
    "Ach-olmesartan Hctz",
    "Ach-pioglitazone",
    "Ach-pravastatin",
    "Ach-quetiapine Fumarate Xr",
    "Ach-rosuvastatin",
    "Ach-telmisartan Hctz",
    "Ach-temozolomide",
    "Ach-topiramate",
    "Acid Control",
    "Acid Reducer",
    "Act Amlodipine",
    "Act Amphetamine Xr",
    "Act Buprenorphine/naloxone",
    "Act Celecoxib",
    "Act Ciprofloxacin",
    "Act Clarithromycin Xl",
    "Act Clopidogrel",
    "Act Dextroamphetamine Sr",
    "Act Diltiazem Cd",
    "Act Diltiazem T",
    "Act Donepezil Odt",
    "Act Dutasteride",
    "Act Enalapril",
    "Act Escitalopram Odt",
    "Act Etidrocal",
    "Act Etidronate",
    "Act Exemestane",
    "Act Famciclovir",
    "Act Fluconazole",
    "Act Fluvoxamine",
    "Act Levofloxacin",
    "Act Meloxicam",
    "Act Memantine",
    "Act Metformin",
    "Act Methylphenidate Er",
    "Act Nabilone",
    "Act Olanzapine Odt",
    "Act Olmesartan",
    "Act Olmesartan Hct",
    "Act Ondansetron",
    "Act Pioglitazone",
    "Act Pramipexole",
    "Act Quetiapine",
    "Act Raloxifene",
    "Act Repaglinide",
    "Act Rizatriptan",
    "Act Sumatriptan",
    "Act Temozolomide",
    "Act Terbinafine",
    "Act Venlafaxine Xr",
    "Act Zopiclone",
    "Activated Charcoal",
    "Activated Charcoal 260mg",
    "Activelle",
    "Activelle Ld",
    "Actonel",
    "Actonel Dr",
    "Adalat Xl - Srt 30mg",
    "Adcirca",
    "Adderall Xr",
    "Addyi",
    "Adempas",
    "Advagraf",
    "Advil 12 Hour",
    "Advil Arthritis Pain",
    "Advil Caplets",
    "Advil Cold & Flu",
    "Advil Cold & Sinus Convenience Pack",
    "Advil Cold & Sinus Liqui-gels",
    "Advil Cold & Sinus Plus",
    "Advil Cold And Sinus",
    "Advil Cold And Sinus Daytime",
    "Advil Cold And Sinus Nighttime",
    "Advil Cold, Cough & Flu Nighttime",
    "Advil Cold, Sinus & Flu Extra Strength",
    "Advil Day/night Convenience Pack",
    "Advil Extra Strength Caplets",
    "Advil Extra Strength Liqui-gels",
    "Advil Gel Caplets",
    "Advil Liqui-gels",
    "Advil Mini-gels",
    "Advil Muscle And Joint",
    "Advil Nighttime",
    "Advil Tablets",
    "Aerius",
    "Aerius Double Action 12 Hour",
    "Afinitor",
    "Afinitor Disperz",
    "Ag-allopurinol",
    "Ag-amitriptyline",
    "Ag-amlodipine",
    "Ag-amoxicillin",
    "Ag-atenolol",
    "Ag-atorvastatin",
    "Ag-azithromycin",
    "Ag-celecoxib",
    "Ag-citalopram",
    "Prismasol 4",
    "Ravicti",
    "Salofalk",
    "Smofkabiven",
    "Smofkabiven Electrolyte Free",
    "Sodium Chloride 3% Inj",
    "Sulcrate Suspension Plus",
    "Bi-peglyte",
    "Cholestyramine-odan",
    "Colestid Granules",
    "Jamp-cholestyramine",
    "Jamp-fosfomycin",
    "Lodalis",
    "Lokelma",
    "Monurol",
    "Moviprep",
    "Olestyr",
    "Renvela",
    "Sodium Bicarbonate Usp For Hemodialysis D12276",
    "Veltassa",
    "Ampicillin For Injection, Usp",
    "Ampicillin Sodium For Injection Bp",
    "Ampicillin Sodium For Injection, Usp",
    "Apo-cefepime",
    "Calcium Chloride For Haemodialysis",
    "Cefazolin For Injection",
    "Cefazolin For Injection Usp",
    "Cefazolin For Injection, Usp",
    "Cefotaxime Sodium For Injection, Bp",
    "Cefoxitin For Injection",
    "Ceftazidime For Injection Bp",
    "Ceftazidime For Injection, Usp",
    "Ceftriaxone Sodium For Injection",
    "Ceftriaxone Sodium For Injection Bp",
    "Cefuroxime For Injection, Usp",
    "Chloromycetin Succinate Injection 1gm",
    "Cloxacillin For Injection",
    "Cyanokit",
    "Deferoxamine Mesylate For Injection",
    "Ertapenem For Injection",
    "Erythrocin I.v.",
    "Fibryga",
    "Gemcitabine For Injection",
    "Ifex",
    "Invanz",
    "Ivozfo",
    "Jamp-vancomycin",
    "Meropenem For Injection",
    "Meropenem For Injection Usp",
    "Methylprednisolone Sodium Succinate For Injection",
    "Piperacillin / Tazobactam Powder For Injection",
    "Piperacillin And Tazobactam For Injection",
    "Piperacillin Sodium/tazobactam Sodium Powder For Injection",
    "Solu-cortef 1 Gm Act-o-vial",
    "Solu-medrol",
    "Streptomycin For Injection Usp",
    "Tobramycin For Injection",
    "Vancomycin Hydrochloride For Injection Usp",
    "Vancomycin Hydrochloride For Injection, Usp",
    "Virazole",
    "Zerbaxa",
    "Apo-sucralfate - Tab 1g",
    "Apo-tryptophan",
    "Bibag",
    "Colestid Tablets",
    "Mezavant",
    "Mezera",
    "Pentasa",
    "Sulcrate",
    "Teva-sucralfate",
    "Teva-tryptophan",
    "Tryptan Tab 1000mg",
    "Vascepa",
    "Galli Eo",
    "Ruby-fill",
    "Technelite",
    "Cyclodx",
    "Fludeoxyglucose (18f) Injection",
    "Osteovision",
    "Sodium Iodide (131i) Solution",
    "Miconazole Nitrate Vaginal Cream Usp",
    "Clindamycin Phosphate Topical Solution Usp",
    "Cold And Allergy Decongestant Nasal Spray",
    "Covalonguard Spray",
    "Cyclogyl",
    "Decongest Nasal",
    "Decongestant Nasal Spray",
    "Dequadin Oral Paint",
    "Derm Oil",
    "Dermotic Oil Ear Drops",
    "Dermsafe Chlorhexidine Gluconate Hand Sanitizer Lotion",
    "Dermsafe Pc",
    "Dexidin 2 Detergent",
    "Dexidin Liq",
    "Diclofenac",
    "Dristan Nasal Mist",
    "Drixoral Decongestant Nasal Spray",
    "Drixoral No Drip Cooling Menthol",
    "Drixoral No Drip Extra Moisturizing",
    "Drixoral No Drip Original Unscented",
    "Dry Eye Tears",
    "Duotrav Pq",
    "Durezol",
    "E-z Scrub 747",
    "Extra Moisturizing Nasal Spray",
    "Sodium Chloride Injection Usp",
    "Soluprep Antiseptic Skin Cleanser Sponge",
    "Soluprep Aq Sponge",
    "Soluprep Aq Swab",
    "Soluprep Aq Wipe",
    "Soluprep Ld Sponge",
    "Soothe Allergy",
    "Soothe Dry Eyes",
    "Soothe Redness",
    "Systane Lubricant Eye Drops",
    "Taro-ciprofloxacin/dexamethasone",
    "Tears Naturale Free",
    "Tears Naturale Ii",
    "Teva-cyclosporine",
    "Tobradex",
    "Tobrex",
    "Travatan Z",
    "Verkazia",
    "Visine For Allergy 3 Symptom Relief",
    "Visine For Allergy With Antihistamine",
    "Visine For Dry Eye Tired Eye Relief",
    "Visine For Red Eye Triple Action",
    "Anti-shine Anthelios Xl Dry Touch Gel-cream",
    "Antibacterial Wipes",
    "Apo-acyclovir Ointment",
    "Apo-ciclopirox",
    "Apo-clobetasol Spray",
    "Applaud Ab Antiseptic Lotionized Hand Soap",
    "Aquagel Defense 50",
    "Aqualia Thermal Uv",
    "Aqualia Thermal Uv Defense Moisturizing Cream Spf30",
    "Aristocort C",
    "Aristocort R",
    "Arthritis Pain Relief",
    "Artistry Exact Fit Beauty Balm Perfecting Primer",
    "Artistry Hydra-v Sheer Weightless Foundation",
    "Artistry Ideal Radiance Illuminating Cc Cream",
    "Artistry Youth Xtend Lifting Smoothing Foundation",
    "Artistry Youth Xtend Protecting Cream",
    "Artistry Youth Xtend Protecting Lotion",
    "Atridox",
    "Bpo5",
    "Bright Boost Moisturizer Spf 30",
    "Broad Spectrum 30 Spf Fps Sunscreen Lotion",
    "Broad Spectrum 50 Spf Fps Sunscreen Lotion",
    "Broad Spectrum Spf 50+ Sunscreen",
    "Broad Spectrum Spf Fps 50",
    "Butterstick",
    "Canesoral Combi 1 Day",
    "Canesten 1 Day Internal Cream",
    "Canesten 3 Day Internal Cream",
    "Canesten 6 Day Internal Cream",
    "Canesten Combi 1 Day Comfortab + External Cream",
    "Canesten Combi 1 Day Internal + External Creams",
    "Canesten Combi 3 Day Comfortab + External Cream",
    "Canesten External Antifungal Cream",
    "Canesten Extra Strength External Antifungal Cream",
    "Caramel Latte Tinted Moisturizer",
    "Cavilon Durable Barrier Cream",
    "Cavilon Moisture Barrier Ointment",
    "Cc Cream Broad Spectrum Spf 30",
    "Clinique Spf 30 Sheer Body Mist",
    "Clinique Spf 30 With Solarsmart+ Oil-free Face Cream",
    "Clinique Spf 50 Face Cream",
    "Clinique Super City Block Oil-free Daily Face Protector Spf 40",
    "Clinique Superbalanced Silk Makeup Spf 15",
    "Clinique Superdefense Daily Defense Moisturizer Spf 20 Combination Oily To Oily",
    "Clinique Superdefense Daily Defense Moisturizer Spf 20 Very Dry To Dry Combination",
    "Clinoleic 20%",
    "Clobex Spray",
    "Clotrimaderm Vaginal 3",
    "Clotrimaderm Vaginal 6",
    "Clotrimaderm-fluconazole Combi-pack",
    "Clotrimazole External Antifungal Cream",
    "Clotrimazole-fluconazole Combi-pack",
    "Colgate Total",
    "Complete Dry Mist Spray Hypoallergenic Uva + Uvb Spf 30",
    "Complete Dry Mist Spray Hypoallergenic Uva + Uvb Spf 60",
    "Complete Sensitive Advanced [80 Minutes] Water/sweat Resistant Lotion Spf 60",
    "Deep Moisture",
    "Deep Pore Acne Vanishing Treatment",
    "Denorex Extra Strength Medicated Shampoo",
    "Denorex Extra Strength Medicated Shampoo With Conditioners",
    "Denticare Pro-freeze",
    "Dermatop Emollient Cream",
    "Dermatop Ointment",
    "Diabetics' Dry Skin Relief Foot Cream",
    "Dial Antibacterial Hydrating Hand Soap",
    "Dial Complete Antibacterial Foaming Hand Wash",
    "Diaper Rash Cream",
    "Diclofenac Sodium Solution",
    "Diclofenac Topical Solution",
    "Dimethicone Protectant",
    "Diprolene",
    "Diprosone Ointment",
    "Dove Derma Plus Care Scalp Anti-dandruff Aloe & Restore",
    "Dove Derma Plus Care Scalp Anti-dandruff Invigorating Mint",
    "Dove Derma Plus Care Scalp Anti-dandruff Invigorating Mint 2 In 1",
    "Dove Derma+care Scalp Anti-dandruff Dryness & Itch Relief",
    "Dove Derma+care Scalp Anti-dandruff Fresh & Clean",
    "Estee Lauder Resilience Lift Firming/sculpting Face And Neck Creme Spf 15 For Normal/combination Skin",
    "Estée Lauder Resilience Multi-effect Tri-peptide Face And Neck Creme Crème Tri-peptide Visage Et Cou Spf/fps 15",
    "Estee Lauder Resilience Multi-effect Tri-peptide Face And Neck Creme Crème Tri-peptide Visage Et Cou Spf/fps 15 Dry Skin Peaux Sèches",
    "Estee Lauder Revitalizing Supreme+ Global Anti-aging Creme Spf 15",
    "Estragyn Vaginal Cream",
    "Eucerin Aquaphor Healing Ointment",
    "Eucrisa",
    "Even Tone Daily Moisturizer",
    "Expert Finish Makeup Broad Spectrum Spf 25",
    "Extra Lasting Cream-to-powder Foundation",
    "Extra Strength Diaper Rash Ointment",
    "Ez Pur Hand Sanitizer",
    "Face & Body Sunscreen Broad Spectrum Spf 30",
    "Face & Neck Multi Action Visage Et Cou Multi Action Day Cream / Crème De Jour Spf 30 / Fps 30",
    "Face And Body Lotion Spf 50",
    "Face Anti-shine Cream",
    "Head & Shoulders Dry Scalp Care",
    "Equate After Sun Gel With Lidocaine",
    "Essential Energy Day Cream",
    "Estrogel",
    "Eurax Cream 10%",
    "Extra Strength Aspercreme Creme Rub 15%",
    "Extra-firming Jour Fps/spf 15",
    "Face And Body Protective Lotion Spf 30",
    "Face Stick Premium Endurance Sunscreen 30",
    "Flagyl",
    "Flamazine Crm 1%",
    "Fleet Enema Mineral Oil",
    "Flexitol Medicated Anti-fungal Cream",
    "Fml 0.1%",
    "Forane",
    "Fs Antimicrobial Hand Cleaner - 2.5% Liq",
    "Fucidin Cream 2%",
    "Fucidin H",
    "Fucidin Ointment 2%",
    "Future Solution Lx Total Protective Cream E",
    "Mannitol Injection Usp",
    "Marcelle/ Oil Free Multi-défense Lotion Spf 15 Fps/ Fluide Multi-défense Sans Huile",
    "Marcelle/multi-defense Cream/crème Multi-défense/spf 15 Fps",
    "Teva-quetiapine Xr",
    "Teva-quinine",
    "Teva-rabeprazole Ec",
    "Teva-ramipril",
    "Teva-rasagiline",
    "Teva-risedronate",
    "Teva-risperidone",
    "Teva-rizatriptan Odt",
    "Teva-ropinirole",
    "Teva-rosuvastatin",
    "Teva-sertraline",
    "Teva-sildenafil",
    "Teva-sildenafil R",
    "Teva-simvastatin",
    "Teva-solifenacin",
    "Teva-spironolactone",
    "Teva-spironolactone/hctz",
    "Teva-sulindac",
    "Teva-sumatriptan",
    "Teva-sumatriptan Df",
    "Teva-tadalafil",
    "Teva-tamoxifen",
    "Teva-tamsulosin Cr",
    "Teva-tecnal",
    "Teva-tecnal C 1/2",
    "Teva-tecnal C 1/4",
    "Teva-telmisartan",
    "Teva-telmisartan Hctz",
    "Teva-tenofovir",
    "Teva-terazosin",
    "Teva-tiaprofenic Acid",
    "Teva-tolterodine",
    "Teva-tolterodine La",
    "Teva-topiramate",
    "Teva-tramadol/acetaminophen",
    "Teva-trandolapril",
    "Teva-trazodone",
    "Teva-triamterene/hctz",
    "Teva-trimel",
    "Teva-trimel Ds",
    "Teva-valacyclovir",
    "Teva-valganciclovir",
    "Teva-valsartan",
    "Teva-valsartan/hctz",
    "Teva-varenicline",
    "Teva-venlafaxine Xr",
    "Teva-voriconazole",
    "Teva-zolmitriptan",
    "Teva-zolmitriptan Od",
    "Teva-zopiclone",
    "Teveten",
    "Teveten Plus",
    "Thalomid",
    "The Magic Bullet",
    "Theo Er",
    "Thyroid Tab 125mg",
    "Thyroid Tab 30mg",
    "Thyroid Tab 60mg",
    "Tiazac",
    "Tiazac Xc",
    "Tibella",
    "Timolol",
    "Tivicay",
    "Tizanidine",
    "Tobi Podhaler",
    "Toctino",
    "Toloxin",
    "Topamax",
    "Topamax 100mg",
    "Topamax 200mg",
    "Topamax 25mg",
    "Topiramate",
    "Topiramate Tablets Usp",
    "Toradol",
    "Total Cold & Flu Combo",
    "Total Cold And Flu",
    "Toviaz",
    "Tracleer",
    "Trajenta",
    "Trandate",
    "Trandolapril",
    "Tranexamic Acid Tablets",
    "Travel Tabs",
    "Travel Tabs 50 Mg",
    "Trazodone",
    "Trazodone-100",
    "Trazodone-150 D",
    "Trazodone-50",
    "Tri-jordyna 21",
    "Tri-jordyna 28",
    "Trianal Tablet",
    "Triatec-30",
    "Triazolam",
    "Tricira Lo",
    "Tridural",
    "Trifluoperazine",
    "Trihexyphenidyl",
    "Trileptal 300 Mg",
    "Trileptal 600 Mg",
    "Trimebutine",
    "Trimethoprim Tablets",
    "Trimipramine",
    "Trintellix",
    "Triumeq",
    "Trosec",
    "Truvada",
    "Tryptan Cap 500mg",
    "Tryptan Tab 250mg",
    "Tryptan Tab 500mg",
    "Tryptan Tab 750mg",
    "Tukysa",
    "Twynsta",
    "Iclusig",
    "Idhifa",
    "Imbruvica",
    "Imdur",
    "Imipramine",
    "Imitrex Df - Tab 100mg",
    "Imitrex Df - Tab 50mg",
    "Imodium Complete",
    "Imodium Liqui-gels",
    "Imodium Quick Dissolve",
    "Imovane",
    "Imunovir",
    "Imuran",
    "Indayo",
    "Inderal-la",
    "Inhibace",
    "Inhibace Plus",
    "Inlyta",
    "Inqovi",
    "Insomnal",
    "Inspra",
    "Intelence",
    "Intuniv Xr",
    "Invega",
    "Invokamet",
    "Invokana",
    "Irbesartan",
    "Irbesartan Hct",
    "Irbesartan-hctz",
    "Irbesartan/hctz",
    "Iressa",
    "Isdn",
    "Isentress",
    "Isentress Hd",
    "Isoptin Sr",
    "Jadenu",
    "Jakavi",
    "Jalyn",
    "Jamp Acetaminophen 325",
    "Jamp Acetaminophen 500",
    "Jamp Acetaminophen Blazon 500",
    "Jamp Candesartan-hct",
    "Jamp Clindamycin",
    "Jamp Diphenhydramine 25 Mg",
    "Jamp Diphenhydramine 50 Mg",
    "Jamp Docusate S Oblong",
    "Jamp Dutasteride",
    "Jamp Emtricitabine/tenofovir Disoproxil Fumarate",
    "Jamp Enalapril",
    "Jamp Entecavir",
    "Jamp Febuxostat",
    "Jamp Fingolimod",
    "Jamp Flecainide",
    "Jamp Frovatriptan",
    "Jamp Granisetron",
    "Jamp Hydroxychloroquine Sulfate",
    "Jamp Nevirapine",
    "Jamp Olanzapine Fc",
    "Jamp Olanzapine Odt",
    "Jamp Oseltamivir",
    "Jamp Perindopril",
    "Jamp Pioglitazone",
    "Jamp Rasagiline",
    "Jamp Rivastigmine",
    "Jamp Zolmitriptan",
    "Jamp-acet-tramadol",
    "Jamp-alendronate",
    "Jamp-allopurinol",
    "Jamp-amitriptyline Tablets",
    "Jamp-amoxicillin",
    "Jamp-anastrozole",
    "Jamp-asa 81mg Ec",
    "Jamp-asa Chew",
    "Jamp-asa Ec",
    "Jamp-atenolol",
    "Jamp-atorvastatin",
    "Jamp-azithromycin",
    "Jamp-bezafibrate Sr",
    "Jamp-bicalutamide",
    "Jamp-bisacodyl",
    "Jamp-candesartan",
    "Jamp-carvedilol",
    "Jamp-celecoxib",
    "Jamp-cetirizine",
    "Jamp-ciprofloxacin",
    "Jamp-clopidogrel",
    "Jamp-colchicine",
    "Jamp-cyclobenzaprine",
    "Jamp-dicyclomine Hcl",
    "Jamp-dimenhydrinate",
    "Jamp-docusate Calcium",
    "Jamp-docusate Sodium",
    "Jamp-domperidone",
    "Jamp-donepezil Tablets",
    "Jamp-doxazosin",
    "Jamp-duloxetine",
    "Jamp-efavirenz",
    "Jamp-escitalopram",
    "Jamp-ezetimibe",
    "Jamp-finasteride",
    "Jamp-fluconazole",
    "Jamp-fluoxetine",
    "Jamp-folic Acid",
    "Jamp-gabapentin",
    "Jamp-gabapentin Tablets",
    "Jamp-hydralazine",
    "Jamp-ibuprofen",
    "Jamp-irbesartan",
    "Jamp-irbesartan And Hydrochlorothiazide",
    "Jamp-lacosamide",
    "Jamp-letrozole",
    "Jamp-levetiracetam",
    "Jamp-losartan",
    "Jamp-losartan Hctz",
    "Jamp-metformin",
    "Jamp-metoprolol-l",
    "Jamp-montelukast",
    "Pms-busulfan",
    "Pms-cytarabine",
    "Pms-dexamethasone Elixir",
    "Pms-dexamethasone Sod Phosphate Inj 10mg/ml",
    "Pms-docusate Sodium",
    "Pms-epirubicin",
    "Pms-iron Sucrose",
    "Pms-lactulose Syr 667mg/ml",
    "Pms-lactulose-pharma",
    "Pms-loperamide Hydrochloride Solution.2mg/ml",
    "Pms-oxybutynin",
    "Pms-prednisolone",
    "Pms-risperidone",
    "Pms-salbutamol",
    "Pms-valproic Acid",
    "Polysporin Eye And Ear Drops Sterile",
    "Polysporin Plus Pain Relief Ear Drops",
    "Polytrim Ophthalmic Solution",
    "Posanol",
    "Posicaine N",
    "Posicaine Sp",
    "Potass Chlor 40meq 5% Dex And 0.9% Sod Chlor",
    "Potassium Chloride For Injection Concentrate Usp",
    "Potassium Chloride In Lactated Ringer's Injection",
    "Potassium Chloride In Sodium Chloride Injection Usp",
    "Potassium Chloride Injection",
    "Potassium Phosphates",
    "Potassium Phosphates Injection, Usp",
    "Praluent",
    "Praxbind",
    "Prepidil Gel",
    "Prevymis",
    "Prezista",
    "Prilocaine Hcl 4% Epineph 1:200000inj",
    "Primene 10%",
    "Primovist",
    "Pro-amox-250",
    "Procainamide Hydrochloride Inj. Usp",
    "Prograf",
    "Prohance - Liq Iv 279.3mg/ml",
    "Prolia",
    "Propofol",
    "Propofol Injection",
    "Propranolol Hydrochloride Injection Usp",
    "Protamine Sulfate Injection Usp",
    "Protamine Sulfate Injection, Usp",
    "Pulmicort Nebuamp 0.125 Mg/ml",
    "Pulmicort Nebuamp 0.25 Mg/ml",
    "Pulmicort Nebuamp 0.5 Mg/ml",
    "Pulmozyme 1mg/ml",
    "Pyridoxine Hydrochloride Injection, Usp",
    "Quelicin",
    "Quinsair",
    "Radicava",
    "Ranitidine Injection Usp",
    "Rapamune",
    "Ratio-docusate Sodium",
    "Ratio-lactulose",
    "Reactine",
    "Reactine Allergy",
    "Regular Strength Bismuth",
    "Relistor",
    "Remodulin",
    "Repatha",
    "Replagal",
    "Retrovir (azt)",
    "Revatio",
    "Ringer's Injection Usp",
    "Risperdal Oral Solution",
    "Rituxan",
    "Rituxan Sc",
    "Riva-dorzolamide/timolol",
    "Riximyo",
    "Robitussin Ac",
    "Acid Concentrate A1269",
    "Acid Concentrate A1271",
    "Acid Concentrate A1274",
    "Acid Concentrate A1275",
    "Acid Concentrate A1279",
    "Acid Concentrate A1294",
    "Acid Concentrate A1296",
    "Acid Concentrate A1297",
    "Bicarbonate Concentrate D17000",
    "Citrasate C0125",
    "Citrasate C1125",
    "Citrasate C2125",
    "Citrasate C2150",
    "Head & Shoulders Dry Scalp Care 2in1",
    "Head & Shoulders Green Apple",
    "Head & Shoulders Green Apple 2in1",
    "Head & Shoulders Instant Cooling Relief",
    "Head & Shoulders Instant Cooling Relief 2in1",
    "Head & Shoulders Instant Cooling Relief Conditioner",
    "Head & Shoulders Instant Oil Control",
    "Head & Shoulders Instant Oil Control 2in1",
    "Head & Shoulders Itchy Scalp Care",
    "Head & Shoulders Itchy Scalp Care 2 In 1",
    "Head & Shoulders Ocean Lift",
    "Head & Shoulders Ocean Lift 2 In 1",
    "Head & Shoulders Purely Gentle Scalp Care",
    "Head & Shoulders Purely Gentle Scalp Care 2in1",
    "Head & Shoulders Smooth & Silky",
    "Head & Shoulders Smooth & Silky 2 In 1",
    "Healthy Defense Daily Moisturizer Spf 45",
    "Healthy Glow All-in-one Tinted Moisturizer Broad Spectrum Spf 25",
    "Healthy Skin Lift & Firm",
    "High Performance Sunscreen Lotion Spf 15",
    "High Performance Sunscreen Spray Spf 15",
    "Liquid Spray Sunscreen",
    "Tykerb",
    "Tylenol Arthritis Pain 8h",
    "Tylenol Complete Cold, Cough & Flu Plus Mucus Relief",
    "Tylenol Extra Strength",
    "Tylenol Extra Strength Caplets",
    "Tylenol Liquid Gels",
    "Tylenol Muscle & Body",
    "Tylenol Rapid Release",
    "Tylenol Regular Strength",
    "Tylenol Regular Strength Caplets",
    "Tylenol Ultra Relief",
    "Uloric",
    "Ultra Headache Relief",
    "Ultra Strength Gas Relief",
    "Ultra Strength Phazyme 180mg Softgels",
    "Unisom",
    "Unisom Sleepgels Extra Strength",
    "Urocit-k",
    "Urso",
    "Urso Ds",
    "Valacyclovir",
    "Valcyte",
    "Valium 5 Tab",
    "Valsartan",
    "Valsartan Hct",
    "Valsartan-hctz",
    "Valtrex",
    "Vancocin",
    "Vancomycin Hydrochloride Capsules, Usp",
    "Vaseretic",
    "Vasotec",
    "Velphoro",
    "Vemlidy",
    "Venclexta",
    "Venlafaxine Xr",
    "Vepesid",
    "Vermox",
    "Verzenio",
    "Vesanoid",
    "Vesicare",
    "Vfend",
    "Viacoram",
    "Viagra",
    "Viberzi",
    "Vicks Dayquil Cold & Flu Multi-symptom Relief Liquicaps",
    "Vicks Dayquil Complete Cold & Flu Caplets",
    "Vicks Dayquil Complete Cold & Flu Liquicaps",
    "Vicks Nyquil Complete Cold & Flu Caplets",
    "Vicks Nyquil Complete Cold & Flu Liquicaps",
    "Vicks Nyquil Liquicaps Cold & Flu Multi-symptom Relief",
    "Viibryd",
    "Vimovo",
    "Vimpat",
    "Viracept",
    "Viracept -250mg",
    "Viread",
    "Visanne",
    "Viskazide",
    "Visken",
    "Vitrakvi",
    "Vizimpro",
    "Vocabria",
    "Volibris",
    "Voltaren",
    "Voltaren Rapide Tablets 50mg",
    "Voltaren Sr",
    "Vosevi",
    "Votrient",
    "Vpi-ondansetron Odt",
    "Vyndaqel",
    "Vyvanse",
    "Wampole Activated Charcoal",
    "Wellbutrin Xl",
    "Winpred",
    "Xalkori",
    "Xanax",
    "Xanax Ts",
    "Xarelto",
    "Xatral",
    "Xeljanz",
    "Xeljanz Xr",
    "Xeloda",
    "Xenical",
    "Xermelo",
    "Xigduo",
    "Xospata",
    "Xtandi",
    "Xylac",
    "Yasmin 21",
    "Yasmin 28",
    "Yaz",
    "Yaz Plus",
    "Yohimbine Tab 5.4mg",
    "Zaditen",
    "Zamine 21",
    "Zamine 28",
    "Zantac",
    "Zantac Maximum Strength Non-prescription",
    "Zarontin Cap 250mg",
    "Zaroxolyn",
    "Zavesca",
    "Zaxine",
    "Zejula",
    "Zelboraf",
    "Zeldox",
    "Zepatier",
    "Zeposia",
    "Zestoretic",
    "Zestril",
    "Ziagen",
    "Zithromax",
    "Zocor",
    "Zofran",
    "Zofran Odt",
    "Zoladex",
    "Zoladex La",
    "Zolinza",
    "Zolmitriptan",
    "Zolmitriptan Odt",
    "Zoloft",
    "Zomig",
    "Zomig Rapimelt",
    "Zopiclone",
    "Jamp-moxifloxacin",
    "Jamp-mycophenolate",
    "Jamp-mycophenolate Capsules",
    "Jamp-olmesartan",
    "Jamp-omeprazole Dr",
    "Jamp-ondansetron",
    "Jamp-oxcarbazepine",
    "Jamp-pantoprazole",
    "Jamp-paroxetine",
    "Jamp-pravastatin",
    "Jamp-pregabalin",
    "Jamp-pyrantel Pamoate",
    "Jamp-quetiapine",
    "Jamp-quinine",
    "Jamp-ramipril",
    "Jamp-ranitidine",
    "Jamp-risedronate",
    "Jamp-risperidone",
    "Jamp-rizatriptan Ir",
    "Jamp-rizatriptan Odt",
    "Jamp-ropinirole",
    "Jamp-rosuvastatin",
    "Jamp-sildenafil",
    "Jamp-simvastatin",
    "Jamp-solifenacin",
    "Jamp-sotalol",
    "Jamp-tadalafil",
    "Jamp-tenofovir",
    "Jamp-topiramate",
    "Jamp-ursodiol",
    "Jamp-valacyclovir",
    "Jamp-vardenafil",
    "Jamp-vardenafil Odt",
    "Jamp-zolmitriptan",
    "Jamp-zolmitriptan Odt",
    "Jamp-zopiclone",
    "Jamp-zopiclone Tablets",
    "Janumet",
    "Janumet Xr",
    "Januvia",
    "Jardiance",
    "Jencycla",
    "Jentadueto",
    "Jinarc",
    "Jorveza",
    "Juluca",
    "Junior Strength Advil",
    "Junior Strength Advil Fever From Colds Or Flu",
    "Junior Strength Allergy Formula",
    "Junior Strength Children's Acetaminophen Tablets",
    "Juxtapid",
    "Kadian",
    "Kaletra",
    "Kalydeco",
    "Kazano",
    "Keppra",
    "Ketoprofen Sr",
    "Ketoprofen-e",
    "Kids Gravol Chewables",
    "Kids Gravol Suppositories",
    "Kisqali",
    "Kivexa",
    "Komboglyze",
    "Kuvan",
    "Kyleena",
    "Lacrisert",
    "Lamictal",
    "Lamisil Tab 250mg",
    "Lamotrigine",
    "Lamotrigine-100",
    "Lamotrigine-150",
    "Lamotrigine-25",
    "Lancora",
    "Lansoprazole",
    "Lanvis",
    "Lasix Special",
    "Latuda",
    "Laxative For Women",
    "Lederle Leucovorin",
    "Leflunomide",
    "Lescol Xl",
    "Letrozole",
    "Leukeran",
    "Levetiracetam",
    "Levetiracetam Tablets",
    "Levitra",
    "Levofloxacin",
    "Librax",
    "Linessa 21",
    "Linessa 28",
    "Lipidil Ez",
    "Lipidil Supra",
    "Lipitor",
    "Lisinopril",
    "Ag-topiramate",
    "Ag-zopiclone",
    "Anandron",
    "Anaprox",
    "Anaprox Ds",
    "Anastrozole",
    "Androcur",
    "Angeliq",
    "Anodan-hc 10mg Suppositories",
    "Anti-nauseant",
    "Anti-nauseant Liquid Gels",
    "Antibacterial Throat Lozenges",
    "Anusol Plus Suppositories",
    "Anusol-hc Suppositories",
    "Apo Dimenhydrinate Tab 50mg",
    "Apo Furosemide Tab 20mg",
    "Apo Furosemide Tab 40mg",
    "Apo Furosemide Tab 80mg",
    "Apo Glyburide Tab 2.5mg",
    "Apo Glyburide Tab 5mg",
    "Apo Ibuprofen Tab 600mg",
    "Apo Oxazepam Tab 10mg",
    "Apo Oxazepam Tab 15mg",
    "Apo Oxazepam Tab 30mg",
    "Apo Piroxicam Cap 10mg",
    "Apo Piroxicam Cap 20mg",
    "Apo Prednisone Tab 50mg",
    "Apo Prednisone Tab 5mg",
    "Apo Triazide",
    "Apo-abacavir",
    "Apo-abacavir-lamivudine",
    "Apo-azithromycin Z",
    "Apo-baclofen",
    "Apo-bicalutamide",
    "Apo-bisacodyl",
    "Apo-bisoprolol",
    "Apo-bromazepam - Tab 3mg",
    "Apo-bromazepam - Tab 6mg",
    "Apo-buspirone - Tab 10mg",
    "Apo-candesartan",
    "Apo-capto Tab 100mg",
    "Apo-capto Tab 12.5mg",
    "Apo-capto Tab 25mg",
    "Apo-capto Tab 50mg",
    "Apo-carvedilol",
    "Apo-cefadroxil",
    "Apo-cefuroxime",
    "Apo-celecoxib",
    "Apo-cephalex",
    "Apo-cetirizine",
    "Apo-cilazapril",
    "Apo-feno-super",
    "Apo-finasteride",
    "Apo-fingolimod",
    "Apo-flecainide",
    "Apo-fluconazole",
    "Apo-fluconazole-150",
    "Apo-fluoxetine",
    "Apo-fluvoxamine Tablets",
    "Apo-fosinopril",
    "Apo-frovatriptan",
    "Apo-gabapentin",
    "Apo-gefitinib",
    "Apo-gliclazide",
    "Apo-gliclazide Mr",
    "Apo-granisetron",
    "Apo-hydralazine",
    "Apo-hydrochlorothiazide",
    "Apo-mirtazapine",
    "Apo-modafinil",
    "Apo-montelukast",
    "Apo-moxifloxacin",
    "Apo-mycophenolate",
    "Apo-mycophenolic Acid",
    "Apo-nadolol",
    "Apo-naltrexone",
    "Apo-napro-na",
    "Apo-napro-na Ds",
    "Apo-naproxen",
    "Apo-naproxen Ec",
    "Apo-naproxen Ec Tablets",
    "Apo-olanzapine",
    "Apo-olanzapine Odt",
    "Apo-rosuvastatin",
    "Apo-selegiline",
    "Apo-sertraline",
    "Apo-sildenafil",
    "Apo-simvastatin",
    "Apo-sotalol - Tab 160mg",
    "Apo-sotalol 80mg Tablets",
    "Apo-sumatriptan",
    "Apo-tadalafil",
    "Apo-tadalafil Pah",
    "Apo-tamox Tab 10mg",
    "Apo-tamox Tab 20mg",
    "Apo-tamsulosin Cr",
    "Apo-tenofovir",
    "Apo-terazosin",
    "Atacand Tab 16 Mg",
    "Atacand Tab 8mg",
    "Atenolol",
    "Ativan",
    "Atomoxetine",
    "Auro-finasteride 1mg",
    "Auro-flecainide",
    "Auro-fluoxetine",
    "Auro-gabapentin",
    "Auro-gabapentin Tablets",
    "Auro-galantamine Er",
    "Auro-lacosamide",
    "Auro-lamivudine/zidovudine",
    "Auro-lamotrigine",
    "Auro-levetiracetam",
    "Auro-lisinopril",
    "Auro-losartan",
    "Auro-telmisartan Hctz",
    "Auro-tenofovir",
    "Auro-terbinafine",
    "Auro-topiramate",
    "Auro-tramadol",
    "Auro-tramadol/acetaminophen",
    "Auro-trandolapril",
    "Auro-valacyclovir",
    "Acid Concentrate D12262",
    "Acid Concentrate D12265",
    "Acid Concentrate D12272",
    "Acid Concentrate D12275",
    "Acid Concentrate D12286",
    "Acid Concentrate D12290",
    "Acid Concentrate D12291",
    "Ag-fluoxetine",
    "Ag-gabapentin",
    "Ag-metoprolol-l",
    "Ag-montelukast",
    "Ag-moxifloxacin",
    "Ag-pantoprazole",
    "Ag-pantoprazole Sodium",
    "Ag-paroxetine",
    "Ag-perindopril",
    "Ag-pravastatin",
    "Zyprexa 15mg",
    "Zyprexa 20mg",
    "Zyprexa Zydis",
    "Zytiga",
    "Zytram Xl",
    "Zzzquil",
    "Activase Rt-pa",
    "Serostim",
    "Bacteriostatic Water For Injection Usp",
    "Nuwiq",
    "Allergenic Extract - Standardized Grass Pollen - Kentucky Blue/june",
    "Allergenic Extract - Standardized Grass Pollen - Meadow Fescue",
    "Allergenic Extract - Standardized Grass Pollen - Orchard",
    "Allergenic Extract - Standardized Grass Pollen - Perennial Rye",
    "Allergenic Extract - Standardized Grass Pollen - Red Top",
    "Allergenic Extract - Standardized Grass Pollen - Sweet Vernal",
    "Allergenic Extract - Standardized Grass Pollen - Timothy",
    "Allergenic Extract - Standardized June Grass Pollen",
    "Allergenic Extract - Standardized Meadow Fescue Grass Pollen",
    "Allergenic Extract - Standardized Mite Dermatophagoides Farinae",
    "Allergenic Extract - Standardized Mite Dermatophagoides Pteronyssinus",
    "Allergenic Extract - Standardized Mite Mix",
    "Allergenic Extracts - 7 Grass Mix",
    "Allergenic Extracts, K-o-r-t Grass Mixture",
    "Allergy Canada Allergen Extract - Alum Precipitated",
    "Antibiotic Drops",
    "Apidra",
    "Avaxim",
    "Basaglar",
    "Bicillin L-a",
    "Calcimar",
    "Center-al",
    "Entuzity Kwikpen",
    "Eprex Sterile Solution",
    "Eprex Sterile Solution 10000iu/1.0ml",
    "Humulin 30/70 Cartridge",
    "Humulin N",
    "Humulin N (cartridge)",
    "Humulin N (kwikpen)",
    "Humulin R",
    "Humulin R (kwikpen)",
    "Humulin R Cartridge",
    "Hyperhep B S/d",
    "Hyperrab",
    "Oxybutynin",
    "Oxyneo",
    "Ozurdex",
    "Painaid Free Acetaminophen Tablets - 500mg",
    "Painaid Pmf Premenstrual Formula",
    "Panectyl Tab 2.5mg",
    "Panectyl Tab 5mg",
    "Pantoloc",
    "Pantoprazole",
    "Pantoprazole Magnesium",
    "Pantoprazole T",
    "Pantoprazole-20",
    "Pantoprazole-40",
    "Pariet, Enteric-coated Tablet 10mg",
    "Pariet, Enteric-coated Tablet 20mg",
    "Parnate",
    "Paroxetine",
    "Paroxetine-10",
    "Paroxetine-20",
    "Paroxetine-30",
    "Parsitan 50mg",
    "Pat-galantamine Er",
    "Paxil Cr",
    "Paxil Tab 10mg",
    "Paxil Tab 20mg",
    "Paxil Tab 30mg",
    "Pdp-amantadine Hydrochloride Capsules",
    "Pdp-benztropine",
    "Pdp-diphenhydramine",
    "Pdp-diphenhydramine Extra Strength/ Extra Fort",
    "Pdp-isoniazid",
    "Pdp-pyrazinamide",
    "Pen-vk",
    "Pentoxifylline Sr",
    "Pepcid Ac",
    "Pepcid Complete",
    "Pepto Bismol Caplet - 262mg/caplet",
    "Pepto-bismol Chewables",
    "Pepto-bismol With Instacool",
    "Perindopril Erbumine",
    "Periostat",
    "Perphenazine",
    "Pharma-amlodipine",
    "Pharma-lacosamide",
    "Pharma-ramipril",
    "Pharma-simvastatin",
    "Phenobarb",
    "Pifeltro",
    "Pimozide",
    "Piqray",
    "Plan B",
    "Plaquenil",
    "Plavix",
    "Plendil 10 Mg",
    "Plendil 2.5 Mg",
    "Plendil 5 Mg",
    "Pms Dexamethasone Tab 0.5mg Usp",
    "Pms Dexamethasone Tab 0.75mg Usp",
    "Pms Dexamethasone Tab 4mg",
    "Pms Midol Complete",
    "Pms Trazodone Hcl Tab 100mg",
    "Pms Trazodone Hcl Tab 50mg",
    "Pms-abacavir-lamivudine",
    "Pms-abiraterone",
    "Pms-alendronate-fc",
    "Pms-amiodarone",
    "Pms-amitriptyline",
    "Pms-amlodipine",
    "Pms-amoxicillin",
    "Pms-amphetamines Xr",
    "Pms-anagrelide",
    "Pms-anastrozole",
    "Pms-aripiprazole",
    "Pms-atenolol",
    "Pms-atomoxetine",
    "Pms-atorvastatin",
    "Pms-azithromycin",
    "Pms-baclofen",
    "Pms-baclofen Tab 20mg",
    "Pms-betahistine",
    "Pms-bicalutamide",
    "Pms-bosentan",
    "Pms-buprenorphine-naloxone",
    "Pms-buspirone",
    "Pms-candesartan",
    "Pms-candesartan Hctz",
    "Pms-carbamazepine-cr",
    "Pms-carvedilol",
    "Pms-celecoxib",
    "Pms-cetirizine",
    "Pms-ciprofloxacin",
    "Pms-ciprofloxacin Xl",
    "Pms-citalopram",
    "Pms-clarithromycin",
    "Pms-clonazepam Tab 0.5mg",
    "Pms-clonazepam Tab 1.0mg",
    "Pms-clonazepam Tab 2mg",
    "Pms-clonazepam- Tab 0.25mg",
    "Pms-clonazepam-r",
    "Pms-clopidogrel",
    "Pms-colchicine",
    "Pms-cyclobenzaprine - Tab 10mg",
    "Pms-deferasirox",
    "Pms-desmopressin",
    "Pms-dexamethasone",
    "Pms-diclofenac",
    "Pms-diclofenac K",
    "Pms-diclofenac-sr",
    "Pms-domperidone",
    "Pms-donepezil",
    "Pms-doxylamine-pyridoxine",
    "Pms-duloxetine",
    "Pms-efavirenz-emtricitabine-tenofovir",
    "Pms-emtricitabine-tenofovir",
    "Auro-citalopram",
    "Auro-clindamycin",
    "Auro-clopidogrel",
    "Auro-cyclobenzaprine",
    "Auro-darunavir",
    "Auro-donepezil",
    "Auro-duloxetine",
    "Auro-dutasteride",
    "Auro-efavirenz",
    "Auro-efavirenz-emtricitabine-tenofovir",
    "Auro-eletriptan",
    "Auro-entecavir",
    "Auro-escitalopram",
    "Auro-ezetimibe",
    "M-venlafaxine Xr",
    "M-zopiclone",
    "Macrobid",
    "Malarone",
    "Malarone Pediatric",
    "Manerix",
    "Mar-acarbose",
    "Mar-allopurinol",
    "Mar-amitriptyline",
    "Mar-amlodipine Tablets",
    "Mar-anastrozole",
    "Mar-atenolol",
    "Mar-atorvastatin",
    "Mar-ranitidine",
    "Mar-risperidone",
    "Mar-rizatriptan",
    "Mar-rizatriptan Odt",
    "Mar-sertraline",
    "Mar-sildenafil",
    "Mar-simvastatin",
    "Mar-tadalafil",
    "Mar-tramadol",
    "Mar-tramadol/acet",
    "Mar-tranexamic Acid",
    "Mar-trientine",
    "Mar-trospium",
    "Mar-zopiclone",
    "Marvelon 21",
    "Marvelon 28",
    "Matulane",
    "Mint-anastrozole",
    "Mint-aripiprazole",
    "Mint-atenol",
    "Mint-atorvastatin",
    "Mint-bisoprolol",
    "Mint-candesartan",
    "Mint-celecoxib",
    "Mint-cetirizine",
    "Mint-ciproflox",
    "Mint-citalopram",
    "Mint-clonidine",
    "Mint-donepezil",
    "Mint-duloxetine",
    "Mint-spironolactone",
    "Mint-tadalafil",
    "Mint-telmisartan",
    "Mint-tolterodine",
    "Mint-topiramate",
    "Mint-tramadol/acet",
    "Mint-valganciclovir",
    "Mint-zolmitriptan",
    "Mint-zopiclone",
    "Mirapex",
    "Mirena",
    "Mirtazapine",
    "Moclobemide",
    "Mogadon",
    "Monistat 1 Vaginal Ovule",
    "Monistat 3 Vaginal Ovules",
    "Montelukast",
    "Mylan-efavirenz/emtricitabine/tenofovir Disoproxil Fumarate",
    "Mylan-emtricitabine/tenofovir Disoproxil",
    "Mylan-escitalopram",
    "Mylan-fingolimod",
    "Mylan-fluconazole",
    "Mylan-galantamine Er",
    "Mylan-gliclazide Mr",
    "Mylan-hydroxyurea",
    "Mylan-indapamide",
    "Mylan-lamotrigine",
    "Mylan-lansoprazole",
    "Mylan-mirtazapine",
    "Mylan-naproxen/esomeprazole Mr",
    "Mylan-nevirapine",
    "Nat-levetiracetam",
    "Nat-omeprazole Dr",
    "Nat-ondansetron",
    "Nat-oseltamivir",
    "Mylan-valacyclovir",
    "Mylan-vardenafil",
    "Pms-fluoxetine",
    "Pms-fluoxetine - Cap 10mg",
    "Pms-fluoxetine - Cap 20mg",
    "Pms-gabapentin",
    "Pms-galantamine Er",
    "Pms-hydrochlorothiazide",
    "Pms-hydromorphone Tab 1mg",
    "Pms-hydromorphone Tab 2mg",
    "Pms-hydromorphone Tab 4mg",
    "Pms-hydromorphone Tab 8mg",
    "Pms-imatinib",
    "Pms-irbesartan",
    "Pms-irbesartan-hctz",
    "Pms-ismn",
    "Pms-lamotrigine",
    "Pms-rabeprazole Ec",
    "Pms-ramipril-hctz",
    "Pms-ranitidine 150 Mg",
    "Pms-ranitidine 300 Mg",
    "Pms-risedronate",
    "Pms-rizatriptan Rdt",
    "Pms-rosuvastatin",
    "Pms-sertraline",
    "Pms-sildenafil R",
    "Pms-simvastatin",
    "Pregvit Folic 5",
    "Premarin",
    "Premium Activated Charcoal Usp",
    "Prevacid",
    "Prevacid Fastab",
    "Prezcobix",
    "Primaquine",
    "Primidone",
    "Pristiq",
    "Priva-amitriptyline",
    "Priva-sertraline",
    "Priva-sildenafil",
    "Priva-simvastatin",
    "Priva-tadalafil",
    "Priva-zopiclone",
    "Pro-aas - 80 (croquable)",
    "Pro-aas Ec - 80",
    "Pro-amiodarone - 200",
    "Pro-amox-500",
    "Pro-azithromycine",
    "Pro-bicalutamide - 50",
    "Pro-bisoprolol - 10",
    "Pro-bisoprolol - 5",
    "Pro-cefadroxil - 500",
    "Pro-cefuroxime - 500",
    "Pro-ciprofloxacin",
    "Pro-clonazepam",
    "Pro-enalapril - 10",
    "Pro-enalapril - 2.5",
    "Quetiapine",
    "Infanrix-hexa",
    "Influvac Tetra",
    "Isolyte S Ph 7.4 (multi-electrolyte Injection)",
    "Ixiaro",
    "Jamp Latanoprost",
    "Jamp-latanoprost/timolol",
    "Latanoprost Ophthalmic Solution",
    "Lignospan Forte",
    "Pegasys",
    "Pfizer-biontech Covid-19 Vaccine",
    "Phenylephrine Hydrochloride Injection",
    "Plegridy",
    "Pms-ipratropium",
    "Pneumovax 23",
    "Precedex",
    "Prevnar 13",
    "Prostin Vr Sterile Solution",
    "Rebif",
    "Teva-ipratropium Sterinebs",
    "Teva-latanoprost",
    "Teva-teriparatide Injection",
    "Trumenba",
    "Typhim Vi",
    "Uvadex",
    "Vitamin B12",
    "Xalacom",
    "Xalatan",
    "Xylocaine 1% W Epinephrine 1:200000",
    "Xylocaine 2% W Epinephrine 1:200000",
    "Blincyto",
    "Caverject Sterile Powder",
    "Caverject Sterile Powder - Pws 23.2mcg/vial",
    "Gonal-f",
    "Hymenoptera Venom Product - Honey Bee Venom (550 Mcg)",
    "Hymenoptera Venom Product - Yellow Jacket Venom Protein (550 Mcg)",
    "Fentora",
    "Foradil Dry Powder Capsules For Inhalation",
    "Gd-diclofenac/misoprostol 50",
    "Gd-diclofenac/misoprostol 75",
    "Loestrin 1.5/30",
    "Lolo",
    "Mifegymiso",
    "Min-ovral 21",
    "Min-ovral 28",
    "Minestrin 1/20",
    "Misoprostol",
    "Muse",
    "Nocdurna",
    "Onbrez Breezhaler",
    "One Alpha Caps 0.25mcg",
    "Migranal Nasal Spray 4mg/ml",
    "Mylan-nitro Sublingual Spray",
    "Nitrolingual Pumpspray",
    "Ozempic",
    "Relenza",
    "Rho-nitro Pumpspray",
    "Sativex",
    "Spravato",
    "Zomig Nasal Spray",
    "Aridol",
    "Ratio-tamsulosin",
    "Baqsimi",
    "Bydureon",
    "Lenvima",
    "Apo-divalproex",
    "Alka-seltzer",
    "Xylonor",
    "Xylonor Gel",
    "Androderm",
    "Exelon Patch 10",
    "Exelon Patch 15",
    "Exelon Patch 5",
    "Minitran",
    "Mylan-nitro Patch 0.2",
    "Mylan-nitro Patch 0.4",
    "Mylan-nitro Patch 0.6",
    "Mylan-nitro Patch 0.8",
    "Mylan-rivastigmine Patch 10",
    "Mylan-rivastigmine Patch 5",
    "Phenylephrine Hydrochloride Injection Usp",
    "Phenylephrine Hydrochloride Injection Usp 1%",
    "Phenytoin Sodium Injection Usp",
    "Phenytoin Sodium Injection, Usp",
    "Phosphate De Potassium Monobasic Inj 176mg/ml",
    "Plasbumin-5",
    "Plasma-lyte A Injection",
    "Pms Hydromorphone Sirop 1mg/ml",
    "Pms-acetaminophen With Codeine Elixir",
    "Ultra Strength Pain Relief Rub",
    "Ultra Sun Protection Cream",
    "Ultra Sun Protection Lotion",
    "Ultra Sun Protection Lotion Ti",
    "Ultra Sun Protection Spray",
    "Ultra Sun Protector Cream Crème Solaire Ultra Protection 50+",
    "Ultra Sun Protector Lotion Lait Solaire Ultra Protection 50+",
    "Ultra-light Lotion Spf 50",
    "Ultra-rich Hydration",
    "Ultravate",
    "Universal Defense E",
    "Unseen Sunscreen",
    "Urban Environment Oil-free Uv Protector",
    "Urban Environment Tinted Uv Protector",
    "Urban Environment Uv Protection Cream",
    "Urban Skin Defence",
    "Uv Daily Tinted",
    "Uv Essential Multi Protection",
    "Uv Lip Color Splash",
    "Uv Protective Compact Foundation (refill)",
    "Uv Protective Stick Foundation",
    "Vanilla Latte Tinted Moisturizer",
    "Vaniqa",
    "Veregen",
    "Vinda Antibacterial Wipes",
    "Vioform Hydrocortisone",
    "Vita Lift Spf 15 Daily Moisturizer",
    "Vitamin C Glow-protect Lotion Spf 30",
    "Vitamin E Moisture-protect Lip Care",
    "Voltaren Emulgel Back & Muscle Pain",
    "Voltaren Emulgel Joint Pain Extra Strength",
    "Voltaren Emulgel Joint Pain Regular Strength",
    "Volu-firm Day Cream Sunscreen Broad Spectrum Spf 30",
    "Volu-firm Day Cream With Spf 30",
    "Vyloma",
    "Wet Ones",
    "Wet Skin Kids",
    "Women's Rogaine Foam 5%",
    "X3 Clean Germ Attack Hand Sanitizer",
    "X3 On-the-go Antiseptic Spray",
    "Xerese",
    "Zensa",
    "Zero Fresh Breath",
    "Zero Healthy Gums",
    "Zovirax",
    "Zyclara",
    "0.9% Sodium Chloride Injection Usp",
    "60 Spf Stick Protection Ciblee Uva Uvb Anthelios Xl",
    "Abreva",
    "Absolue Hand Spf 15",
    "Absorbine Jr Extra Strength Liniment",
    "Absorbine Jr Liniment",
    "Acclaim Ab",
    "Acular Liq 0.5%",
    "Acular Ls",
    "Adaptasun Sun Care Lotion Sea And Tropics Body / Lait De Soin Solaire Mer Et Tropiques Corps Spf/fps 35",
    "Adasept B.p.5 Acne Gel",
    "Afterburn",
    "Air Usp",
    "Albumin (human) 25% Solution Usp",
    "Alburex - 25",
    "Alburex - 5",
    "Aldara P",
    "Alexander's Rash Ease - For Babies",
    "Alexander's Rash Ease For Adults",
    "Alnox Gas",
    "Alphagan",
    "Alphagan P",
    "Amo Endosol Solution",
    "Androgel",
    "Anew Hydra Fusion Daily Beauty Defense",
    "Anodan-hc Ointment",
    "Anti-bac - Asp 0.5%",
    "Anti-bac Foam Soap",
    "Anti-itch Cream",
    "Anti-microbe",
    "Antibacterial Clean & Smooth",
    "Antibacterial Lotion Soap",
    "Antiseptic Body Cleanser",
    "Antiseptic Hand Soap",
    "Antiseptic Hand Soap Liq 0.3%",
    "Antiseptic Oral Rinse",
    "Anugesic-hc Ointment",
    "Anusol Plus Ointment",
    "Anusol-hc Ointment",
    "Apo-brimonidine",
    "Apo-gatifloxacin",
    "Apo-olopatadine",
    "Apo-timop",
    "Aqua Soleil Crème Visage Et Corps Fps 35",
    "Atropine",
    "Avagard Chg",
    "Aveeno Anti-itch Lotion",
    "Avon Moisture Shield-tinted Spf 15 Crm",
    "Baby Mineral Sunscreen Lotion",
    "Bacteriostatic Water For Injection Usp-pre-filled Syringe",
    "Balminil Decongest",
    "Banana Boat Kids Free Continuous Spray Sunscreen Spf 50+",
    "Banana Boat Suncomfort Sunscreen Lotion Spf 30",
    "Banana Boat Suncomfort Sunscreen Lotion Spf 50+",
    "Band-aid Brand Antiseptic Wash",
    "Barriere Cream 20%",
    "Baxedin 2% - 70%",
    "Baxedin Liq 20%",
    "Baxedin Pre-op",
    "Beauty Balm Instant Solutions Broad Spectrum Spf 35",
    "Beauty Booster Cream Spf 30",
    "Beauty Booster Lip Gloss Spf 15",
    "Bébé Healing Ointment",
    "Benadryl Cream 2%",
    "Benadryl Itch Stopping Cream",
    "Benadryl Spray",
    "Benefiance Wrinkle Smoothing Day Cream",
    "Benzac W Wash Gel 10%",
    "Benzaclin Topical Gel",
    "Benzagel 5 Gel",
    "Benzagel 5 Wash",
    "Benzoyl Peroxide Acne Treatment 5%",
    "Pms-letrozole",
    "Pms-lithium Carbonate - Cap 150mg",
    "Pms-lithium Carbonate - Cap 300mg",
    "Pms-lithium Carbonate - Cap 600mg",
    "Pms-loperamide - Caplet 2mg",
    "Pms-lorazepam Tab 0.5mg",
    "Pms-lorazepam Tab 1mg",
    "Pms-lorazepam Tab 2mg",
    "Pms-losartan",
    "Pms-losartan-hctz",
    "Pms-meloxicam",
    "Pms-memantine",
    "Pms-metformin",
    "Pms-metformin - Tab 500mg",
    "Pms-methotrexate",
    "Pms-methylphenidate",
    "Pms-metoprolol-l",
    "Pms-mirtazapine",
    "Pms-montelukast",
    "Pms-solifenacin",
    "Pms-sotalol - 160 Mg",
    "Pms-sotalol - 80 Mg",
    "Pms-sulfasalazine 500mg/tab Usp",
    "Pms-sulfasalazine-e.c. Tab 500mg",
    "Pms-sumatriptan",
    "Pms-tadalafil",
    "Apo-amoxi",
    "Apo-amoxi Clav",
    "Apo-amphetamine Xr",
    "Apo-anastrozole",
    "Apo-aripiprazole",
    "Apo-atenol Tab 100mg",
    "Apo-atenol Tab 50mg",
    "Apo-atomoxetine",
    "Apo-atorvastatin",
    "Apo-azathioprine",
    "Apo-cilazapril/hctz",
    "Apo-cinacalcet",
    "Apo-citalopram",
    "Apo-clarithromycin",
    "Apo-clarithromycin Xl",
    "Apo-clobazam",
    "Apo-clonazepam - Tab 0.5mg",
    "Apo-clonazepam - Tab 2mg",
    "Apo-clopidogrel",
    "Apo-colesevelam",
    "Apo-cyclobenzaprine",
    "Apo-dabigatran",
    "Apo-darunavir",
    "Apo-dasatinib",
    "Apo-deferasirox",
    "Apo-deferasirox (type J)",
    "Apo-desvenlafaxine",
    "Apo-dexamethasone",
    "Apo-diclo",
    "Apo-diclo Sr",
    "Apo-diltiaz Cd",
    "Apo-dipyridamole-fc Tab 25mg",
    "Apo-dipyridamole-fc Tab 50mg",
    "Apo-docusate Sodium",
    "Apo-domperidone - Tab 10mg",
    "Apo-donepezil",
    "Apo-doxy Cap 100mg",
    "Apo-doxy Tabs 100mg",
    "Apo-doxylamine/b6",
    "Apo-duloxetine",
    "Apo-dutasteride",
    "Apo-efavirenz-emtricitabine-tenofovir",
    "Apo-eletriptan",
    "Apo-emtricitabine-tenofovir",
    "Apo-enalapril Tab 10mg",
    "Apo-enalapril Tab 2.5mg",
    "Apo-enalapril Tab 20mg",
    "Apo-enalapril Tab 5mg",
    "Apo-entecavir",
    "Apo-erlotinib",
    "Apo-escitalopram",
    "Apo-esomeprazole",
    "Apo-ezetimibe",
    "Apo-famciclovir",
    "Apo-felodipine",
    "Apo-hydromorphone",
    "Apo-hydromorphone Cr",
    "Apo-hydroxyquine",
    "Apo-hydroxyurea",
    "Apo-ibuprofen",
    "Apo-imatinib",
    "Apo-indapamide 1.25 Mg Tablets",
    "Apo-indapamide 2.5mg Tablets",
    "Apo-ismn",
    "Apo-ketoconazole",
    "Apo-ketorolac",
    "Apo-labetalol",
    "Apo-lamivudine",
    "Apo-lamivudine Hbv",
    "Apo-lamivudine-zidovudine",
    "Apo-lamotrigine",
    "Apo-lansoprazole",
    "Apo-leflunomide",
    "Apo-letrozole",
    "Apo-levetiracetam",
    "Apo-levocarb - Tab 10mg/100mg",
    "Apo-levocarb - Tab 25mg/250mg",
    "Apo-levocarb-tab 25mg/100mg",
    "Apo-levofloxacin",
    "Apo-linezolid",
    "Apo-lisinopril Tablet 10 Mg",
    "Apo-lisinopril Tablet 20 Mg",
    "Apo-lisinopril Tablet 5 Mg",
    "Apo-lithium Carbonate",
    "Apo-loratadine",
    "Apo-lorazepam Tab 0.5mg",
    "Apo-lorazepam Tab 1mg",
    "Apo-lorazepam Tab 2mg",
    "Pregabalin",
    "Pregvit",
    "Priva-amlodipine",
    "Priva-atorvastatin",
    "Priva-celecoxib",
    "Priva-cetirizine",
    "Priva-cinacalcet",
    "Priva-ciprofloxacin",
    "Priva-citalopram",
    "Priva-clopidogrel",
    "Priva-domperidone",
    "Priva-donepezil",
    "Priva-duloxetine",
    "Priva-dutasteride",
    "Priva-escitalopram",
    "Priva-ezetimibe",
    "Priva-fluoxetine",
    "Priva-gabapentin",
    "Priva-losartan",
    "Priva-montelukast",
    "Priva-omeprazole",
    "Priva-pantoprazole",
    "Priva-paroxetine",
    "Priva-perindopril Erbumine",
    "Priva-pravastatin",
    "Priva-quetiapine",
    "Priva-ramipril",
    "Priva-rosuvastatin",
    "Pro-enalapril - 20",
    "Pro-enalapril - 5",
    "Pro-fluconazole",
    "Pro-fluoxetine",
    "Pro-gabapentin",
    "Pro-ismn - 60",
    "Pro-levetiracetam - 250",
    "Pro-levetiracetam - 500",
    "Pro-levetiracetam - 750",
    "Pro-levocarb - 100/25",
    "Pro-lisinopril - 10",
    "Pro-lisinopril - 20",
    "Pro-lisinopril - 5",
    "Pro-lorazepam",
    "Pro-lorazepam Tab 1.0mg",
    "Pro-lorazepam Tab 2mg",
    "Pro-metformin",
    "Pro-mirtazapine",
    "Pro-naproxen Ec",
    "Pro-pioglitazone",
    "Pro-quetiapine",
    "Pro-quinine - 200",
    "Pro-quinine - 300",
    "Pro-rabeprazole",
    "Pro-ramipril - 1.25",
    "Pro-ramipril - 10",
    "Pro-ramipril - 2.5",
    "Pro-ramipril - 5",
    "Pro-risperidone",
    "Pro-topiramate",
    "Pro-valacyclovir",
    "Pro-zopiclone",
    "Probuphine",
    "Prochlorazine",
    "Proctodan-hc Suppositories",
    "Proctol Suppositories",
    "Procysbi",
    "Procytox Tab 25mg",
    "Procytox Tab 50mg",
    "Proglycem",
    "Prolopa Cap 100-25",
    "Prolopa Cap 200-50",
    "Prolopa Cap 50-12.5",
    "Prometrium",
    "Propafenone",
    "Propecia",
    "Proscar",
    "Prostin E2 Tablets",
    "Provera 10mg Tablets",
    "Provera 2.5mg Tablets",
    "Provera 5mg Tablets",
    "Prozac Capsules 10mg",
    "Prozac Capsules 20mg",
    "Prz-domperidone",
    "Prz-sildenafil",
    "Prz-solifenacin",
    "Purinethol",
    "Pyridium 100mg",
    "Qinlock",
    "Quetiapine Tablets",
    "Quetiapine Xr",
    "Lise Watier Cc Creme Fps 25 Spf",
    "Loprox",
    "Lotemax Gel",
    "Lotemax Ointment",
    "Lotion Écran Solaire 30",
    "Lotion Solaire Anti-âge",
    "Lyracaine Gel",
    "M-peg 3350",
    "M.a.c Prep + Prime Face Protect Lotion Spf 50",
    "M.a.c Studio Fix Fluid Spf 15",
    "M.a.c. Studio Waterweight Spf 30 Foundation",
    "Mac Studio Sculpt Spf 15 Foundation",
    "Magix Face Perfector",
    "Makeup Setting Spray Pulvérisation Pour Fixer Le Maquillage",
    "Marcelle City High Protection Urban Day Cream Soin Jour Haute Protection Urbaine Spf 30 Fps",
    "Marcelle City Tinted Cream Crème Tintée Multi-protection Spf 25 Fps",
    "Marcelle Flawless Air Serum Foundation Sérum De Teint Peau Parfaite Spf 15 Fps",
    "Marcelle Revival+ Skin Renewal Anti-aging Day Cream Spf 15",
    "Marcelle Sheer Tint Moisturizer Hydratant Teinté Translucide Spf 30 Fps",
    "Olay Total Effects 7-in-1 Anti-aging Moisturizer With Sunscreen Broad Spectrum Spf 30",
    "Olay Total Effects 7in1 Featherweight Moisturizer With Sunscreen",
    "Olay Total Effects Whip",
    "Olay Uv Moisturizing Cream",
    "Ombrelle Kids Lotion Wet'n Protect",
    "Onreltea",
    "Origins A Perfect World Spf 40 Age-defense Moisturizer With White Tea",
    "Refreshing Day Cream",
    "Rénergie Lift",
    "Rénergie Lift Makeup",
    "Renergie Lift Multi-action Spf 15 Firming Moisturizing Cream All Skin Types",
    "Rénergie Lift Multi-action Ultra",
    "Rénergie Lift Multi-action Ultra Spf30",
    "Renewed Hope In A Jar Spf 30",
    "Repairing Treatment",
    "Restoralax",
    "Resultz",
    "Retin-a",
    "Retin-a Micro",
    "Reversa Crème Anti-rides Contour Des Yeux Fps 15",
    "Reversa Creme Fps30",
    "Reversa Crème Radiance Fps 30",
    "Revitalift Anti-wrinkle + Firming Day Cream",
    "Revitalift Triple Power Lzr Day Lotion",
    "Rhinaris Nasal Mist",
    "Rodan + Fields Essentials Face + Body Sunscreen",
    "Rodan + Fields Redefine Triple Defense Cream",
    "Spf 30 Fps Sunscreen Lotion Lotion Écran Solaire",
    "Spf 30 Ideal Soleil Lip Protection Stick",
    "Spf 30 Kids Wet'n Protect",
    "Spf 30 Sport Endurance",
    "Spf 30 Ultra Light Advanced Weightless Body Lotion",
    "Spf 30 Ultra Light Advanced Weightless Face Lotion",
    "Spf 30 Wrinkle Reducing Cream",
    "Spf 50 Broad Spectrum Kids",
    "Spf 50 Classic Face Sport Coola Classic Sunscreen White Tea Moisturizer",
    "Spf 50 Face Cream",
    "Spf 50+ Fps Ultra",
    "Spf 50+ Fps Ultra Lotion",
    "Spf 50+ Ultra Light Advanced Weightless Body Lotion",
    "Spf 60 Anthelios Xl Lotion",
    "Spf 60 Kids Wet'n Protect",
    "Sunscreen Continuous Spray Spf/fps 30",
    "Sunscreen Continuous Spray Spf/fps 60",
    "Sunscreen Cream Spf60",
    "Sunscreen Face Lotion",
    "Sunscreen Family Spf 30",
    "Sunscreen Family Spf 50+",
    "Sunscreen Kids Spf 50+",
    "Sunscreen Lip Balm",
    "Sunscreen Lotion 30 Spf/fps Sport",
    "Sunscreen Lotion Ecran Solaire Spf/fps 30",
    "Sunscreen Lotion Ecran Solaire Spf/fps 50+",
    "Sunscreen Lotion Spf/fps 60",
    "Sunscreen Oil Spray",
    "Sunscreen Sport Spf 30",
    "Sunscreen Sport Spf 50+",
    "Sunscreen Stick Écran Solaire En Bâtonnet With Aloe Vera/avec Aloès",
    "Theratears Lubricant Eye Drops",
    "Timeless Illuminating Makeup Broad Spectrum Spf 30",
    "Timewise Day Solution Sunscreen Spf 35",
    "Tinactin",
    "Tinactin Aerosol Powder",
    "Tinactin Chill Deodorant Powder Spray",
    "Tinactin Powder",
    "Tolak",
    "Toleriane Sensitive Crème Uv",
    "Topical Hapten Gel",
    "Topical Hapten Liquid",
    "Total Defense + Repair Broad Spectrum Spf 34 Sunscreen",
    "Total Defense + Repair Broad Spectrum Spf 34 Sunscreen Tinted",
    "Total Defense + Repair Broad Spectrum Spf 50+ Sunscreen",
    "Tpr20",
    "Triple Age Repair Moisturizer",
    "Triple Defense Treatment",
    "Triple Protect Face Lotion Spf 20",
    "True Match Lumi",
    "Cleansing Nettoyant Dandruff Pyrithione Zinc Shampoo",
    "Clear Cell Medicated Acne Lotion",
    "Citrasate C3125",
    "Citrasate C3150",
    "Citrasate C4125",
    "Extraneal",
    "Golytely Gi Lavage Solution",
    "H.e.l.p. Acetate Buffer Ph 4.85",
    "H.e.l.p. Naci 0.9%",
    "H.e.l.p.bicel",
    "Hemosate Ultra Hs1125",
    "Naturalyte H-615",
    "Naturalyte H-616",
    "Naturalyte H-617",
    "Naturalyte H-623",
    "Naturalyte H-624",
    "Crème Hydra Finish Cream Crème Hydratation Révélatrice De Teint Fps 15 Large Spectre Visage Moisturizing Complexion Enhacing Cream Spf 15 Broad Spectrum Face",
    "Future Solution Lx Total Protective Emulsion E",
    "Fuzion Ab Foaming Hand Soap",
    "Gamastan",
    "Gamastan S/d",
    "Gammagard Liquid",
    "Gaseous Nitrogen 99.0%",
    "Gastrografin - Liq Orl",
    "Gentle Fresh Defense",
    "Gentle Fresh Sanitizer",
    "Germi Stat Gel 2%",
    "Germi-stat Prep Gel",
    "Germicidal Hand Soap Liq 0.6%",
    "Glycerinated Phenol Saline",
    "Gojo Antibacterial Luxury Foam Handwash",
    "Gojo E2 Foam Sanitizing Soap",
    "Gojo Premium Foam Antibacterial Handwash",
    "Green Apple Pomme Verte Dandruff Pyrithione Zinc Shampoo",
    "Green Apple Pomme Verte Dandruff Pyrithione Zinc Shampoo & Conditioner",
    "Gum Paroex",
    "Hand Sanitizing Wipes",
    "Haute Exigence Jour Spf 20 Multi-intensive",
    "Hawaiian Tropic Oil Spray Moisturizing Sunscreen Spf 4",
    "Hawaiian Tropic Silk Hydration Weghtless Face",
    "Nix Dermal Cream",
    "Nizoral",
    "No Odour Pain Relief Cream",
    "Nyda",
    "Octalbin 25%",
    "Octalbin 5%",
    "Ocuflox",
    "Odans Liquor Carbonis Detergens",
    "Oil And Pore Control Mattifier Broad Spectrum Spf 45",
    "Olay Complete Uv365* Daily Moisturizing Cream With Sunscreen Broad Spectrum Spf 15 Normal",
    "Olay Complete Uv365* Daily Moisturizing Lotion With Sunscreen Broad Spectrum Spf 15 Combination/oily",
    "Olay Complete Uv365* Daily Moisturizing Lotion With Sunscreen Broad Spectrum Spf 15 Normal",
    "Olay Complete Uv365* Daily Moisturizing Lotion With Sunscreen Broad Spectrum Spf 30 Sensitive",
    "Olay Total Effects 7 In One Tone Correcting Moisturizer With Sunscreen",
    "Olay Total Effects 7in1 Anti-aging Moisturizer With Sunscreen Broad Spectrum Spf 15",
    "Ombrelle - Lotion Extreme Spf 30",
    "Ombrelle Cream Spf 60",
    "Ombrelle L'oreal Suncare Research Kids (spf 30)",
    "Privigen",
    "Proclearz Antifungal Liquid",
    "Proctodan-hc Ointment",
    "Proctofoam Hc",
    "Proctol Ointment",
    "Proctosedyl",
    "Protective Moisturizer Broad Spectrum Spf 30 Sunscreen",
    "Provon Antiseptic Lotion Soap With 2% Chg",
    "Provon Medicated Foam Handwash With Advanced Moisturizers",
    "Provon Medicated Lotion Soap With Triclosan",
    "Psoriasin Gel",
    "Psoriasin Ointment",
    "Pur Confort Fps 15 Spf",
    "Purell Sanitizing Wipes",
    "Purell Sf607 Foam Hand Rub",
    "Pyrithione Zinc Dandruff Shampoo Classic Clean",
    "Qfs Antimicrobial Hand Soap With Triclosan",
    "R & C Shampoo With Conditioner",
    "Ratio-amcinonide",
    "Red Currant Protective Moisturizer Spf 30",
    "Redermic [c] Uv - Spf 25",
    "Clinimix E",
    "Clolar",
    "Clopixol Depot 200mg/ml",
    "Dexamethasone Sodium Phosphate Injection, Usp",
    "Dexamethasone-omega",
    "Dextrose 0.2% And 0.9% Sod Chlor Solution",
    "Dextrose 10% And 0.9% Sod Chloride Inj",
    "Dextrose 3.3% And 0.3% Sod Chloride Inj",
    "Dextrose 5% And 0.2% Sod Chloride Inj",
    "Dextrose 5% And 0.45% Sod Chloride Inj",
    "Dextrose 5% And 0.9% Sod Chloride Inj",
    "Dextrose 5% Injection",
    "Dextrose Injection Usp",
    "Dianeal Pd 101 Capd Solution W 0.5% Dextrose",
    "Dianeal Pd 101 Capd Solution W 1.5% Dextrose",
    "Jamp Ondansetron",
    "Jamp-lactulose",
    "Mineral Oil (heavy)",
    "Oracort Dental Paste",
    "Petrolatum Blanc Ont Usp",
    "Sebamed Diaper Rash Cream",
    "Shampoo Control",
    "Sterile Water For Injection, Usp",
    "Sun-shades Lip Balm Spf 15 - Pina Colada Stk",
    "Sun-shades Lip Balm Spf 15 - Vanilla Stk",
    "Sunscreen Lotion Ecran Solaire 15",
    "White Petroleum Jelly Usp Ointment",
    "Origins Vitazing Spf 15 Energy-boosting Moisturizer",
    "3m Soluprep Sponge",
    "Anti-microbe M",
    "Antibacterial Hand Soap",
    "Antibacterial Hand Soap With Light Moisturizers",
    "Bio-odeur",
    "Chloraprep",
    "Chloraprep One-step",
    "Co-ne-o2-n2 Mixture",
    "Td Adsorbed",
    "Proquad",
    "Pre-pen",
    "18f-fludeoxyglucose (18f-fdg)",
    "Adreview",
    "Datscan",
    "Gallium",
    "Gallium (ga67) Citrate Injection",
    "Indium (111in) Oxine Solution",
    "Indium Dtpa In 111",
    "Lutathera",
    "Naf Plus",
    "Neuraceq",
    "Sodium Iodide I-123 Oral Solution",
    "Thallous Chloride Ti 201 Injection",
    "Thallous Chloride Ti-201 Injection",
    "Draximage Sodium Iodide I131 Solution, Usp Diagnostic",
    "Draximage Sodium Iodide I131 Solution, Usp Therapeutic",
    "Apo-triamcinolone Aq",
    "Arnuity Ellipta",
    "Asmanex Twisthaler",
    "Atrovent Hfa",
    "Avamys",
    "Breo Ellipta",
    "Byetta",
    "Combivent Respimat",
    "Desmopressin Spray",
    "Duaklir Genuair",
    "Dymista",
    "Flonase Allergy Relief",
    "Flovent Diskus",
    "Flovent Hfa",
    "Zenhale",
    "Aklief",
    "Dovonex Ont 50mcg/gm",
    "Enstilar",
    "Silkis",
    "Butrans 10",
    "Butrans 15",
    "Butrans 20",
    "Butrans 5",
    "Climara 25",
    "Climara 50",
    "Climara 75",
    "Estalis 140/50 Mcg",
    "Estalis 250/50 Mcg",
    "Estradot 100",
    "Estradot 25",
    "Estradot 37.5",
    "Estradot 50",
    "Estradot 75",
    "Evra",
    "Oesclim",
    "Pms-fentanyl Mtx",
    "Calcitriol Injection Usp",
    "Carbetocin Injection",
    "Cervarix",
    "Cyanocobalamin Injection Usp",
    "Cyanocobalamin Injection, Usp",
    "Ddavp Inj 4mcg/ml",
    "Dexmedetomidine Hydrochloride For Injection",
    "Dexmedetomidine Hydrochloride For Injection, Usp",
    "Dexmedetomidine Hydrochloride Injection",
    "Duratocin",
    "Engerix-b",
    "Fentanyl Citrate Injection Usp",
    "Lignospan Standard",
    "Med-latanoprost",
    "Menactra",
    "Menjugate Liquid",
    "Menveo",
    "Micro Cr",
    "Micro I",
    "Micro Plus 4 Regular Strength",
    "Micro Plus 6   (pediatric)",
    "Micro Se",
    "Moderna Covid-19 Vaccine",
    "Monoprost",
    "Multi 12 Injection",
    "Neisvac-c",
    "Recombivax Hb",
    "Rekovelle",
    "Riva-latanoprost",
    "Sandostatin 100mcg/ml",
    "Sandostatin 200mcg/ml",
    "Sandostatin 50mcg/ml",
    "Sandoz Latanoprost",
    "Sandoz Latanoprost/timolol",
    "Sensorcaine With Epinephrine",
    "Shingrix",
    "Soliqua",
    "Sufentanil Citrate Injection Usp",
    "Synflorix",
    "Arthrotec 75",
    "Atectura Breezhaler",
    "Aviane 21",
    "Aviane 28",
    "Calcitriol Capsules",
    "Calcitriol-odan",
    "Constella",
    "Cytomel",
    "Daxas",
    "Ddavp Melt",
    "Diane-35",
    "Eltroxin",
    "Enerzair Breezhaler",
    "Uptravi",
    "Vagifem 10",
    "Atlantiscan",
    "High Purity Indium Chloride In 111 Sterile Solution",
    "Thallium",
    "Definity",
    "Sonovue",
    "Ultratag Rbc",
    "Vasopressin Injection Usp",
    "Vivaxim",
    "Xyntha Solofuse",
    "Advate",
    "Kovaltry",
    "Luveris",
    "Menopur",
    "Multi-12/k1 Pediatric",
    "Nuceiva",
    "Octaplex",
    "Oncotice",
    "Penicillin G Sodium For Injection, Usp",
    "Proleukin",
    "Rebinyn",
    "Ran-esomeprazole",
    "Ran-ezetimibe",
    "Ran-gabapentin",
    "Ran-lisinopril",
    "Ran-metformin",
    "Ran-montelukast",
    "Ran-olanzapine Odt",
    "Ran-pantoprazole",
    "Ran-quetiapine",
    "Ran-ranitidine",
    "Ran-risperidone",
    "Ran-ropinirole",
    "Riva-aripiprazole",
    "Riva-atenolol",
    "Riva-atenolol 100 Mg",
    "Riva-atenolol 50 Mg",
    "Riva-atomoxetine",
    "Riva-atorvastatin",
    "Riva-azithromycin",
    "Riva-baclofen",
    "Riva-bisoprolol",
    "Riva-celecox",
    "Riva-ciprofloxacin",
    "Riva-citalopram",
    "Riva-clarithromycin",
    "Riva-clindamycin",
    "Riva-terbinafine",
    "Riva-valacyclovir",
    "Riva-zopiclone",
    "Rivacocet",
    "Rivasa 80 Mg Ec",
    "Rivasa 80mg Croquable - Tab",
    "Rivasa 81 Mg Ec",
    "Rivasa Fc",
    "Rivastigmine",
    "Rivotril 0.5tab",
    "Rivotril 2tab",
    "Rizatriptan Odt",
    "Rizatriptan Rdt",
    "Robax Platinum",
    "Robaxacet",
    "Robaxacet Extra Strength",
    "Robaxacet-8",
    "Sandoz Bisoprolol",
    "Sandoz Bisoprolol Tablets",
    "Sandoz Bosentan",
    "Sandoz Bupropion Sr",
    "Sandoz Candesartan",
    "Sandoz Candesartan Plus",
    "Sandoz Capecitabine",
    "Sandoz Cefprozil",
    "Sandoz Ciprofloxacin",
    "Sandoz Citalopram",
    "Sandoz Clarithromycin",
    "Sandoz Clopidogrel",
    "Sandoz Colchicine",
    "Sandoz Losartan",
    "Sandoz Losartan Hct",
    "Sandoz Losartan Hct Ds",
    "Sandoz Memantine Fct",
    "Sandoz Metformin Fc",
    "Sandoz Methylphenidate Sr",
    "Sandoz Metoprolol Sr",
    "Sandoz Miglustat",
    "Sandoz Mirtazapine",
    "Sandoz Montelukast",
    "Sandoz Montelukast Tablet",
    "Sandoz Morphine Sr",
    "Sandoz Moxifloxacin",
    "Sandoz Mycophenolate Mofetil",
    "Sandoz Naratriptan",
    "Sandoz Rosuvastatin",
    "Sandoz Senna S",
    "Sandoz Sertraline",
    "Sandoz Silodosin",
    "Sandoz Solifenacin",
    "Norepinephrine Bitartrate Injection Usp",
    "Nozinan Inj 25mg/ml",
    "Nubain Injection 10mg/ml",
    "Nucala",
    "Nutrineal Pd4",
    "Pediatrix Drops",
    "Pepto-bismol",
    "Pepto-bismol Extra",
    "Perjeta",
    "Persantine",
    "Peyona",
    "Pharma-lactulose",
    "Phenobarb Elixir",
    "Phenobarbital Sodium Injection, Usp",
    "Phentolamine Mesylate Injection Sandoz Standard",
    "Simponi",
    "Simponi I.v.",
    "Sirop Docusate De Sodium U.s.p. 4mg/ml",
    "Skyrizi",
    "Sleep-eze Eze-free",
    "Sleep-eze Eze-liquid",
    "Smofkabiven Peripheral",
    "Sodium Acetate Injection, Usp",
    "Sodium Acetate-omega",
    "Sodium Bicarbonate Injection Usp",
    "Sodium Bicarbonate Injection, Usp",
    "Sodium Chloride 0.45% Inj",
    "Sodium Chloride 0.9% Injection",
    "Sodium Chloride Bacteriostatic Inj",
    "Sodium Chloride Inj 23.4%",
    "Teva-cephalexin 250",
    "Teva-cloxacillin",
    "Teva-combo Sterinebs",
    "Teva-cotridin",
    "Teva-cotridin Expectorant",
    "Teva-fulvestrant Injection",
    "Teva-lactulose",
    "Teva-propofol",
    "Teva-salbutamol Sterinebs P.f.",
    "Teva-tobramycin",
    "Thiamiject Injection  - Liq Im Iv 100mg/ml",
    "Tis-u-sol Solution",
    "Tobi",
    "Tobramycin Inhalation Solution",
    "Tobramycin Injection",
    "Tobramycin Injection Usp",
    "Vitamin B1",
    "Vitamin C",
    "Vitamin K1 Inj 10mg/ml Usp",
    "Vitamin K1 Inj 1mg/0.5ml Usp",
    "Vivacaine",
    "Vpi-amikacin",
    "Vpi-benztropine",
    "Wilate",
    "Xgeva",
    "Xolair",
    "Xultophy",
    "Xylocaine 0.5%",
    "Xylocaine 1%",
    "Xylocaine 1% W Epinephrine 1:100000",
    "Xylocaine 2%",
    "Neocitran Total Cold Night",
    "Neocitran Ultra Strength Total Flu",
    "Neocitran Ultra Strength Total Flu Night",
    "Nexium",
    "Night Time Total Extra Strength",
    "Nighttime Cold",
    "Pico-salax",
    "Purg-odan",
    "Sabril",
    "Sandoz Montelukast Granules",
    "Singulair",
    "Sandoz Indomethacin",
    "Eligard",
    "Bortezomib For Injection",
    "Taro-clarithromycin",
    "Taro-doxorubicin Liposomal",
    "Taro-oxaliplatin",
    "Taro-phenytoin",
    "Taro-sumatriptan",
    "Taro-testosterone Cypionate Injection",
    "Taro-zoledronic Acid",
    "Taro-zoledronic Acid Concentrate",
    "Tecentriq",
    "Tegretol - Sus 100mg/5ml",
    "Tegsedi",
    "Telebrix 38 Oral",
    "Telzir",
    "Tempra Children's Syrup",
    "Tempra Double Strength Children's Syrup",
    "Tempra Infant Drops",
    "Teva-budesonide",
    "Teva-cephalexin 125",
    "Vicks Children's Nyquil Cold & Cough Multi-symptom Relief",
    "Vicks Dayquil Complete Cold & Flu Liquid",
    "Vicks Dayquil Cough",
    "Vicks Dayquil Cough Cough & Congestion",
    "Vicks Nyquil Cold & Flu Nighttime Relief",
    "Vicks Nyquil Complete Cold & Flu",
    "Vicks Nyquil Cough",
    "Victoza",
    "Vimizim",
    "Vinblastine Sulfate Injection",
    "Vinblastine Sulphate Injection",
    "Vincristine Sulfate Injection",
    "Vincristine Sulfate Injection Usp",
    "Vinorelbine Injection, Usp",
    "Vinorelbine Tartrate For Injection",
    "Visipaque",
    "Diacomit",
    "Extra Strength Total Symptom Relief Sugar-free",
    "Hot Lemon Relief For Symptoms Of Cold And Flu Extra Strength",
    "Hot Lemon Relief For Symptoms Of Cold And Flu Regular Strength",
    "Hot Lemon Relief For Symptoms Of Cough, Cold And Flu Extra Strength",
    "Neocitran Cold & Sore Throat Night",
    "Neocitran Extra Strength Cold & Congestion",
    "Neocitran Extra Strength Cold & Sinus Night",
    "Neocitran Extra Strength Cold & Sinus Night - Apple Cinnamon",
    "Neocitran Extra Strength Total Cold",
    "Neocitran Extra Strength Total Cold Night",
    "Angiomax",
    "Avsola",
    "Azacitidine For Injection",
    "Azithromycin For Injection Usp",
    "Azithromycin For Injection, Usp",
    "Benlysta",
    "Besponsa",
    "Betaseron",
    "Bicnu",
    "Bivalirudin For Injection",
    "Bortezomib",
    "Draximage Mdp",
    "Draximage Mdp-25",
    "Draximage Sestamibi",
    "Egrifta",
    "Emend Iv",
    "Eraxis",
    "Ethacrynate Sodium For Injection Usp",
    "Extavia",
    "Fabrazyme",
    "Fasturtec",
    "Firmagon",
    "Flolan",
    "Fungizone",
    "Fuzeon",
    "Ganciclovir For Injection",
    "Glucagen",
    "Glucagen Hypokit",
    "Polivy",
    "Premarin Intravenous",
    "Primaxin 500",
    "Procytox",
    "Prolastin-c",
    "Provocholine",
    "Reblozyl",
    "Remicade",
    "Remifentanil For Injection",
    "Remifentanil Hydrochloride For Injection",
    "Renflexis",
    "Veklury",
    "Velcade",
    "Vfend For Injection",
    "Vibativ",
    "Vidaza",
    "Visudyne",
    "Voriconazole For Injection",
    "Vpi-ethacrynate Sodium",
    "Yondelis",
    "Zeulide Depot",
    "Acetaminophen Tablets Usp 500 Mg",
    "Acetaminophen With Antihistamine Nighttime",
    "Acetaminophen With Codeine - Caplet",
    "Acetaminophen, Caffeine And Codeine Phosphate Tablets",
    "Acétaminophène Blason Shield 500",
    "Acétaminophène Caplet 325",
    "Acétaminophène Caplet 500",
    "Acétaminophène Comprimé Tablet 325",
    "Acétaminophène Comprimé Tablet 500",
    "Acetazolamide",
    "Acetazone Forte",
    "Acetazone Forte C8",
    "Acetylsalicylic Acid 325mg Tablets Usp",
    "Acetylsalicylic Acid Extra Strength 500mg Tablets Usp",
    "Ach-alendronate",
    "Auro-olmesartan",
    "Auro-olmesartan Hctz",
    "Auro-ziprasidone",
    "Auro-zolmitriptan",
    "Avalide",
    "Avapro",
    "Aventyl",
    "Avodart",
    "Axid",
    "Azathioprine-50",
    "Azilect",
    "Azithromycin",
    "Backup Plan Onestep",
    "Baclofen",
    "Baclofen-10",
    "Baclofen-20",
    "Balversa",
    "Banzel",
    "Baraclude",
    "Benadryl Allergy",
    "Benadryl Allergy Liquigels",
    "Biphentin",
    "Bisacodyl",
    "Bisacodyl 10 Mg",
    "Bisacodyl 5 Mg",
    "Bisacodyl Suppository",
    "Bisacodyl Suppository 5 Mg",
    "Bisacodyl Tablets",
    "Bisacodyl Tablets 5mg",
    "Bisacodyl-odan",
    "Bismuth Caplets",
    "Bismuth Subsalicylate Caplets",
    "Bisoprolol",
    "Bisoprolol Tablets",
    "Blexten",
    "Bosulif",
    "Bradosol Lozenges Extra Strength 3.5mg",
    "Brevicon 0.5/35 Tablets (21-day Pack)",
    "Brevicon 0.5/35 Tablets (28-day Pack)",
    "Brevicon 1/35 Tablets (21-day Pack)",
    "Citalopram",
    "Citalopram-10",
    "Citalopram-20",
    "Citalopram-40",
    "Clarithromycin",
    "Claritin Allergy",
    "Claritin Allergy + Sinus",
    "Claritin Allergy + Sinus Extra Strength",
    "Claritin Liquid Capsules",
    "Claritin Rapid Dissolve",
    "Clarus",
    "Clasteon",
    "Clavulin 500 F Tab",
    "Clavulin 875",
    "Contingency One",
    "Contrave",
    "Cortef Tablets 10mg",
    "Cortef Tablets 20 Mg",
    "Cortiment",
    "Cortisone Acetate",
    "Cotellic",
    "Cough, Cold & Flu",
    "Coversyl",
    "Coversyl Plus",
    "Coversyl Plus Hd",
    "Coversyl Plus Ld",
    "Cozaar",
    "Creo-rectal Adultes/adults",
    "Creo-rectal Enfants/children",
    "Cresemba",
    "Crestor - 10mg",
    "Crestor - 20mg",
    "Crestor - 40mg",
    "Crestor - 5mg",
    "Ctp 30",
    "Cuprimine",
    "Diltiazem-cd",
    "Dimenhydrinate Capsules",
    "Dimenhydrinate Tablets",
    "Diofluor Strips",
    "Diovan",
    "Diovan 160mg Tablets",
    "Diovan 80mg Tablets",
    "Diovan-hct",
    "Diovol Plus Aluminum Free",
    "Diovol Plus Tablets",
    "Dipentum",
    "Ditropan Xl",
    "Diurex Water Caplets",
    "Docusate Calcium",
    "Dom-alendronate-fc",
    "Dom-amlodipine",
    "Dom-atenolol - 100mg",
    "Dom-atenolol - 50mg",
    "Edarbi",
    "Edarbyclor",
    "Edecrin",
    "Edurant",
    "Effexor Xr",
    "Elavil",
    "Eletriptan",
    "Eliquis",
    "Ella",
    "Elmiron",
    "Emend",
    "Emend Tri-pack",
    "Enablex",
    "Enalapril",
    "Extra Strength Flu Relief Nightime",
    "Extra Strength Head Cold And Sinus",
    "Omega Allergenic Extracts - Non-pollens (glycerinated)",
    "Omega Allergenic Extracts - Non-pollens (suspal)",
    "Omega Allergenic Extracts - Pollens (aqueous)",
    "Omega Allergenic Extracts - Pollens (glycerinated)",
    "Omega Allergenic Extracts - Pollens (suspal)",
    "Berinert 500",
    "Bleomycin For Injection",
    "Bleomycin For Injection Usp",
    "Botox",
    "Botox Cosmetic",
    "Cerezyme",
    "Chorionic Gonadotropin For Injection, Usp",
    "Cinryze",
    "Corifact 1250",
    "Corifact 250",
    "Dysport Aesthetic",
    "Dysport Therapeutic",
    "Elelyso",
    "Eloctate",
    "Zonovate",
    "Acarizax",
    "Apo-alendronate/vitamin D3",
    "Beriplex P/n 1000",
    "Beriplex P/n 500",
    "Cotazym",
    "Cotazym Ecs 20",
    "Cotazym Ecs 8",
    "Creon Minimicrospheres 10",
    "Creon Minimicrospheres 25",
    "D-forte",
    "D-tabs 10000unit",
    "Euro D 10 000",
    "Euro-d 50000 Iu",
    "Flagystatin",
    "Fosavance",
    "Grastek",
    "Enevra Non-alcoholic Hand Sanitizer",
    "Loris 0.13% Bzk",
    "Medical Air U.s.p.",
    "Non-alcohol Foaming Hand Sanitizer",
    "Ritual",
    "Soluprep",
    "Soluprep Applicator",
    "Soluprep Qd Solution",
    "Soluprep Swab",
    "Soluprep Wipe",
    "Sterile Light Mineral Oil 100%",
    "Sterilised Water For Injections",
    "Sunshine Hand Sanitizer",
    "Suprane",
    "Triple Rain Hand Sanitizer",
    "Visine For Dry Eye Eye Revival",
    "8-symptom Relief",
    "Act Moxifloxacin",
    "Act Olopatadine 0.1%",
    "Acuvail",
    "Advanced Relief Eye Drops",
    "Minims Fluorescein Sodium",
    "Minims Phenylephrine Hydrochloride",
    "Minims Pilocarpine Nitrate",
    "Minims Tetracaine Hydrochloride",
    "Minims Tropicamide",
    "Mint-olopatadine",
    "Mydfrin",
    "Mydriacyl",
    "Nasal Congestion Spray",
    "Nasal Decongestant Spray With Moisturizers",
    "Nevanac",
    "Odan-benzydamine",
    "Opti-tears Red Eye",
    "Opticrom",
    "Original Eye Drops",
    "Otixal",
    "Otrivin Medicated Cold & Allergy Relief",
    "Otrivin Medicated Cold & Allergy Relief With Moisturizers",
    "Pataday",
    "Visine For Red Eye Workplace",
    "Visine Multi-symptom",
    "Vistitan",
    "Voltaren Ophtha",
    "Vyzulta",
    "Xiidra",
    "2in1 Men Advanced Series Bourbon",
    "2in1 Men Advanced Series Charcoal",
    "2in1 Men Advanced Series Fiji",
    "2in1 Men Advanced Series Full & Thick",
    "2in1 Men Advanced Series Pure Sport",
    "2in1 Men Advanced Series Refreshing Menthol",
    "2in1 Men Advanced Series Sage & Mint",
    "2in1 Men Advanced Series Sandalwood",
    "2in1 Men Advanced Series Swagger",
    "30 Spf",
    "Abc Arbonne Baby Care Diaper Rash Cream",
    "Absolue Velvet Cream With Broad Spectrum Spf 15",
    "Absolutely Ageless Daily Moisturizer",
    "Acne Clearing Treatment",
    "Acne Treatment Lotion",
    "Acne Treatment System",
    "Banana Boat Simply Protect Sensitive Sunscreen Lotion Spf 50 Plus",
    "Banana Boat Simply Protect Sport Sunscreen Lotion Spf 50+",
    "Banana Boat Simply Protect Sport Sunscreen Spray Spf 50+",
    "Banana Boat Sport For Kids Sunscreen Stick Spf 50+",
    "Banana Boat Sport Performance With Powerstay Technology Sunscreen Lotion Spf 30",
    "Banana Boat Sport Performance With Powerstay Technology Sunscreen Lotion Spf/fps 60",
    "Banana Boat Sport Performance With Powerstay Technology Sunscreen Spray Spf 30",
    "Banana Boat Sport Performance With Powerstay Technology Sunscreen Spray Spf 50+",
    "Banana Boat Suncomfort Sunscreen Spray Spf 30",
    "Banana Boat Suncomfort Sunscreen Spray Spf 50+",
    "Banana Boat Sunscreen Oil Spray Huile Écran Solaire En Vaporisateur Spf Fps 4",
    "Banana Boat Ultra Sport Sunscreen Stick Spf 50+",
    "Baza Cleanse & Protect",
    "Baza Protect Ii",
    "Bb Cream Sunscreen Spf 30",
    "Cle De Peau Beaute 50+ Creme Teintee Protectrice Uv",
    "Clé De Peau Beauté 50+ Émulsion Très Haute Protection Uv Pour Le Corps",
    "Clé De Peau Beauté Crème Fortifiante Protectrice",
    "Clé De Peau Beauté Crème Pour Les Mains",
    "Clé De Peau Beauté Émulsion Fortifiante Protectrice",
    "Clé De Peau Beauté Radiant Cream Foundation",
    "Cle De Peau Beaute Teint Stick Eclat",
    "Clear Cell Medicated Acne Facial Scrub",
    "Clear Complexion Sheer Daily Moisturizer",
    "Clear Face Sunscreen Lotion",
    "Clear Stick Uv Protector",
    "Clindoxyl Adv Gel",
    "Clindoxyl Gel",
    "Clinique Acne Solutions All-over Clearing Treatment",
    "Clinique Even Better Glow Light Reflecting Makeup Spf 15",
    "Clinique Even Better Hand Cream Spf 15",
    "Clinique Even Better Lotion Spf 20",
    "Clinique Even Better Makeup Spf 15",
    "Coppertone Lotion Sunscreen Spf 30 Glow",
    "Coppertone Lotion Sunscreen Spf 30 Sport",
    "Coppertone Lotion Sunscreen Spf 30 Sun Guard",
    "Coppertone Lotion Sunscreen Spf 50 Defend & Care",
    "Coppertone Lotion Sunscreen Spf 50 Defend & Care Face",
    "Coppertone Lotion Sunscreen Spf 50 Glow",
    "Coppertone Lotion Sunscreen Spf 50 Kids",
    "Coppertone Lotion Sunscreen Spf 50 Sport",
    "Coppertone Lotion Sunscreen Spf 50 Sun Guard",
    "Coppertone Lotion Sunscreen Spf 50 Waterbabies",
    "Coppertone Mousse Sunscreen Spf 50 Waterbabies",
    "Coppertone Spray Sunscreen Spf 30 Sport",
    "Coppertone Spray Sunscreen Spf 30 Sun Guard",
    "Genotropin",
    "Lupron Depot",
    "Somatuline Autogel",
    "Apo-doxazosin",
    "Cellcept I.v.",
    "Ceretec",
    "Cerubidine",
    "Cetrotide",
    "Colistimethate For Injection",
    "Colistimethate For Injection U.s.p.",
    "Coly-mycin M Parenteral",
    "Cortrosyn Inj 0.25mg",
    "Methacholine Omega",
    "Miochol E",
    "Mitomycin For Injection",
    "Mitomycin For Injection Usp",
    "Mycamine",
    "Mycophenolate Mofetil For Injection Usp",
    "Mycophenolate Mofetil For Injection, Usp",
    "Mylotarg",
    "Myoview",
    "Myoview 30ml",
    "Myozyme",
    "Neurolite",
    "Solu-cortef 500 Mg Act-o-vial",
    "Somavert",
    "Spy Agent Green",
    "Spy Agent Green Kit For Advanced Imaging Modality (aim) And Pinpoint",
    "Spy Agent Green Kit For Spy Elite",
    "Spy Agent Green Kit For Spy-phi",
    "Spy Agent Green Lymphatics Kit For Advanced Imaging Modality (aim) And Pinpoint",
    "Sylvant",
    "Taro-imipenem-cilastatin",
    "Acarbose Tablets",
    "Accel-entecavir",
    "Accel-leflunomide",
    "Accel-ondansetron",
    "Accel-pilocarpine",
    "Accel-rizatriptan Odt",
    "Accel-sevelamer",
    "Accel-sildenafil",
    "Accupril 5mg Tab",
    "Accupril Tab 10mg",
    "Accupril Tab 20mg",
    "Accupril Tab 40mg",
    "Accuretic",
    "Accutane Roche",
    "Acebutolol - 400",
    "Acebutolol-100",
    "Acebutolol-200",
    "Ag-quetiapine",
    "Ag-ramipril",
    "Ag-ranitidine",
    "Ag-risperidone",
    "Creme Visage Fps 45",
    "Crinone",
    "Cromolyn Eye Drops",
    "D.o.r.c. Vision Blue",
    "Daily Sheer Broad-spectrum Sunscreen Spf 50",
    "Day Cream Spf 15",
    "Deep Moisture Renewal With Spf 15",
    "Dentec Lip Balm",
    "Dentec Lotion",
    "Denticare Chlorhexidine Gluconate Oral Rinse 0.12%",
    "Derma Smoothe/fs Liq 0.01%",
    "Dermovate Cream",
    "Dermovate Ointment",
    "Dermovate Scalp Application",
    "Dettol",
    "Dexamethasone",
    "Dexidin 2 Solution",
    "Dial Complete 2 In 1 Moisturizing & Antibacterial Foaming Hand Wash Manuka Honey",
    "Apo-terbinafine",
    "Apo-tetrabenazine",
    "Apo-topiramate",
    "Apo-tramadol",
    "Apo-tramadol/acet",
    "Apo-trazodone D Tablets 150mg",
    "Apo-trazodone Tablets 100mg",
    "Apo-trazodone Tablets 50mg",
    "Apo-valacyclovir",
    "Apo-valproic",
    "Apo-vardenafil",
    "Apo-varenicline",
    "Apo-venlafaxine Xr",
    "Apo-verap Tab 80mg",
    "Apo-verap Tablet 120mg",
    "Apo-warfarin",
    "Apo-zidovudine",
    "Apo-zolpidem Odt",
    "Apo-zopiclone",
    "Apprilon",
    "Aptiom",
    "Aptivus",
    "Arava 100 Mg",
    "Arava 10mg",
    "Arava 20 Mg",
    "Aricept",
    "Aricept Rdt",
    "Arimidex Tab 1mg",
    "Aripiprazole",
    "Aromasin",
    "Asa",
    "Asa 325mg",
    "Asa 500 Mg Tablets Extra Strength",
    "Asa 80mg",
    "Asa 81 Mg",
    "Asa Daily Low Dose",
    "Asa Ec",
    "Asacol 800",
    "Asaphen",
    "Asaphen E.c. 80 Mg",
    "Asatab 80 Mg Chewable Tablets",
    "Aspen-dienogest",
    "Aspirin 81mg",
    "Aspirin 81mg Quick Chews",
    "Aspirin Coated For Delayed Release Regular Strength",
    "Aspirin Extra Strength",
    "Aspirin Regular Strength",
    "Atacand",
    "Atacand Plus",
    "Atorvastatin",
    "Atorvastatin-10",
    "Atorvastatin-20",
    "Atorvastatin-40",
    "Atorvastatin-80",
    "Atovaquone And Proguanil Hydrochloride Tablets",
    "Atovaquone Proguanil",
    "Atripla",
    "Aubagio",
    "Auro-abacavir/lamivudine",
    "Auro-alendronate",
    "Auro-alfuzosin",
    "Auro-amlodipine",
    "Auro-amoxicillin",
    "Auro-aripiprazole",
    "Auro-atomoxetine",
    "Auro-atorvastatin",
    "Auro-betahistine",
    "Auro-buspirone",
    "Auro-candesartan",
    "Auro-candesartan Hct",
    "Auro-carvedilol",
    "Auro-cefixime",
    "Auro-cefprozil",
    "Auro-cefuroxime",
    "Auro-celecoxib",
    "Auro-cephalexin",
    "Auro-cinacalcet",
    "Auro-ciprofloxacin",
    "Auro-finasteride",
    "Robitussin Children's Cold",
    "Robitussin Children's Cough & Cold Bedtime",
    "Robitussin Children's Cough And Cold",
    "Robitussin Cough And Cold",
    "Robitussin Cough Control",
    "Robitussin Extra Strength Cough & Cold",
    "Robitussin Extra Strength Cough Control",
    "Robitussin Extra Strength Honey Cough & Congestion",
    "Robitussin Extra Strength Mucus And Phlegm",
    "Robitussin Honey Cough & Cold Nighttime",
    "Robitussin Mucus & Phlegm",
    "Robitussin Sugar Free Cough Control",
    "Robitussin Total Cough, Cold & Flu",
    "Robitussin Total Cough, Cold & Flu Nighttime Extra Strength",
    "Rocuronium Bromide Injection",
    "Ropivacaine Hydrochloride Injection Usp",
    "Ropivacaine Hydrochloride Injection, Usp",
    "Rupall",
    "Ruxience",
    "S.o.s. Naloxone Hydrochloride Injection",
    "Saizen",
    "Sandimmune Iv 50mg/ml",
    "Sandoz Azithromycin",
    "Sandoz Cyproheptadine",
    "Sandoz Dorzolamide/timolol",
    "Sandoz Methadone",
    "Sandoz Polytrimethoprim",
    "Sarclisa",
    "Saxenda",
    "Scandonest 3% Plain Inj",
    "Sclerodex",
    "Scopolamine Hydrobromide Injection",
    "Seacalphyx",
    "Sensorcaine",
    "Septanest N",
    "Septanest Sp",
    "Septra Injection",
    "Signifor",
    "Siliq",
    "Sunscreen Oil",
    "Acid Concentrate A1298",
    "Acid Concentrate D12201",
    "Acid Concentrate D12203",
    "Acid Concentrate D12207",
    "Acid Concentrate D12236",
    "Acid Concentrate D12248",
    "Ag-rosuvastatin",
    "Ag-sertraline",
    "Ag-sildenafil",
    "Ag-simvastatin",
    "Ag-tadalafil",
    "Pms-tenofovir",
    "Pms-terazosin",
    "Pms-terbinafine",
    "Pms-testosterone",
    "Pms-tetrabenazine",
    "Pms-topiramate",
    "Pms-trandolapril",
    "Pms-trazodone",
    "Pms-ursodiol C",
    "Cold And Flu Relief",
    "Cold Stix",
    "Cold Stix Super Strength",
    "Cough & Cold Relief",
    "Daytime Cold",
    "Apo-lansoprazole-amoxicillin-clarithromycin",
    "Hp-pac",
    "Mirvala 21",
    "Mirvala 28",
    "Ursodiol Tablets Usp",
    "Abilify Maintena",
    "Abraxane For Injectable Suspension",
    "Acetazolamide For Injection, Usp",
    "Act Bortezomib",
    "Adcetris",
    "Alimta",
    "Ambisome",
    "Amoxicillin Sodium And Potassium Clavulanate For Injection",
    "Cosmegen",
    "Cubicin Rf",
    "Cysview",
    "Cytovene",
    "Dacarbazine For Injection Bp",
    "Dantrium Intravenous",
    "Daptomycin For Injection",
    "Desferal 500mg",
    "Digifab",
    "Doxorubicin Hydrochloride For Injection Usp",
    "Draximage Dtpa",
    "Draximage Gluceptate",
    "Draximage Maa",
    "Niastase Rt",
    "Ogivri",
    "Olanzapine For Injection",
    "Orencia",
    "Panhematin",
    "Pantoprazole For Injection",
    "Pantoprazole Sodium For Injection",
    "Pemetrexed Disodium For Injection",
    "Pentamidine Isetionate For Injection Bp",
    "Perjeta-herceptin",
    "Pms-bortezomib",
    "Taro-pemetrexed",
    "Technescan Mag3",
    "Technetium Tc 99m Tsc",
    "Tepadina",
    "Teva-topotecan",
    "Thymoglobulin",
    "Thyrogen",
    "Tigecycline",
    "Tnkase",
    "Tomudex",
    "Trazimera",
    "Treanda",
    "Trelstar",
    "Tygacil",
    "Acet 120",
    "Acet 160",
    "Acet 325",
    "Acet 650",
    "Acetaminophen 160 Mg Chewable Tablets",
    "Acetaminophen 325 Mg Usp Regular Strength",
    "Acetaminophen 325mg Tablets Regular Strength",
    "Acetaminophen 500 Mg Tablets Extra Strength Easy To Swallow",
    "Acetaminophen 500 Mg Tablets Usp Extra Strength",
    "Acetaminophen 500mg And Caffeine 65mg",
    "Acetaminophen 500mg Tablets Extra Strength",
    "Acetaminophen Arthritis Pain",
    "Acetaminophen Caplet 325mg Usp",
    "Acetaminophen Caplet 500mg",
    "Acetaminophen Caplets 325 Mg",
    "Acetaminophen Caplets 500 Mg",
    "Acetaminophen Chewable Tablets 160 Mg",
    "Acetaminophen Chewable Tablets 160 Mg For Children",
    "Acetaminophen Chewable Tablets 80 Mg",
    "Acetaminophen Chewable Tablets 80 Mg For Children",
    "Acetaminophen Extra Strength Liquid Gels",
    "Acetaminophen Tab 325mg Usp",
    "Acetaminophen Tab 500mg Usp",
    "Acetaminophen Tablets 325 Mg",
    "Acetaminophen Tablets Usp 325 Mg",
    "Apo-losartan/hctz",
    "Apo-lovastatin - Tab 20mg",
    "Apo-lovastatin - Tab 40mg",
    "Apo-medroxy",
    "Apo-medroxy Tablets",
    "Apo-meloxicam",
    "Apo-memantine",
    "Apo-metformin Er",
    "Apo-methylphenidate",
    "Apo-methylphenidate Er",
    "Apo-methylphenidate Sr",
    "Apo-metoprolol",
    "Apo-metoprolol (type L)",
    "Apo-metoprolol Sr",
    "Apo-metronidazole",
    "Apo-midodrine",
    "Apo-olmesartan",
    "Apo-olmesartan/hctz",
    "Apo-omeprazole",
    "Apo-ondansetron",
    "Apo-oxcarbazepine",
    "Apo-oxybutynin - Tab 5mg",
    "Apo-oxycodone Cr",
    "Apo-oxycodone/acet",
    "Apo-pantoprazole",
    "Apo-paroxetine",
    "Apo-perindopril",
    "Apo-perindopril/amlodipine",
    "Apo-phenytoin Sodium",
    "Apo-pinaverium",
    "Apo-pindol Tab 10mg",
    "Apo-pindol Tab 15mg",
    "Apo-pindol Tab 5mg",
    "Apo-pioglitazone",
    "Apo-pramipexole",
    "Apo-pravastatin",
    "Apo-prazo Tab 1mg",
    "Apo-prazo Tab 2mg",
    "Apo-prazo Tab 5mg",
    "Apo-pregabalin",
    "Apo-propafenone",
    "Apo-prucalopride",
    "Apo-quetiapine",
    "Apo-quetiapine Xr",
    "Apo-quinapril",
    "Apo-quinapril/hctz",
    "Apo-quinine",
    "Apo-raloxifene",
    "Apo-ramipril",
    "Apo-ranitidine Tablet 150mg",
    "Apo-ranitidine Tablet 300mg",
    "Apo-rasagiline",
    "Apo-riluzole",
    "Apo-risedronate",
    "Apo-risperidone",
    "Apo-rivastigmine",
    "Apo-rizatriptan",
    "Cough Syrup With Codeine",
    "Dianeal Pd 101 Capd Solution W 2.5% Dextrose",
    "Dianeal Pd 101 Capd Solution W 4.25% Dextrose",
    "Dianeal Pd4 Capd Solution With 1.5% Dextrose And 2.5meq/l Calcium",
    "Dianeal Pd4 Capd Solution With 2.5% Dextrose And 2.5meq/l Calcium",
    "Dianeal Pd4 Capd Solution With 4.25% Dextrose And 2.5meq/l Calcium",
    "Diastat",
    "Diazepam Injection Usp",
    "Diflucan",
    "Digoxin Injection C.s.d.",
    "Dihydroergotamine (dhe), 1mg/ml",
    "Dilantin-125 Suspension",
    "Dilantin-30 Suspension",
    "Diltiazem Hydrochloride Injection",
    "Dimenhydrinate Inj 10mg",
    "Dimenhydrinate Inj 50mg Usp",
    "Quinine - Odan",
    "Rabeprazole",
    "Rabeprazole Ec",
    "Ralivia",
    "Ramipril",
    "Ran-celecoxib",
    "Ran-citalo",
    "Ran-clarithromycin",
    "Ran-domperidone",
    "Ran-duloxetine",
    "Ran-enalapril",
    "Ran-escitalopram",
    "Ran-tadalafil",
    "Ranitidine",
    "Rapaflo",
    "Rapid Action",
    "Rasilez",
    "Ratio-metformin",
    "Reactine 20mg Tablet",
    "Reactine Allergy Liquid Gels",
    "Reactine Complete",
    "Reactine Fast Melt Junior",
    "Reactine Rapid Dissolve",
    "Red-cote",
    "Reddy-atorvastatin",
    "Reddy-progesterone",
    "Regular Strength Acetaminophen",
    "Regular Strength Sleep Aid",
    "Relpax",
    "Remeron",
    "Remeron Rd",
    "Renagel",
    "Repaglinide",
    "Resotran",
    "Restoril",
    "Retisert",
    "Revia",
    "Revlimid",
    "Revolade",
    "Rexulti",
    "Reyataz",
    "Ridaura",
    "Rilutek",
    "Rinvoq",
    "Risedronate",
    "Risedronate-35",
    "Risperidone",
    "Ritalin 10mg",
    "Ritalin-sr Tab 20mg",
    "Riva Leucovorin",
    "Riva Oxazepam",
    "Riva-alendronate",
    "Riva-amiodarone",
    "Riva-amlodipine",
    "Riva-anastrozole",
    "Riva-clonazepam",
    "Riva-clopidogrel",
    "Riva-cyclobenzaprine",
    "Riva-cyproterone",
    "Riva-dapsone",
    "Riva-duloxetine",
    "Riva-dutasteride",
    "Riva-enalapril",
    "Riva-escitalopram",
    "Riva-finasteride",
    "Riva-fluconazole",
    "Riva-fluoxetine",
    "Riva-fluvox",
    "Riva-gabapentin",
    "Riva-labetalol",
    "Riva-lansoprazole",
    "Riva-letrozole",
    "Lithmax",
    "Lixiana",
    "Lomotil",
    "Loniten 10mg",
    "Loniten 2.5mg",
    "Lonsurf",
    "Loperamide-2",
    "Lopresor Sr 100mg",
    "Lopresor Sr 200 Mg",
    "Loratadine",
    "Loratadine Soft Gel Capsules",
    "Lorazepam",
    "Lorazepam Sublingual",
    "Lorbrena",
    "Losartan",
    "M-rosuvastatin",
    "M-sildenafil",
    "Naturalyte H-702",
    "Nxstage Pureflow Dialysate Concentrate (sak 304)",
    "Nxstage Pureflow Dialysate Concentrate (sak-301)",
    "Nxstage Pureflow Dialysate Concentrate (sak-302)",
    "Nxstage Pureflow Solution Rfp-204-can",
    "Nxstage Pureflow Solution Rfp-207-can",
    "Nxstage Pureflow Solution Rfp-209-can",
    "Selectbag One (ax450g)",
    "1.6% Sodium Chlordie Processing Solution",
    "10% Dextrose Injection, Usp",
    "12% Sodium Chlordie Processing Solution",
    "20% Prosol",
    "5% Dextrose Injection, Usp",
    "5% Sodium Chloride Injection Usp",
    "70% Dextrose Injection Usp",
    "Additive Solution Formula 3 As-3",
    "Anticoagulant Citrate Dextrose Solution Usp (acd) Formula A",
    "Anticoagulant Sod Citrate Soltn 4gm/100ml",
    "Anticoagulant Sodium Citrate 4% W/v Solution, Usp",
    "Antizol",
    "Charac-50",
    "Charactol-50",
    "Cold Flu Relief",
    "Cutaquig",
    "Draximage Sodium Iodide I131 Capsules, Usp Diagnostic",
    "Draximage Sodium Iodide I131 Capsules, Usp Therapeutic",
    "24hr Nasal Allergy Relief",
    "Adlyxine",
    "Advair 100 Diskus",
    "Advair 125",
    "Advair 250",
    "Advair 250 Diskus",
    "Advair 500 Diskus",
    "Aermony Respiclick",
    "Airomir",
    "Alvesco",
    "Anoro Ellipta",
    "Apo-beclomethasone Nasal Spray",
    "Apo-fluticasone",
    "Apo-mometasone",
    "Apo-salbutamol Hfa",
    "Ratio-fluticasone",
    "Rhinocort Aqua",
    "Salbutamol Hfa",
    "Sandoz Mometasone",
    "Serevent Diskus (50mcg/dose)",
    "Spiriva Respimat",
    "Suprefact",
    "Symbicort 100 Turbuhaler",
    "Symbicort 200 Turbuhaler",
    "Synarel",
    "Teva-fluticasone",
    "Teva-mometasone",
    "Teva-salbutamol Hfa",
    "Trelegy Ellipta",
    "Tudorza Genuair",
    "Ventolin Diskus",
    "Ventolin Hfa",
    "Wixela Inhub",
    "Agriflu",
    "Apo-ipravent Solution - Inh 250mcg/ml",
    "Apo-latanoprost",
    "Aranesp",
    "Clear Eyes",
    "Clear Eyes Allergy",
    "Clear Eyes Triple Action Relief",
    "Clearlax",
    "Clobex Shampoo",
    "Clotrimazole Vaginal 3",
    "Clotrimazole Vaginal 6",
    "Co-he-o2-n2 Mixture",
    "Cold & Allergy Relief With Moisturizers",
    "Color-smart Day Moisturizer Hydratant Jour Correcteur De Teint Broad Spectrum Spf 30 Fps 30 A Large Spectre",
    "Color-smart Day Moisturizer Oil-free Hydratant Jour Correcteur De Teint Sans Corps Gras Broad Spectrum Spf 30 Fps",
    "Mylan-rizatriptan Odt",
    "Mylan-sumatriptan",
    "Mylan-tadalafil",
    "Mylan-tenofovir Disoproxil",
    "Mylan-topiramate",
    "Dehydrated Alcohol Injection Usp",
    "Dymon Antibacterial Hand Soap With Moisturizers",
    "Ecological Hand Sanitizer With Conditioning Aloe",
    "Eye Stream",
    "Flarex",
    "Fluorescite",
    "Henry Schein Antimicrobial Skin Cleanser",
    "Ilevro",
    "Intralipid",
    "Isopto Atropine",
    "Izba",
    "Jamp-dorzolamide",
    "Jamp-olopatadine",
    "Latisse",
    "Long Lasting Decongestant Nasal Spray",
    "Long Lasting Dristan Mentholated Nasal Spray",
    "Long Lasting Dristan Nasal Mist",
    "Loris 2% Chg Solution",
    "Loris 2% Chg Wipe/serviette",
    "Lotemax",
    "Lubricant Eye Drops/ Artificial Tears",
    "Lumigan Rc",
    "Maxitrol",
    "Minims Atropine Sulphate",
    "Minims Cyclopentolate Hydrochloride",
    "Actikerall",
    "Active Anti-acne Treatment Kit",
    "Active Protection Fresh Grapefruit Sunscreen Lip Balm",
    "Active Protection Lemon Twist Sunscreen Lip Balm",
    "Active Protection With Aloe",
    "Aczone",
    "Adaptasun Crème De Soin Solaire Mer Et Tropiques Visage Fps/spf 25",
    "Advantage Acne Control Kit",
    "Age Balancing Moisture Broad Spectrum Spf 30 | Pa+++",
    "Age Minimize 3d Day Cream Spf 30 Broad Spectrum Sunscreen",
    "Age Perfect Rosy Tone Day Cream",
    "Age Renewal Spf 25",
    "Alcohol Free Foaming Hand Sanitizer",
    "Alexander's Rash Ease - Sport Cream",
    "Almost Powder Makeup Teint Poudre Naturel Spf 18 / Fps 18",
    "Aloe Soothing Moisture Lotion Spf 15",
    "Aloe Vera 2in1",
    "Aloe-care Antibacterial Lotion Soap, Benzalkonium Chloride Lotion 0.13% W/w",
    "Amorepacific Color Control Cushion Compact",
    "Aveeno Active Naturals Protect + Hydrate Spf 30",
    "Aveeno Active Naturals Protect + Hydrate Spf 45",
    "Aveeno Active Naturals Protect + Hydrate Spf 60",
    "Avmor Antibacterial Foaming Hand Soap/ Avmor Savon Moussant Antibactérien Pour Les Mains",
    "Baby Lips",
    "Baby Sun Protection Lotion",
    "Bactine First Aid Spray",
    "Banana Boat Baby Sunscreen Lotion Spf/fps 60",
    "Banana Boat Daily Protect Sunscreen Lotion Spf 30",
    "Banana Boat Daily Protect Sunscreen Lotion Spf 50+",
    "Banana Boat Daily Protect Sunscreen Spray Spf 30",
    "Banana Boat Daily Protect Sunscreen Spray Spf 50+",
    "Banana Boat Kids Sunscreen Lotion Spf/fps 60",
    "Banana Boat Kids Tear-free Sunscreen Spray Spf 50+",
    "Banana Boat Simply Protect Kids Sunscreen Lotion Spray Spf 50+",
    "Banana Boat Simply Protect Sensitive Faces Visages Suncreen Lotion Spf 50 Plus",
    "Cc Sunscreen",
    "Ceramide Lift And Firm Day Cream Spf 30",
    "Ceramide Lift And Firm Eye Cream Spf 15",
    "Ceramide Premiere Intense Moisture And Renewal Activation Cream Spf 30",
    "Cerave",
    "Certainty Foaming Hand Sanitizer",
    "Certainty Wipes Hand Sanitizing Wipes",
    "Cetaphil Daily Facial Moisturizer     (spf 50)",
    "Cetaphil Pro Dermacontrol Oil Control Moisturizer",
    "Cetylpyridinium Chloride Antiseptic Oral Rinse 0.07 % W/w",
    "Chapstick Active Spf 30",
    "Chapstick Moisturizer",
    "Chlorhexidine Gluconate 0.12% Oral Rinse, Usp",
    "Ciloxan",
    "Cintas Alcohol-free Foaming Hand Sanitizer / Cintas Assainisseur Moussant Sans Alcool Pour Les Mains",
    "Cle De Peau Beaute 30 Soin Protecteur Uv Pour Les Levres",
    "Clé De Peau Beauté 50+ Crème Protectrice Uv",
    "Complete* Dry Touch Sunscreen/écran Solaire",
    "Continuous Control Acne Cleanser",
    "Continuous Spray Sunscreen Sun Bum Broad Spectrum Spf 15",
    "Continuous Spray Sunscreen Sun Bum Broad Spectrum Spf 30",
    "Continuous Spray Sunscreen Sun Bum Broad Spectrum Spf 50",
    "Coola Citrus Mimosa Scent Sunscreen Spray",
    "Coola Makeup Setting Spray Green Tea Scent",
    "Coola Pina Colada Scent Sunscreen Spray",
    "Coolzone Instantly Cools & Refreshes Rafraîchit Instantanément Spray Sunscreen Écran Solaire En Vaporisateur Spf/fps 30",
    "Coolzone Instantly Cools & Refreshes Rafraîchit Instantanément Spray Sunscreen Écran Solaire En Vaporisateur Spf/fps 50",
    "Coppertone Clear Sunscreen Spf 30 Sport",
    "Coppertone Clear Sunscreen Spf 50 Sport",
    "Coppertone Lotion Sunscreen Spf 15 Glow",
    "Coppertone Lotion Sunscreen Spf 15 Sun Guard",
    "Elemental Hand Sanitizer",
    "Elidel",
    "Elizabeth Arden Nourishing Lip Balm Spf 20",
    "Eltamd Skincare Uv Clear",
    "Eltamd Skincare Uv Daily Spf 40",
    "Eltamd Skincare Uv Defense Spf 45",
    "Eltamd Skincare Uv Facial Spf 30",
    "Emergency Acne Vanishing Facial Cleanser",
    "Emolax",
    "Émulsion Hydratante Antirides",
    "Emulsion Spf 50+",
    "Enriched Foam Alcohol-free Hand Sanitizer",
    "Equate Kids Sunscreen Lotion Spf/fps 60",
    "Equate Sport Sunscreen Continous Spray Spf/fps 15",
    "Equate Sport Sunscreen Continuous Spray Spf/fps 60",
    "Equate Sport Sunscreen Continuous Spray Spf/fps30",
    "Equate Sport Sunscreen Lotion Spf/fps 30",
    "Equate Sport Sunscreen Lotion Spf/fps 60",
    "Equate Sunscreen Lotion Spf/fps 30",
    "Fresh Essentials Daily Nourishing Moisturizer",
    "Fs Antimicrobial Hand Wash",
    "Fucibet",
    "Fucithalmic",
    "Fungifoam Antifungal",
    "Futur E Spf 15 Moisturizing Lotion",
    "Future Solution Lx Universal Defense",
    "Futurist Hydra Rescue Moisturizing Makeup Fond De Teint Hydratant Spf/fps 45",
    "Global Blend",
    "Glow Tinted Moisturizer Spf 15",
    "Glowscreen",
    "Gojo Antibacterial Foam Handwash Triclosan Liquid",
    "Gojo Antibacterial Plum Scent Foam Handwash Triclosan Liquid",
    "Gold Bond Anti-itch Lotion",
    "Gold Bond Medicated Anti-itch Cream",
    "Hamol",
    "Hand Sanitizer",
    "Hand Sanitizer Foam",
    "Hawaiian Tropic Duo Defence Refresh Sunscreen Mist Spf 30",
    "Hawaiian Tropic Island Sport Sweat Resistant Sunscreen Spray Spf 30",
    "Hawaiian Tropic Kids Sunscreen Lotion Spf/fps 50+",
    "La Mer The Spf 50 Uv Protecting Fluid",
    "Lab Series Day Rescue Defense Lotion Spf 35",
    "Avonex",
    "Bexsero",
    "Bles",
    "Boostrix",
    "Gd-latanoprost",
    "Gd-latanoprost/timolol",
    "Grastofil",
    "Hemabate",
    "Hiberix",
    "Artiss",
    "Tisseel",
    "Potassium Chloride For Injection Concentrate",
    "Bricanyl Turbuhaler",
    "Imitrex Nasal Spray",
    "Lidodan Endotracheal Non-aerosol Spray",
    "Original Antibiotic Cream",
    "Pdp-erythromycin",
    "Pheburane",
    "Polysporin Antibiotic Cream",
    "Polysporin Complete",
    "Polysporin For Kids",
    "Polysporin Plus Pain Relief",
    "Polysporin Triple Antibiotic Ointment",
    "Premarin Vaginal Cream",
    "Prostin E2 Vaginal Gel",
    "Ratio-topisalic",
    "Resonium Calcium",
    "Rimso-50",
    "Teva-triacomb",
    "Theraderm Cream",
    "Triple Antibiotic Ointment",
    "Viaderm Kc Crm",
    "(40mmol/l) Potassium Chloride In 3.3% Dextrose And 0.3% Sodium Chloride Injection Usp",
    "(40mmol/l)potassium Chloride In 5% Dextrose And 0.45% Sodium Chloride Injection Usp",
    "0.15% Potassium Chloride In 5% Dextrose And 0.20% Sodium Chloride Injection Usp",
    "0.4% Lidocaine Hydrochloride And 5% Dextrose Injection",
    "0.45% Sodium Chloride Injection Usp",
    "0.9% Sodium Chloride Injection, Usp",
    "0.9% Sodium Chloride Irrigation, Usp",
    "10% Dextrose Injection Usp",
    "3.33% Dextrose And 0.3% Sodium Chloride",
    "3% Polocaine Dental",
    "3tc",
    "4% Astracaine Dental With Epinephrine 1:200,000 (0.005mg/ml)",
    "4% Astracaine Dental With Epinephrine Forte 1:100,000 (0.01mg/ml)",
    "4% Citanest Forte Dental With Epinephrine 1:200,000",
    "4% Citanest Plain Dental",
    "Aloxi",
    "Amikacin Sulfate Injection",
    "Amikacin Sulfate Injection Usp",
    "Aminophylline Inj 25mg/ml",
    "Aminophylline Injection Usp",
    "Amiodarone Hydrochloride For Injection",
    "Amiodarone Hydrochloride Injection",
    "Amoxicillin",
    "Androcur Depot",
    "Antibiotic Ear Drops",
    "Antibiotic Eye Drops",
    "Antimony Sulfide Colloid Kit",
    "Apo-dorzo-timop",
    "Balminil Dm + Decongestant + Expectorant Extra Strength",
    "Balminil Dm + Expectorant",
    "Balminil Dm + Expectorant Extra Strength",
    "Balminil Expectorant",
    "Balminil Expectorant (sucrose Free)",
    "Balminil Night-time",
    "Bamlanivimab",
    "Bavencio",
    "Belkyra",
    "Benadryl Allergy Liquid",
    "Benylin Extra Strength All-in-one Cough, Cold & Flu",
    "Benylin Extra Strength All-in-one Cough, Cold & Flu Night",
    "Benylin Extra Strength All-in-one Cough, Cold & Flu With Warming Sensation",
    "Benylin Extra Strength Chest Congestion & Cold",
    "Benylin Extra Strength Cough & Chest Congestion",
    "Benylin Extra Strength Cough & Chest Congestion With Warming Sensation",
    "Benylin Sleep Time",
    "Benztropine Omega",
    "Beovu",
    "Betnesol Retention Enema 5mg/100ml",
    "Biaxin",
    "Bismuth Subsalicylate Liquid",
    "Brenzys",
    "Brevibloc Injection 10mg/ml",
    "Brevibloc Premixed Injection",
    "Bridion",
    "Brinavess",
    "Brineura",
    "Brivlera",
    "Bronchophan Expectorant (sans Sucrose)",
    "Bronchophan Forte Dm Syr",
    "Buckley's Chest Congestion",
    "Buckley's Complete",
    "Buckley's Complete Plus Extra Strength Mucus Relief",
    "Buckley's Mucus & Phlegm",
    "Buckley's Nighttime Cough & Congestion",
    "Bupivacaine Hcl 0.5% And Epinephrine 1:200,000 Injection",
    "Children's Clear Allergy Formula",
    "Children's Cough & Cold Relief",
    "Children's Europrofen",
    "Children's Fever From Colds Or Flu",
    "Children's Ibuprofen Suspension",
    "Children's Motrin",
    "Children's Tylenol",
    "Children's Tylenol Cold",
    "Children's Tylenol Cold & Stuffy Nose",
    "Children's Tylenol Cold And Cough",
    "Children's Tylenol Cold And Cough Nighttime",
    "Children's Tylenol Complete Cold, Cough & Fever",
    "Children's Tylenol Complete Cold, Cough & Fever Nighttime",
    "Children's Tylenol Fever & Sore Throat Pain",
    "Chloral Hydrate Syrup Odan",
    "Choledyl Expectorant Elixir",
    "Cimzia",
    "Cinqair",
    "Crysvita",
    "Curosurf",
    "Cuvitru",
    "Cuvposa",
    "Cyklokapron 100 Mg/ml",
    "Cyramza",
    "Cysto-conray Ii",
    "Cytarabine Injection",
    "Cytogam",
    "Dalacin C Flavoured Granules",
    "Dalacin C Phosphate",
    "Dalmacol",
    "Damylin With Codeine Syrup",
    "Darzalex",
    "Darzalex Sc",
    "Dayquil Cold & Flu",
    "Dayquil Complete + Vicks Vapocool Cold & Flu Liquid",
    "Daytime Cold/flu Medicine",
    "Dimenhydrinate Injection Usp With Preservative",
    "Dimetane Expectorant C",
    "Dimetane Expectorant Dc",
    "Dimetapp",
    "Dimetapp Dm Cough & Cold",
    "Dimetapp Extra Strength",
    "Dimetapp Extra Strength Dm Cough & Cold",
    "Dimetapp-c",
    "Diovol Plus Aluminum Free Suspension",
    "Diovol Plus Suspension",
    "Sandoz Sumatriptan",
    "Sandoz Tacrolimus",
    "Sandoz Tamsulosin",
    "Sandoz Tamsulosin Cr",
    "Sandoz Telmisartan",
    "Sandoz Telmisartan Hct",
    "Sandoz Tolterodine La",
    "Sandoz Topiramate Tablets",
    "Simvastatin",
    "Simvastatin-10",
    "Simvastatin-20",
    "Simvastatin-40",
    "Simvastatin-80",
    "Sinequan",
    "Sinus Medication",
    "Sinus Medication Day & Night",
    "Sinus Medication Daytime Relief",
    "Sinus Relief",
    "Sleep Aid",
    "Sleep Aid Extra Strength",
    "Sleep Aid Extra Strength Tab 50mg",
    "Sleep Aid Liquid Fastgels",
    "Sleep-eze",
    "Sleep-eze Extra Strength Caplets",
    "Ag-pregabalin",
    "Amerge",
    "Amiodarone",
    "Amitriptyline-10",
    "Amitriptyline-25",
    "Amitriptyline-50",
    "Amlodipine",
    "Anacin",
    "Anafranil",
    "Analgesic And Muscle Relaxant",
    "Auro-valsartan Hct",
    "Auro-venlafaxine Xr",
    "Bio-paroxetine",
    "Bio-perindopril",
    "Bio-pravastatin",
    "Bio-quetiapine",
    "Bio-rosuvastatin",
    "Bio-sertraline",
    "Bio-sildenafil",
    "Bio-simvastatin",
    "Bio-zopiclone",
    "Candesartan",
    "Candesartan Hct",
    "Candesartan-hctz",
    "Candesartan/hctz",
    "Canesoral",
    "Canesten Comfortab 1",
    "Canesten Comfortab 3",
    "Caprelsa",
    "Carbaglu",
    "Carbolith",
    "Carnitor",
    "Carter's Little Pills",
    "Carvedilol",
    "Casodex",
    "Ccp-anastrozole",
    "Ccp-citalopram",
    "Ccp-letrozole",
    "Cléo -35",
    "Clopidogrel",
    "Clopixol Tablets 10mg",
    "Clopixol Tablets 25mg",
    "Clorazepate",
    "Clozaril",
    "Codeine 15",
    "Codeine 30",
    "Codeine Contin 100mg Controlled Release Tab",
    "Codeine Contin 150mg Controlled Release Tab",
    "Codeine Contin 200mg Controlled Release Tab",
    "Codeine Contin 50mg Controlled Release Tab",
    "Codulax Tablets",
    "Colace Capsules",
    "Colace Clear",
    "Acid Concentrate D12305",
    "Acid Concentrate D12316",
    "Additive Solution Sodium Adenine Glucose Mannitol (sagm)",
    "Anticoagulant Solution Citrate Phosphate Dextrose (cpd)",
    "Balance 1.5% Glucose, 1.25 Mmol/l Calcium",
    "Balance 2.3% Glucose, 1.25 Mmol/l Calcium",
    "Balance 4.25% Glucose, 1.25 Mmol/l Calcium",
    "Bicarbonate Concentrate B38",
    "Colchicine Tab 0.6mg",
    "Cold & Flu",
    "Cold & Flu-in-one",
    "Cold & Sinus Liquid Capsules",
    "Cold & Sinus Liquid Fastgels",
    "Cold & Sinus Relief Capsules",
    "Cold + Sinus",
    "Cold + Sinus Daytime Cold + Sinus Nighttime",
    "Cold + Sinus Nighttime",
    "Cold + Sinus Plus",
    "Cold And Flu-in-one Extra Strength",
    "Cold And Sinus Complete Liquid Gels",
    "Cold And Sinus Daytime Relief",
    "Cold And Sinus Relief Combo",
    "Cold Medication",
    "Coldaside Cold & Flu Extra Strength",
    "Coldaside Cough & Cold",
    "Coltalin Cold & Allergy Tablets",
    "Combantrin Tab 125mg",
    "Combivir",
    "Combogesic",
    "Complera",
    "Complete",
    "Complete Daytime Liquid Capsules",
    "Complete Liquid Capsules",
    "Complete Liquid Capsules Nighttime Relief",
    "Comtan",
    "Concerta",
    "Cyclobenzaprine",
    "Cyclobenzaprine - 10",
    "Cyclomen",
    "Cyestra-35",
    "Cyklokapron 500 Mg",
    "Cymbalta",
    "Cyproheptadine 4mg Tablets",
    "Cyproterone",
    "Dalacin C 150 Mg",
    "Dalacin C 300 Mg",
    "Dantrium Capsules",
    "Dapsone",
    "Daurismo",
    "Dayquil Complete + Vicks Vapocool",
    "Dayquil Sinus Liquicaps",
    "Daytime Cold & Flu Liquid Capsules",
    "Dayvigo",
    "Ddavp Tablets 0.1mg",
    "Ddavp Tablets 0.2mg",
    "Delstrigo",
    "Demo-cineol Adultes/adults",
    "Demo-cineol Enfants/children",
    "Dequadin",
    "Descovy",
    "Desipramine",
    "Desloratadine Allergy Control",
    "Desmopressin",
    "Detrol",
    "Detrol La",
    "Devrom Chew Tab 200mg",
    "Dexedrine Spansule Src 10mg",
    "Dexedrine Spansule Src 15mg",
    "Dexedrine Tablets (5mg)",
    "Dexilant",
    "Dextroamphetamine",
    "Diamicron",
    "Diamicron Mr",
    "Diarrhea Relief",
    "Diazepam",
    "Dicetel",
    "Diclectin",
    "Diclofenac-50",
    "Diclofenac-sr",
    "Dificid",
    "Diflucan One",
    "Dilantin",
    "Dilantin Infatabs",
    "Dilaudid",
    "Dilotab Ii",
    "Diltiazem Cd",
    "Dom-azithromycin",
    "Dom-citalopram",
    "Dom-clarithromycin",
    "Dom-clopidogrel",
    "Dom-cyclobenzaprine",
    "Dom-finasteride",
    "Dom-fluoxetine",
    "Dom-fluoxetine - Cap 10mg",
    "Dom-metformin",
    "Taro-ciproflox",
    "Taro-clomipramine",
    "Taro-clopidogrel",
    "Taro-cyproterone/ethinyl Estradiol",
    "Taro-deferasirox",
    "Taro-dipyridamole/ Asa",
    "Taro-docusate",
    "Taro-donepezil",
    "Taro-fampridine",
    "Taro-fenofibrate E",
    "Taro-fingolimod",
    "Taro-gliclazide Mr",
    "Taro-irbesartan",
    "Taro-lansoprazole",
    "Taro-pravastatin",
    "Taro-pregabalin",
    "Taro-rabeprazole",
    "Taro-ramipril",
    "Taro-ramipril Hctz",
    "Taro-rosuvastatin",
    "Taro-simvastatin",
    "Taro-solifenacin",
    "Taro-temozolomide",
    "Taro-testosterone",
    "Taro-tramadol Er",
    "Taro-tramadol/acet",
    "Taro-valsartan",
    "Taro-venlafaxine Xr",
    "Taro-warfarin",
    "Taro-zopiclone",
    "Tasigna",
    "Tavalisse",
    "Tecfidera",
    "Tecta",
    "Tegretol 200mg",
    "Tegretol Cr Tab 200mg",
    "Tegretol Cr Tab 400mg",
    "Telmisartan",
    "Telmisartan Hctz",
    "Telmisartan Tablets",
    "Telmisartan-hctz",
    "Telmisartan/hctz",
    "Temodal",
    "Tenormin 100mg",
    "Tenormin 50mg",
    "Terazosin",
    "Terazosin-2",
    "Terazosin-5",
    "Terbinafine",
    "Terbinafine-250",
    "Tetrabenazine Tablets",
    "Tetracycline",
    "Teva-5 Asa",
    "Teva-abacavir/lamivudine",
    "Teva-acebutolol",
    "Teva-acyclovir",
    "Teva-alendronate",
    "Teva-almotriptan",
    "Teva-alprazolam",
    "Teva-amiodarone",
    "Teva-amitriptyline",
    "Teva-amlodipine",
    "Teva-ampicillin",
    "Teva-anastrozole",
    "Teva-aripiprazole",
    "Teva-atazanavir",
    "Teva-atenolol",
    "Teva-atomoxetine",
    "Teva-atorvastatin",
    "Teva-atovaquone Proguanil",
    "Teva-azathioprine",
    "Teva-azithromycin",
    "Teva-betahistine",
    "Teva-bicalutamide",
    "Teva-bisoprolol",
    "Teva-bromazepam",
    "Teva-bupropion Xl",
    "Teva-buspirone",
    "Teva-candesartan",
    "Teva-candesartan/hctz",
    "Teva-capecitabine",
    "Teva-captopril",
    "Teva-carbamazepine",
    "Teva-carvedilol",
    "Teva-cefadroxil",
    "Teva-cephalexin",
    "Teva-chlorpromazine",
    "Teva-cilazapril/hctz",
    "Teva-cinacalcet",
    "Teva-citalopram",
    "Teva-clarithromycin",
    "Teva-clindamycin",
    "Teva-clobazam",
    "Teva-clonazepam",
    "Teva-clonidine",
    "Teva-clopidogrel",
    "Teva-codeine",
    "Teva-cyclobenzaprine",
    "Teva-cyproterone / Ethinyl Estradiol",
    "Teva-diclofenac Ec",
    "Origins Ginzing Spf 40 Energy-boosting Tinted Moisturizer",
    "Ozanex",
    "Pdp-desonide",
    "Pegalax",
    "Penlac",
    "Pennsaid",
    "Periogard",
    "Pert Anti-dandruff",
    "Pharmasave Sport Sunscreen Continuous Spray Spf Fps 30",
    "Phenrex Mvd",
    "Play Everyday Lotion",
    "Premium Sunscreen Face Lotion Sun Bum Face 50",
    "Premium Sunscreen Lotion Sun Bum 30",
    "Premium Sunscreen Lotion Sun Bum 50",
    "Preparation H-pe Gel",
    "Prevage Anti-aging Eye Cream Spf 15",
    "Prevage Anti-aging Moisture Cream Spf 30",
    "Prevage Anti-aging Moisture Lotion Spf 30",
    "Preventage Firming Defense Crème Normal/dry Broad Spectrum Spf 15",
    "Preventage Firming Defense Crème Normal/oily Broad Spectrum Spf 15",
    "Prevention + Daily Matte Moisturizer Oil-free",
    "Prevention + Daily Ultimate Protection Moisturizer",
    "Prime Source Antibacterial Plum Scent Foam Handwash Triclosan Liquid",
    "Prisma Protect Spf 30",
    "Pro-x By Olay Dermatological Anti-aging Age Protection Lotion Sunscreen Broad Spectrum Spf 30",
    "Proactiv 3 Piece Set",
    "Proactiv 3-step Convenience Pak",
    "Proactiv Cleanse",
    "Proactiv Emergency Blemish Relief",
    "Proactiv Plus Pore Targeting Solution",
    "Proactiv Treat",
    "Proactiv+ Skin Smoothing Exfoliator",
    "Propaderm",
    "Proshield Plus",
    "Protective Lip Conditioner",
    "Protective Ointment",
    "Protective Protectrice Sunscreen Spray Lotion Lotion Écran Solaire En Vaporisateur Spf/fps 15",
    "Protective Protectrice Sunscreen Spray Lotion Lotion Écran Solaire En Vaporisateur Spf/fps 8",
    "Protopic",
    "Purelax",
    "Purell Hand Sanitizing Wipes",
    "Pyrithione Zinc Dandruff Conditioner Suprême Colour Protect",
    "Pyrithione Zinc Dandruff Conditioner Suprême Nourish",
    "Pyrithione Zinc Dandruff Conditioner Suprême Purify & Hydrate",
    "Pyrithione Zinc Dandruff Conditioner Suprême Strengthen",
    "Pyrithione Zinc Dandruff Shampoo And Conditioner Classic Clean 2 In 1",
    "Pyrithione Zinc Dandruff Shampoo Citrus",
    "Pyrithione Zinc Dandruff Shampoo Refresh",
    "Pyrithione Zinc Dandruff Shampoo Scalp Care",
    "Pyrithione Zinc Dandruff Shampoo Suprême Colour Protect",
    "Pyrithione Zinc Dandruff Shampoo Suprême Nourish",
    "Pyrithione Zinc Dandruff Shampoo Suprême Purify & Hydrate",
    "Pyrithione Zinc Dandruff Shampoo Suprême Strengthen",
    "Q10tm/mc Power Anti-wrinkle",
    "Radiant Defense",
    "Rapid Tone Repair Moisturizer",
    "Rapid Wrinkle Repair Moisturizer",
    "Re9 Advanced Extra Moisture Restorative Cream With Spf 20",
    "Rodan + Fields Redefine Triple Defense Lotion",
    "Rodan + Fields Unblemish Invisible Matte Defense",
    "Rodan+fields Essentials Body Sunscreen",
    "Rodan+fields Essentials Lip Shield",
    "Rodan+fields Redefine",
    "Rodan+fields Reverse",
    "Rodan+fields Unblemish",
    "Rosaliac Cc Creme",
    "Rosaliac Uv Legere",
    "Rosaliac Uv Riche",
    "Rosiver",
    "Sandoz Adapalene/benzoyl Peroxide",
    "Sandoz Clobetasol",
    "Sandoz Hydrocortisone",
    "Sanimor Assainisseur Moussant Sans Alcool Pour Les Mains | Sanimor Alcohol Free Foaming Hand Sanitizer",
    "Scalp Mist",
    "Scalp Relief",
    "Scalpsync Anti-dandruff",
    "Seaweed Oil-control Lotion Spf 15",
    "Secaris",
    "Selsun Blue Anti-dandruff Shampoo",
    "Sensitive Skin Sunscreen Continuous Spray Spf 30",
    "Sensitive Skin Sunscreen Lotion Spf 30",
    "Sensitive Skin Sunscreen Lotion Spf 50+",
    "Shade And Illuminate Soft Radiance Foundation Spf 50",
    "Sheer Broad Spectrum Spf 45",
    "Sheer Daily Moisturizer",
    "Sheer Defense Tinted Moisturizer Broad Spectrum Spf 15 L10",
    "Sheer Defense Tinted Moisturizer Broad Spectrum Spf 15 L20",
    "Sheer Defense Tinted Moisturizer Broad Spectrum Spf 15 M50",
    "Sheer Defense Tinted Moisturizer Broad Spectrum Spf 15 Ml30",
    "Sheer Defense Tinted Moisturizer Broad Spectrum Spf 15 Ml40",
    "Sheer Hydration Sunscreen Broad Spectrum Spf 35",
    "Sheer Lotion Spf 45 Bare Skin Feel",
    "Sheer Lotion Spf 60 Bare Skin Feel",
    "Sheer Touch/toucher Soyeux Oil-free Sunscreen/écran Solaire Sans Huile Spf/fps 15",
    "Sheer Touch/toucher Soyeux Oil-free Sunscreen/écran Solaire Sans Huile Spf/fps 30",
    "Sheer Touch/toucher Soyeux Oil-free Sunscreen/écran Solaire Sans Huile Spf/fps 45 Ultra Radiance/ultra-radieux",
    "Shiseido Ibuki Protective Moisturizer",
    "Skin Long-wear Fluid Powder Foundation Spf 20",
    "Skin Tone Correcting & Beautifying Bb Cream",
    "Smart-san Alcohol-free Hand Sanitizer Foam",
    "Smooth And Silky Lisse Et Soyeux Dandruff Pyrithione Zinc Conditioner",
    "Soapopular",
    "Soft Care Defend",
    "Softsoap Antibacterial",
    "Soin Solaire Visage Crème Protectrice Visage Fps 30",
    "Soin Solaire Visage Crème Protectrice Visage Fps 50 Plus",
    "Soothing Care",
    "Soothing Day Cream",
    "Spa Soap Liquid Soap",
    "Spectro Eczemacare Medicated Cream",
    "Spf 15",
    "Spf 30 Anthelios Xl Lotion",
    "Jack & Jill Bedtime Cough & Cold",
    "Jack & Jill Cough & Cold",
    "Jamp Dorzolamide-timolol",
    "Jamp Itraconazole Oral Solution",
    "Jamp Methadone Oral Concentrate",
    "Jamp-methotrexate",
    "Jamp-pyrantel Pamoate Suspension",
    "Jamp-zoledronic Acid",
    "Jelido",
    "Jevtana",
    "Kanuma",
    "Kenalog-10 Injection 10mg/ml",
    "Kenalog-40 Injection 40mg/ml",
    "Ketalar",
    "Ketamine Hydrochloride Injection Usp",
    "Ketorolac Tromethamine Injection Usp",
    "Ketorolac Tromethamine Injection, Usp",
    "Ketotifen Ophthalmic Solution",
    "Kevzara",
    "Keytruda",
    "Kids Gravol Liquid",
    "Kids Honey Works",
    "Kineret",
    "Koffex Dm",
    "Koffex Dm  (sucrose Free)",
    "L-arginine Hydrochloride Injection",
    "Labetalol Hydrochloride Injection",
    "Labetalol Hydrochloride Injection Usp",
    "Lactated Ringer's And 5% Injection, Usp",
    "Lactated Ringer's Injection",
    "Lactated Ringer's Injection Usp",
    "Lactated Ringer's Injection, Usp",
    "Lactated Ringer's Irrigation",
    "Lactated Ringer's Irrigation Sol",
    "Lactulose",
    "Lapelga",
    "Lasix Oral Solution 10mg/ml",
    "Latanoprost And Timolol Ophthalmic Solution",
    "Lemtrada",
    "Leucovorin Calcium Injection",
    "Leucovorin Calcium Injection Usp",
    "Levofloxacin In 5% Dextrose Injection",
    "Levophed",
    "Libtayo",
    "Lidocaine 2% And Epinephrine 1:100,000",
    "Lidocaine 2% And Epinephrine 1:50,000",
    "Lidocaine Hydrochloride And Epinephrine Injection Usp",
    "Lidocaine Hydrochloride Injection Usp",
    "Lidodan Jelly 2%",
    "Linctus Codeine Blanc",
    "Linezolid Injection",
    "Lioresal Intrathecal 0.05mg/ml",
    "Lioresal Intrathecal 0.5mg/ml",
    "Lioresal Intrathecal 2mg/ml",
    "Lorazepam Injection Usp",
    "Lovenox",
    "Lovenox Hp",
    "Lovenox With Preservative 300mg/3ml",
    "Loxapac Im",
    "Lucentis",
    "Lupin-cephalexin",
    "Lupron",
    "Mabcampath",
    "Magnesium Sulfate Inj 20% Usp",
    "Magnesium Sulfate Injection",
    "Magnevist",
    "Magnolax",
    "Mar-cidofovir",
    "Marcaine",
    "Marcaine E",
    "Marcaine Spinal",
    "Med-dorzolamide-timolol",
    "Med-latanoprost-timolol",
    "Men's Rogaine",
    "Meperidine Hydrochloride Injection Usp",
    "Mepron",
    "Mesna For Injection",
    "Metadol",
    "Metadol-d",
    "Methadose",
    "Methotrexate Injection Bp",
    "Methotrexate Injection Usp",
    "Methotrexate Injection, Bp",
    "Methotrexate Sodium Injection",
    "Methotrexate Subcutaneous",
    "Methylene Blue Injection",
    "Methylene Blue Injection Usp",
    "Metoclopramide Hydrochloride Injection",
    "Metoclopramide Omega",
    "Metoject",
    "Metoject Subcutaneous",
    "Metonia",
    "Metoprolol Tartrate Injection Usp",
    "Metronidazole Injection Usp",
    "Metronidazole Injection, Usp",
    "Micro Cu",
    "Micro Mn",
    "Micro Plus 6    (concentrate)",
    "Micro Zn",
    "Feiba Nf",
    "Haegarda",
    "Idelvion",
    "Imovax Rabies Rabies Vaccine Inactivated (dco)",
    "Jivi",
    "Kidrolase",
    "Rixubis",
    "Tretten",
    "Varizig",
    "Vpriv",
    "Winrho Sdf",
    "Xeomin",
    "Xeomin Cosmetic",
    "Xyntha",
    "Itulatek",
    "Jamp-vitamin D",
    "Luxa-d",
    "Oralair",
    "Pancrease Mt 10",
    "Pancrease Mt 16",
    "Pancrease Mt 2",
    "Pancrease Mt 20",
    "Pancrease Mt 4",
    "Ragwitek",
    "Rovamycine 250 Capsule 750000 Unit",
    "Rovamycine 500 Capsule 1500000 Unit",
    "Sandoz Alendronate/cholecalciferol",
    "Sandoz D 10 000",
    "Sandoz D-forte",
    "Vidextra",
    "Viokace",
    "Vitamine D 10 000",
    "Advantage Sanitizing Wipes",
    "Alcaine",
    "Allergy Eye Drops",
    "Alomide",
    "Alrex",
    "Apo-diclofenac Ophthalmic",
    "Apo-travoprost Z",
    "Apo-travoprost-timop Pq",
    "Artificial Tears",
    "Azarga",
    "Azopt",
    "Benadryl Bug Bite Relief",
    "Bepreve",
    "Besivance",
    "Betoptic S",
    "Chlorhexidine",
    "Chlorhexidine Gluconate Solution Usp",
    "Ciprodex",
    "Clear Eyes Extra Strength Redness Relief",
    "Patanol",
    "Pazeo",
    "Pharixia",
    "Vigamox",
    "Vionex Antimicrobial Liquid Soap",
    "Vionexus No-rinse Spray",
    "Virobex-p",
    "Viroptic",
    "Visine Original",
    "Vitamin A Acid",
    "Voltaren Emulgel Extra Strength",
    "Volulyte",
    "Voluven",
    "Water-jel Burn Jel-2%",
    "White Petroleum Jelly 100% Bp",
    "Winning Hands Alcohol Free Hand Sanitizer",
    "Winning Hands Foaming Antibacterial Hand Cleanser",
    "Xylocaine Ointment 5%",
    "Z-plus Shampoo",
    "Zap Topical Anesthetic Gel",
    "Zep Foam San",
    "Zinc Zap Spray",
    "Zincofax",
    "Zincofax Extra Strength",
    "Zymar",
    "Imvamune",
    "Priorix-tetra",
    "Yescarta",
    "Dukoral",
    "Kymriah",
    "Vivotif",
    "Ultra-technekow V4",
    "Boostrix-polio",
    "Flumist Quadrivalent",
    "Ceftriaxone For Injection",
    "Calcium-45  0.25-4.5",
    "Calcium-45  0.5-4.5",
    "Dextrose-45  5.55-4.5",
    "Peglyte Powder",
    "Bicart",
    "Bicart Select Combi-pak",
    "Biflexy 900",
    "Hemacart",
    "Cystadane",
    "Hydralax",
    "Daily Moisturizing Cream Spf 15",
    "Kayexalate",
    "Odan-sodium Polystyrene Sulfonate",
    "Solystat",
    "Spf Fps 50 Kids Sunscreen",
    "Sunlotion Lotionsolaire Spf/fps 4",
    "Uv 50 Ecran Multi-protection Spf 50",
    "White Petroleum Jelly U.s.p.",
    "800 Sodium Bicarbonate Powder",
    "Acid Concentrate 2116",
    "Acid Concentrate 2117",
    "Acid Concentrate 2126",
    "Acid Concentrate 2151",
    "Acid Concentrate 2156",
    "Acid Concentrate 2182",
    "Acid Concentrate A1221",
    "Acid Concentrate A1222",
    "Acid Concentrate A1223",
    "Acid Concentrate A1224",
    "Acid Concentrate A1225",
    "Acid Concentrate A1226",
    "Acid Concentrate A1227",
    "Acid Concentrate A1228",
    "Acid Concentrate A1229",
    "Acid Concentrate A1230",
    "Acid Concentrate A1231",
    "Acid Concentrate A1242",
    "Acid Concentrate A1243",
    "Acid Concentrate A1246",
    "Acid Concentrate A1252",
    "Acid Concentrate A1253",
    "Acid Concentrate A1255",
    "Acid Concentrate A1261",
    "Acid Concentrate A1262",
    "Acid Concentrate A1265",
    "Acid Concentrate A1266",
    "Acid Concentrate A1267",
    "Acid Concentrate A1268",
    "Acid Concentrate D12293",
    "Acid Concentrate D12294",
    "Acid Concentrate D12299",
    "Acid Concentrate D12300",
    "Acid Concentrate D12302",
    "Cough & Cold Relief Extra Strength",
    "Cough And Allergy Syrup With Codeine",
    "Cough Syrup",
    "Teva-montelukast",
    "Teva-morphine Sr",
    "Teva-moxifloxacin",
    "Teva-mycophenolate",
    "Ms.ir",
    "Mucinex Chest Congestion",
    "Mucinex Multi-action Cold & Sinus Caplets",
    "Mylan-verapamil",
    "Mylan-verapamil Sr",
    "Myleran",
    "Myrbetriq",
    "Nabumetone",
    "Nadryl 25mg",
    "Nalcrom",
    "Naltrexone Hydrochloride Tablets Usp",
    "Naprosyn",
    "Naproxen",
    "Naproxen 250",
    "Naproxen 500",
    "Naproxen Ec",
    "Naproxen Menstrual Pain Relief",
    "Naproxen Sodium",
    "Naproxen Sodium Ds",
    "Naproxen Sodium Tablets",
    "Naproxen-375",
    "Naproxen-na",
    "Naproxen-na Df",
    "Naturalyte H-229",
    "Naturalyte H-232",
    "Naturalyte H-260",
    "Naturalyte H-320",
    "Naturalyte H-330",
    "Naturalyte H-331",
    "Naturalyte H-332",
    "Naturalyte H-401",
    "Naturalyte H-402",
    "Naturalyte H-408",
    "Naturalyte H-410",
    "Naturalyte H-602",
    "Naturalyte H-608",
    "Physioneal 40 Glucose 2.27% W/v 22.7 Mg/ml, Solution For Peritoneal Dialysis",
    "Physioneal 40 Glucose 3.86% W/v 38.6 Mg/ml Clear-flex",
    "Physioneal 40 Glucose 3.86% W/v 38.6mg/ml, Solution For Peritoneal Dialysis",
    "Prism0cal B22k0/0",
    "Selectbag One (ax125g)",
    "Selectbag One (ax150g)",
    "Selectbag One (ax200g)",
    "Selectbag One (ax225g)",
    "Selectbag One (ax250g)",
    "Selectbag One (ax2525g)",
    "Selectbag One (ax275g)",
    "Selectbag One (ax325g)",
    "Selectbag One (ax350g)",
    "Potassium Chloride 40 Meq In 3.3% Dextrose And 0.3% Sodium Chloride",
    "Potassium Chloride 40 Meq In 5% Dextrose",
    "Potassium Chloride 40 Meq In 5% Dextrose And 0.45% Sodium Chloride",
    "Potassium Chloride 40 Meq In 5% Dextrose And 0.9% Sodium Chloride",
    "Prism0cal",
    "Prismasol 0",
    "Lisinopril/hctz (type Z)",
    "Lithane",
    "Losartan Hct",
    "Losartan/hctz",
    "Losec",
    "Lovastatin",
    "Lozide",
    "Lunesta",
    "Lupin-estradiol",
    "Luvox",
    "Lynparza",
    "Lyrica",
    "Lysodren",
    "M-amlodipine",
    "M-asa 80 Mg Croquable",
    "M-atorvastatin",
    "M-azithromycin",
    "M-celecoxib",
    "M-cinacalcet",
    "M-clarithromycin",
    "M-clindamycin",
    "M-clopidogrel",
    "M-docusate Sodium 100 Mg",
    "M-donepezil",
    "M-duloxetine",
    "M-escitalopram",
    "M-eslon",
    "M-ezetimibe",
    "M-lansoprazole",
    "M-montelukast",
    "M-moxifloxacin",
    "M-pantoprazole",
    "M-paroxetine",
    "M-perindopril Erbumine",
    "M-pravastatin",
    "M-pregabalin",
    "M-ranitidine",
    "Mar-azithromycin",
    "Mar-celecoxib",
    "Mar-cetirizine",
    "Mar-cinacalcet",
    "Mar-ciprofloxacin",
    "Mar-citalopram",
    "Mar-clopidogrel",
    "Mar-dapsone",
    "Mar-diltiazem Cd",
    "Mar-diltiazem T",
    "Mar-domperidone",
    "Mar-donepezil",
    "Mar-duloxetine",
    "Mar-enalapril",
    "Mar-escitalopram",
    "Mar-ezetimibe",
    "Mar-febuxostat",
    "Mar-fingolimod",
    "Mar-flecainide",
    "Mar-fluconazole-150",
    "Mar-gabapentin",
    "Mar-ketorolac",
    "Mar-lacosamide",
    "Mar-letrozole",
    "Mar-methimazole",
    "Mar-midodrine",
    "Mar-modafinil",
    "Mar-montelukast",
    "Mar-moxifloxacin",
    "Mar-ondansetron",
    "Mar-oseltamivir",
    "Mar-pantoprazole",
    "Mar-paroxetine",
    "Mar-perindopril",
    "Mar-pravastatin",
    "Mar-ramipril",
    "Eprex Sterile Solution 1000iu/0.5ml",
    "Eprex Sterile Solution 2000iu/0.5ml",
    "Eprex Sterile Solution 3000iu/0.3ml",
    "Eprex Sterile Solution 40000iu/ml",
    "Eprex Sterile Solution 4000iu/0.4ml",
    "Eprex Sterile Solution 5000iu/0.5ml",
    "Eprex Sterile Solution 6000 Iu/0.6 Ml",
    "Eprex Sterile Solution 8000 Iu/0.8 Ml",
    "Evicel",
    "Fiasp",
    "Fragmin",
    "Fraxiparine",
    "Fraxiparine Forte",
    "Gonal-f Pen",
    "Havrix - Sus Im 1440 Elisa Units/ml",
    "Havrix 720 Junior",
    "Hepagam B",
    "Heparin Leo 100unit/ml",
    "Heparin Leo Inj 1000unit/ml",
    "Heparin Sodium In 0.9% Sodium Chloride Injection",
    "Heparin Sodium In 5% Dextrose Injection, 25000unit/500ml",
    "Heparin Sodium Injection Usp",
    "Heparin Sodium Injection Usp        (multidose Vial-with Preservative)",
    "Heparin Sodium Injection Usp       (multidose Vial-with Preservative)",
    "Heparin Sodium Injection, Usp",
    "Humalog",
    "Humalog  (cartridge)",
    "Humalog  (kwikpen)",
    "Humalog 200 Units/ml Kwikpen",
    "Humalog Mix 25  (cartridge)",
    "Humalog Mix 25  (kwikpen)",
    "Humalog Mix 50  (cartridge)",
    "Humalog Mix 50  (kwikpen)",
    "Humate-p",
    "Humulin 30/70 (insulin Human Biosynth Inj)",
    "Hypurin Nph Insulin Isophane Pork",
    "Hypurin Regular Insulin Pork",
    "Immunine Vh",
    "Imogam Rabies Pasteurized",
    "Imovax Polio",
    "Innohep",
    "Intron A",
    "Jamp-nystatin Oral Suspension Usp",
    "Kamrab",
    "Lantus",
    "Levemir Flextouch",
    "Levemir Penfill",
    "M-m-r Ii",
    "Non Standardized Allergenic Extracts - Non Pollens",
    "Non Standardized Allergenic Extracts - Pollens",
    "Novolin Ge 30/70",
    "Novolin Ge 30/70 Penfill",
    "Novolin Ge 40/60 Penfill",
    "Novolin Ge 50/50 Penfill",
    "Novolin Ge Nph",
    "Novolin Ge Nph Penfill",
    "Novolin Ge Toronto",
    "Novolin Ge Toronto Penfill",
    "Novomix 30",
    "Novorapid",
    "Obizur",
    "Omega Allergenic Extracts - Non-pollens (aqueous)",
    "Oncaspar",
    "Optimyxin",
    "Orgaran",
    "Oxytocin Injection Usp",
    "Oxytocin Injection, Usp",
    "Pms-nystatin Suspension 100000 Unit/ml",
    "Pollinex R",
    "Puregon",
    "Standardized Cat Hair Ap",
    "Standardized Grass Pollen - Kentucky Bluegrass (100000 Bau/ml)",
    "Standardized Grass Pollen - Orchard Grass (100000 Bau/ml)",
    "Standardized Grass Pollen - Perennial Ryegrass (100000 Bau/ml)",
    "Standardized Grass Pollen - Redtop (100,000 Bau/ml)",
    "Standardized Grass Pollen - Sweet Vernal Grass (100,000 Bau/ml)",
    "Standardized Grass Pollen - Timothy (100000 Bau/ml)",
    "Teva-nystatin",
    "Toujeo Doublestar",
    "Toujeo Solostar",
    "Tresiba",
    "Twinrix",
    "Twinrix Junior",
    "Vaqta",
    "Varivax Iii",
    "Vasopressin Injection",
    "Auro-losartan Hct",
    "Auro-meloxicam",
    "Auro-metformin",
    "Auro-metronidazole",
    "Auro-mirtazapine",
    "Auro-mirtazapine Od",
    "Auro-modafinil",
    "Auro-montelukast",
    "Auro-moxifloxacin",
    "Auro-nevirapine",
    "Auro-nitrofurantoin Bid",
    "Auro-olanzapine Odt",
    "Auro-pantoprazole",
    "Auro-paroxetine",
    "Auro-perindopril",
    "Auro-pramipexole",
    "Auro-pravastatin",
    "Auro-pregabalin",
    "Auro-progesterone",
    "Auro-quetiapine",
    "Auro-quinapril Hctz",
    "Auro-ramipril",
    "Auro-repaglinide",
    "Auro-risedronate",
    "Auro-rosuvastatin",
    "Auro-sertraline",
    "Auro-sildenafil",
    "Auro-simvastatin",
    "Auro-solifenacin",
    "Auro-tadalafil",
    "Auro-telmisartan",
    "Auro-valganciclovir",
    "Auro-valsartan",
    "Benadryl Allergy, Sinus & Pain Total",
    "Benazepril",
    "Benylin All-in-one Cold, Flu & Cough Liquid Gels",
    "Benylin Extra Strength All-in-one Cold, Flu & Cough",
    "Benylin Extra Strength All-in-one Cold, Flu & Cough Night",
    "Benylin Extra Strength Cold & Sinus Day",
    "Benylin Extra Strength Cold & Sinus Night",
    "Benylin Extra Strength Mucus & Phlegm Plus Cold Relief",
    "Betahistine",
    "Bezalip Sr",
    "Biaxin Bid",
    "Biktarvy",
    "Biltricide",
    "Bio-amlodipine",
    "Bio-anastrozole",
    "Bio-atorvastatin",
    "Bio-celecoxib",
    "Bio-ciprofloxacin",
    "Bio-clopidogrel",
    "Bio-domperidone",
    "Bio-donepezil",
    "Bio-escitalopram",
    "Bio-ezetimibe",
    "Bio-fluconazole",
    "Bio-fluoxetine",
    "Bio-gabapentin",
    "Bio-letrozole",
    "Bio-montelukast",
    "Bio-moxifloxacin",
    "Bio-omeprazole",
    "Bio-pantoprazole",
    "Xylocaine 2% With Epinephrine 1:200000",
    "Xylocaine Dental Lidocaine Hcl 2% And Epinephrine 1:100,000",
    "Xylocaine Dental Lidocaine Hydrochloride 2% And Epinephrine 1:50,000",
    "Xylocaine Endotracheal",
    "Xylocaine Jelly 2%",
    "Xylocard",
    "Xyrem",
    "Yervoy",
    "Zaditor",
    "Zarontin Syr 250mg/5ml",
    "Zevalin",
    "Ziextenzo",
    "Zirabev",
    "Zithromax - Pws Orl 100mg/5ml",
    "Zoledronic Acid - Z",
    "Zoledronic Acid For Injection",
    "Zoledronic Acid For Injection Concentrate",
    "Zoledronic Acid Injection",
    "Zometa Concentrate",
    "Zorcaine",
    "Zyvoxam",
    "Zyvoxam 2 Mg/ml",
    "Zzzquil Liquid",
    "Cambia",
    "Mavenclad",
    "Mavik",
    "Maviret",
    "Maxalt",
    "Maxalt Rpd",
    "Maxidol Liquid Gels",
    "Maximum Strength Acid Reducer",
    "Maximum Strength Acid Reducer Without Prescription",
    "Maximum Strength Pepcid Ac",
    "Mayzent",
    "Mdk-nitisinone",
    "Med-cyproterone",
    "Med-dutasteride",
    "Med-exemestane",
    "Med-rivastigmine",
    "Medicament Pour Les Sinus, Extra-fort",
    "Medicament Pour Les Sinus, Regulier",
    "Medrol 16 Mg",
    "Medrol 4 Mg",
    "Mefenamic",
    "Mefloquine",
    "Megestrol",
    "Mekinist",
    "Meloxicam",
    "Memantine",
    "Menstrual Complete",
    "Menstrual Midol Complete",
    "Mercaptopurine Tablets Usp",
    "Mersyndol With Codeine",
    "Mestinon",
    "Mestinon-sr",
    "Metformin",
    "Metformin Fc",
    "Methazolamide",
    "Methoprazine",
    "Methotrexate Tablets, Usp",
    "Methoxisal Extra Strength",
    "Methyldopa",
    "Metoprolol",
    "Metoprolol - 25",
    "Metoprolol Sr",
    "Metoprolol-100",
    "Metoprolol-50",
    "Metoprolol-l",
    "Metronidazole",
    "Micardis 40mg Tab",
    "Micardis 80mg Tab",
    "Micardis Plus",
    "Miconazole 3 Day Ovule Treatment 400mg",
    "Mictoryl",
    "Mictoryl Pediatric",
    "Midamor",
    "Minocycline",
    "Mint-abacavir",
    "Mint-acitretin",
    "Mint-alendronate",
    "Mint-amlodipine",
    "Mint-dutasteride",
    "Mint-entecavir",
    "Mint-eplerenone",
    "Mint-ezetimibe",
    "Mint-finasteride",
    "Mint-fluoxetine",
    "Mint-furosemide",
    "Mint-gliclazide Mr",
    "Mint-hydralazine",
    "Mint-hydrochlorothiazide",
    "Mint-hydroxychloroquine",
    "Mint-imatinib",
    "Mint-indomethacin",
    "Mint-itraconazole",
    "Mint-ketorolac",
    "Mint-lacosamide",
    "Mint-leucovorin",
    "Mint-losartan/hctz",
    "Mint-losartan/hctz Ds",
    "Mint-montelukast",
    "Mint-nadolol",
    "Mint-olanzapine",
    "Mint-olanzapine Odt",
    "Mint-ondansetron",
    "Mint-ondansetron Odt",
    "Mint-oseltamivir",
    "Mint-pantoprazole",
    "Mint-paroxetine",
    "Mint-perindopril",
    "Mint-pravastatin",
    "Mint-pregabalin",
    "Mint-quetiapine",
    "Mint-ramipril",
    "Mint-risperidon",
    "Mint-sertraline",
    "Mint-sildenafil",
    "Mint-simvastatin",
    "Dove Derma+care Scalp Anti-dandruff Fresh & Clean 2 In 1",
    "Dove Derma+care Scalp Anti-dandruff Smoothing Moisture",
    "Dove Men Plus Care Derma Plus Care Scalp Anti-dandruff Deep Clean 2 In 1",
    "Dove Men+care Derma+care Scalp Anti-dandruff Dandruff Defense 2 In 1",
    "Dove Men+care Derma+care Scalp Anti-dandruff Dryness & Itch Relief 2 In 1",
    "Dove Men+care Derma+care Scalp Anti-dandruff Gentle Clean 2 In 1",
    "Dove Men+care Fortifying Shampoo + Conditioner Anti-dandruff 2 In 1",
    "Dr. Numb",
    "Dr. Scholl's Athlete's Foot Spray Powder",
    "Dream Urban Cover",
    "Dry Balance Sunscreen Lotion Spf 30",
    "Dry Balance Sunscreen Lotion Spf 50+",
    "Dry Balance Sunscreen Spray Spf 30",
    "Dry Balance Sunscreen Spray Spf 50+",
    "Dual Intensive Acne Treatment",
    "Duo Defence Sunscreen Lotion Spf 30",
    "Duo Defence Sunscreen Lotion Spf 50+",
    "Duobrii",
    "Dye Free Fragrance Free Antibacterial Foaming Hand Soap",
    "Erfa Hydroquinone",
    "Essential-c Day Moisture Broad Spectrum Spf 30 Pa+++",
    "Essentials By Artistry Multi-protect Lotion",
    "Estee Lauder Advanced Time Zone Age Reversing Line/wrinkle Creme Oil-free Spf 15 For Normal/combination Skin",
    "Estee Lauder Advanced Time Zone Age Reversing Line/wrinkle Creme Spf 15 For Normal/combination Skin",
    "Estee Lauder Daywear Advanced Multi-protection Uv Defense Spf 50",
    "Estee Lauder Daywear Multi-protection 24h-moisture Creme Oil-free Spf 25",
    "Estee Lauder Daywear Multi-protection 24h-moisture Creme Spf 15 For Dry Skin",
    "Estee Lauder Daywear Multi-protection 24h-moisture Creme Spf 15 For Normal/ Combination Skin",
    "Estee Lauder Daywear Multi-protection Sheer Tint Release Moisturizer Spf 15 All Skintypes",
    "Estee Lauder Double Wear Nude Water Fresh Makeup Spf 30",
    "Estee Lauder Perfectionist Youth-infusing Makeup Spf 25",
    "Estee Lauder Resilience Lift Firming/sculpting Face And Neck Creme Oil-free Spf 15 For Normal/combination Skin",
    "Estee Lauder Resilience Lift Firming/sculpting Face And Neck Creme Spf 15 For Dry Skin",
    "Face It Power Perfection Bb Cream Spf 37/pa++",
    "Face Sunscreen Spf 45",
    "Facial Fuel",
    "Finacea",
    "Finipil",
    "Finipil 4 Men Only",
    "Finipil Lait 50",
    "Firmarine Day Cream Spf 30 Crème De Jour Spf 30",
    "Five Star Lip Protection",
    "Flawless Effect Liquid Foundation Broad Spectrum Spf 15",
    "Flawless Future",
    "Foam Sanitizer",
    "Foam-care Ultra",
    "Foot Care Foam",
    "Footworks Healthy Antifungal Spray For Athlete's Foot",
    "Footworks Healthy Cracked Heel Cream",
    "Formula 3",
    "Foundation Primer Plus Spf 15",
    "Fps 30 Soin Complet",
    "Fps 60 Soin Complet",
    "Fragrance Foam",
    "Hawaiian Tropic Matte Effect Mineral Enriched Sunscreen Lotion Spf 30",
    "Hawaiian Tropic Matte Effect Mineral Enriched Sunscreen Lotion Spf 50",
    "Hawaiian Tropic Protective Argan Dry Oil Sunscreen Spray Spf 15",
    "Hawaiian Tropic Protective Dry Oil Sunscreen Spray Spf/fps 10",
    "Hawaiian Tropic Sheer Touch Clear Sunscreen Spray Spf 30 Ultra Radiance",
    "Hawaiian Tropic Sheer Touch Clear Sunscreen Spray Spf 50+ Ultra Radiance",
    "Hawaiian Tropic Silk Hydration Face Oil-free Sunscreen",
    "Hawaiian Tropic Silk Hydration Weightless Clear Sunscreen Spray Spf 50 Plus",
    "Hawaiian Tropic Silk Hydration Weightless Daily Use Sunscreen Mist Spray Spf 30",
    "Hawaiian Tropic Silk Hydration Weightless Sunscreen Lotion With Hydrating Ribbons Spf 30",
    "Hawaiian Tropic Silk Hydration Weightless Sunscreen Lotion With Hydrating Ribbons Spf 50",
    "Hawaiian Tropic Sunscreen Lotion Écran Solaire 4",
    "Head & Shoulders Citrus Breeze",
    "Head & Shoulders Classic Clean",
    "Head & Shoulders Classic Clean 2 In 1",
    "Clinimix",
    "Clopixol-acuphase 50mg/ml",
    "Codeine Phosphate Injection Usp",
    "Codeine Phosphate Syrup",
    "Colace",
    "Colace Syrup",
    "Conray 60",
    "Copaxone",
    "Cophylac",
    "Cortenema",
    "Corvert",
    "Cosentyx",
    "Cosopt",
    "Cough & Chest Congestion",
    "Cough & Chest Congestion Extra Strength",
    "Coppertone Spray Sunscreen Spf 50 Defend & Care",
    "Coppertone Spray Sunscreen Spf 50 Kids",
    "Coppertone Spray Sunscreen Spf 50 Sport",
    "High Performance Sunscreen Spray Spf 50",
    "High Protection Lotion Spf 50+",
    "High Protection Spray Spf 50+",
    "Hydra Vizor",
    "Hydraphase Uv Intense",
    "Hydro Boost Gel Cream Spf 15",
    "Hydro Boost Gel Cream Spf 25",
    "Hydro Boost Water Gel Lotion Sunscreen Spf 30",
    "Hydro Boost Water Gel Lotion Sunscreen Spf 50",
    "Idéal Soleil Spf30",
    "Indefense30",
    "Instant Bronzer Instantané 15",
    "Instant Bronzer Instantané 15 Continuous Spray Sunscreen",
    "Instant Bronzer Instantané 30 Continuous Spray Sunscreen",
    "Instant Bronzer Instantané 30 Spray Gel Sunscreen",
    "Instant Bronzer Instantané 4 Spray Gel Sunscreen",
    "Instillagel",
    "Into Repair Dry Skin / Peaux Sèches",
    "Marcelle Ultra Gentle Hand Sanitizing Gel",
    "Marcelle/bb/cream/crème/anti-aging/anti-âge/spf 20 Fps",
    "Marcelle/cc/cream/crème Complete Correction/correction Complète/spf 35 Fps",
    "Mary Kay Cc Cream",
    "Mary Kay Foundation Primer Spf 15",
    "Matrix Support With Sunscreen Broad Spectrum Spf 30",
    "Matte Defense Spf 30",
    "Matte Moisturizer Spf 15",
    "Mattifying Day Cream",
    "Max Sheer All Day Moisture Defense Lotion",
    "Sport 30 Continuous Spray Sunscreen Écran Solaire En Vaporisateur",
    "Sport 30 Lotion Sunscreen Lotion Écran Solaire",
    "Sport 50 Continuous Spray Sunscreen Ecran Solaire En Vaporisateur",
    "Sport For Kids Sunscreen Lotion Spray Spf 50+",
    "Sport Performance Sunscreen Stick Ecran Solaire En Bâtonnet Spf Fps 50",
    "Sport Sunscreen",
    "Sport Sunscreen Continuous Spray Spf 15",
    "Sport Sunscreen Continuous Spray Spf 30",
    "Sport Sunscreen Continuous Spray Spf 50+",
    "Sport Sunscreen Lotion Spf 30",
    "Sport Sunscreen Lotion Spf 50+",
    "Sport Sunscreen Stick Broad Spectrum Spf 30",
    "Sports Bb",
    "Spray Antibacterial Soap",
    "Spraygel",
    "Spraygel With Instant Bronze Tint Spf/fps 15",
    "Steri-clean",
    "Stokoderm Sunprotect 30 Pure",
    "Sween 24",
    "Tactupump",
    "Tactupump Forte",
    "Taro-adapalene/benzoyl Peroxide",
    "Taro-benzoyl Peroxide / Clindamycin Kit",
    "Taro-ciclopirox",
    "Taro-clindamycin/benzoyl Peroxide Gel",
    "Taro-clobetasol Spray",
    "Taro-clotrimazole/betamethasone Dipropionate",
    "Taro-diclofenac",
    "Taro-imiquimod Pump",
    "Taro-mometasone Cream",
    "Taro-mometasone Lotion",
    "Tc Antibacterial Lotion Soap",
    "Teint Idole Ultra Wear",
    "Teint Lift Anti-rides Fps 20 Spf 20",
    "Teint Lumière",
    "Teva-topisone",
    "The Soft Moisture Powder Foundation Spf 30",
    "Therabreath Healthy Gums Oral Rinse",
    "Dial Complete 2 In 1 Moisturizing & Antibacterial Foaming Hand Wash Pearl Essence",
    "Head & Shoulders Dandruff Conditioner",
    "Head & Shoulders Nourishing Hair & Scalp Care Conditioner",
    "Heliox",
    "Heliox 70/30",
    "Helium 100%",
    "Helium Oxygen Mixture",
    "Helium Usp 99%",
    "Hemorrhoidal Relief Ointment",
    "Hfs Antimicrobial Foam Hand Soap With Triclosan",
    "Huile De Bain Therapeutique",
    "Hydra-essentiel Fluide Fondant Désaltérant Peaux Normales À Mixtes Fps/spf 15",
    "Hydrance Optimale Spf 25",
    "Hydraphase Uv",
    "Hydratant Défense Fps 30",
    "Hydroval Cream 0.2%",
    "Hydroval Ointment 0.2%",
    "Hygienipak 2% Chg Foaming Skin Cleanser",
    "Ideal Soleil Spf 50+",
    "Idéal Soleil Spf 60",
    "Ino-f Antibac Antibacterial Hand Soap",
    "Ino-f-san Instant Hand Sanitizer",
    "Isoflurane Usp",
    "Isopto Carpine",
    "Lidodan 4% Topical Solution",
    "Lidodan Ointment 5%",
    "Lidodan Viscous 2%",
    "Life -shampooing Et Revitalisant Antipelliculaire Classique - 2 En 1",
    "Life Brand Itchy Dry Scalp Anti-dandruff Shampoo",
    "Life Dandruff Shampoo",
    "Lip Balm Spf 30",
    "Liqui-med Analgesic Gas",
    "Liquid Nitrogen",
    "Liquid Nitrogen Nf",
    "Lmd 10% In 0.9% Sodium Chloride",
    "Lmd 10% In Dextrose 5%",
    "Locacorten Vioform",
    "Locacorten Vioform Eardrops",
    "Loris - I.v.",
    "Lotion Calamine Avec Antihistaminique",
    "Lotriderm Cream",
    "Lubricating Nasal Gel",
    "Lung Diffusion Test Mix No Ne Co",
    "Lyderm Cream 0.05%",
    "Lyderm Gel 0.05%",
    "Lyderm Ointment 0.05%",
    "Mac Studio Finish Concealer Spf 35",
    "Mannitol Injection",
    "Ombrelle Sport Lotion Spf 30",
    "Ombrelle Sport Lotion Spf 45",
    "Ombrelle Sport Spray",
    "Ombrelle Stick Spf 60",
    "Ombrelle-lotion Spf 15",
    "One Touch Topical Anesthetic Gel",
    "Opti-tears Allergy",
    "Optiray 320",
    "Optiray 320 (ultraject)",
    "Orabase Paste",
    "Oraqix",
    "Orasoft 3",
    "Original / Originale Dandruff Pyrithione Zinc Shampoo & Conditioner",
    "Origins Plantscription Spf 25 Power Anti-aging Cream",
    "Origins Plantscription Spf 25 Power Anti-aging Oil-free Cream",
    "Oro Clear",
    "Oro-clense",
    "Osmitrol Injection 10%",
    "Osmitrol Injection 20%",
    "Otrivin Medicated Complete Nasal Care",
    "Refresh",
    "Refresh Celluvisc",
    "Refresh Contacts",
    "Refresh Eye Allergy Relief",
    "Refresh Lacri-lube",
    "Refresh Liquigel",
    "Refresh Optive Advanced",
    "Refresh Optive Fusion",
    "Refresh Plus Dps 5mg/ml",
    "Refresh Redness Relief",
    "Refresh Tears",
    "Relaxa",
    "Renew Face Dry Touch Sun Protection Broad Spectrum Uva/uvb Sunscreen Lotion Spf 30",
    "Renewal Cleanser",
    "Replenishing Moisture Lotion Spf 15",
    "Reversa Urban Protection Hydrating Care Spf 30 Soin Hydratant Protection Urbaine Fps 30",
    "Reversa Uv Creme Visage Et Cou Fps 15",
    "Reversa Uv Fluide Hydratant Non Gras Fps 15",
    "Rhinaris Nasal Gel",
    "Rince Bouche Antiseptique",
    "Rodan+fields Spotless",
    "Sterigel Plus",
    "Sterile Diluent For Allergenic Extract - Albumin Saline With Phenol",
    "Sterile Diluent For Allergenic Extracts Normal Saline With Hsa",
    "Sterile Diluent For Merck Sharp & Dohme Corp. Live Attenuated Virus Vaccines",
    "Sterile Water For Injection Usp",
    "Sterile Water For Irrigation Usp",
    "Sterile Water For Irrigation, Usp",
    "Stieprox Shampoo",
    "Stieva-a Cream",
    "Sun And Snow Sport Lotion Spf 30",
    "Sun And Snow Sport Spray Spf 30",
    "Sun Logic 20 Fps Uva Uvb Spf Moyenne Medium Protection Large Spectre Broad Spectrum Lait Solaire Corps Sunscreen Lotion Body",
    "Sun Logic 30 Fps Uva Uvb Spf Haute High Protection Large Spectre Broad Spectrum Crème Solaire Visage Et Corps Sunscreen Face And Body",
    "Timolol Maleate-ex",
    "Timoptic",
    "Timoptic-xe",
    "Tinactin Chill Liquid Spray",
    "Tolnaftate Cream Usp, 1%",
    "Topicaine 5",
    "Topicort",
    "Tranquil Meadows Ab",
    "Triaderm Crm 0.1%",
    "Tridesilon 0.05% Desonide Cream",
    "Tridesilon 0.05% Desonide Ointment",
    "Tropical Vanilla Body Spf 32",
    "Tropical Vanilla Sun Cream",
    "Trusopt",
    "Ultra Calming Daily Moisturizer Spf 15",
    "Ultra Protection Sunscreen Stick Spf 60",
    "Ultra Sheer Body Mist Sunscreen Spf 45",
    "Ultra Sheer Sunscreen Lotion",
    "Ultra-fluid Sun Protection Spf 30",
    "Ultra-light Moisturizing Lotion Spf 30",
    "Mucinex Multi-action Cold, Flu & Sore Throat Caplets",
    "Multaq",
    "Muscle & Back Pain Relief Caplets",
    "Muscle & Joint",
    "Muscle Aches And Body Pain Relief",
    "Muscle And Back Pain Platinum Relief",
    "Muscle And Back Pain Relief",
    "Muscle And Back Pain Relief Regular Strength Tablets",
    "Muscle Relaxant And Back Pain Relief Extra Strength Tablets",
    "Mya",
    "Mycobutin",
    "Mycophenolate Mofetil",
    "Mycophenolate Mofetil Tablets, Usp",
    "Myfortic",
    "Myl-esomeprazole",
    "Mylan-abacavir/lamivudine",
    "Mylan-acyclovir",
    "Mylan-almotriptan",
    "Mylan-nifedipine Extended Release",
    "Mylan-ondansetron",
    "Mylan-pantoprazole T",
    "Mylan-propafenone",
    "Mylan-riluzole",
    "Betaderm Crm 0.05%",
    "Betaderm Crm 0.1%",
    "Betaderm Lotion 0.1%",
    "Betaderm Ont 0.05%",
    "Betaderm Ont 0.1%",
    "Bienfait Multi-vital     (spf 30)",
    "Bienfait Multi-vital Spf 30",
    "Bikini Zone",
    "Blemish Gel 5%",
    "Blephamide",
    "Blistex Dct",
    "Blistex Lip Balm",
    "Bobbi Brown Intensive Skin Serum Foundation Spf 40 Lychee, Bamboo Grass & Cordyceps Extracts",
    "Bright Skin Moisturizer Spf 30",
    "Broad Spectrum Spf/fps 30",
    "Broad Spectrum Spf/fps 50",
    "Bronz Repair Sea And Tropics Face",
    "Bss Plus",
    "Bss Sterile Irrigating Solution",
    "Burn Relief Gel With Lidocaine",
    "Bzk Towelette",
    "Calamine Lotion With Antihistamine",
    "Canesoral Combi",
    "Canesten External Cream",
    "Cantharone Plus",
    "Carbogen",
    "Carbon Dioxide 100%",
    "Carbon Dioxide U.s.p",
    "Carbon Dioxide Usp",
    "Carbon Dioxide Usp, Oxygen Usp Medical G.m.",
    "Carbon Dioxide, Compressed Air Medical G.mix.",
    "Carbon Monox, Helium, Oxygen, Nitrogen L.d.m.",
    "Cc Cream Correction Complete Complete Correction Fps 50 / Spf 50",
    "Cerumol",
    "Cetacaine Liquid",
    "Cetaphil Daily Facial Moisturizer Spf 15",
    "Children's Benadryl Bug Bite Relief",
    "Chlorhexidine 4% Antiseptic Hand Wash",
    "Chlorhexidine Gluconate Solution 0.05%",
    "Chlorhexidine Solution",
    "Chrom-o-red Disclosing Solution Concentrate",
    "Claritin Allergy Decongestant",
    "Clean & Clear Persa-gel 5",
    "Combigan",
    "Comfilax",
    "Comfort Shield",
    "Complete Moisture",
    "Compliments White Petroleum Jelly",
    "Condyline",
    "Covergirl Trublend Base Business Skin Primer Base Pour La Peau",
    "Crème Rajeunissante Haute Fermeté Jour",
    "Creme Visage Fps 30",
    "Diaper Rash Ointment",
    "Differin",
    "Differin Xp",
    "Digiclean Antibacterial Foam Hand Soap",
    "Digiclean E Foam Hand Soap",
    "Digisan E Foam Hand Sanitizer",
    "Diluent For Allergenic Extract Sterile Albumin Saline With Phenol",
    "Diprosone Cream",
    "Diprosone Lotion",
    "Divigel",
    "Doak Oil",
    "Dormer 211 Spf 30",
    "Drixoral Nasal Congestion",
    "Dry Oil Sunscreen",
    "Dry-touch Sunscreen Spf 45",
    "Dynamic Skin Recovery Spf 50",
    "Ecocare 250",
    "Ecocare 360",
    "Efudex",
    "Elizabeth Arden Lip Protectant Stick Spf 15",
    "Elocom Cream",
    "Elocom Lotion",
    "Elocom Ointment",
    "Eltamd Skincare Uv Sport Spf 50",
    "Emla Cream",
    "Emla Patch",
    "Endure 400 Scrub-stat 4",
    "Endure 420 Cida-stat",
    "Enriched Foam Antibacterial Soap",
    "Entonox",
    "Isopto Tears 0.5%",
    "Isopto Tears 1%",
    "Isovue 300 Injection",
    "Riva-levetiracetam",
    "Riva-levofloxacin",
    "Riva-loperamide",
    "Riva-memantine",
    "Riva-metformin",
    "Riva-metoprolol-l",
    "Riva-montelukast Fc",
    "Riva-moxifloxacin",
    "Riva-olanzapine",
    "Riva-omeprazole Dr",
    "Riva-oxybutynin",
    "Riva-pantoprazole",
    "Riva-paroxetine",
    "Riva-perindopril",
    "Riva-pregabalin",
    "Riva-pyridostigmine",
    "Riva-quetiapine",
    "Riva-risedronate",
    "Riva-risperidone",
    "Riva-rosuvastatin",
    "Riva-sertraline",
    "Riva-sildenafil",
    "Riva-sotalol",
    "Riva-tadalafil",
    "Robaxin",
    "Robaxin 750",
    "Robaxisal C 1/2",
    "Robaxisal C 1/4",
    "Robaxisal Extra Strength",
    "Robitussin Dm Coughgels Liqui-gels Toux",
    "Rofact",
    "Ropinirole",
    "Rosiglitazone",
    "Rosuvastatin",
    "Rozlytrek",
    "Ruzurgi",
    "Rybelsus",
    "Rythmodan",
    "Rythmol",
    "Salagen",
    "Salazopyrin En-tabs 500 Mg",
    "Salazopyrin Tab 500mg",
    "Samsca",
    "Sandomigran Ds",
    "Sandoz Abiraterone",
    "Sandoz Alendronate",
    "Sandoz Alfuzosin",
    "Sandoz Almotriptan",
    "Sandoz Amiodarone",
    "Sandoz Amlodipine",
    "Sandoz Amoxi-clav Tablet",
    "Sandoz Amphetamine Xr",
    "Sandoz Anagrelide",
    "Sandoz Anastrozole",
    "Sandoz Aripiprazole",
    "Sandoz Atomoxetine",
    "Sandoz Atorvastatin",
    "Sandoz Cyclosporine",
    "Sandoz Deferasirox",
    "Sandoz Diclofenac Rapide",
    "Sandoz Diltiazem Cd",
    "Sandoz Diltiazem T",
    "Sandoz Dimenhydrinate",
    "Sandoz Docusate Sodium",
    "Sandoz Donepezil",
    "Sandoz Duloxetine",
    "Sandoz Dutasteride Capsule",
    "Sandoz Efavirenz/emtricitabine/tenofovir",
    "Sandoz Enalapril",
    "Sandoz Entacapone",
    "Auro-azithromycin",
    "Avastin",
    "Baclofen Injection",
    "Bacteriostatic Sodium Chloride Injection Usp",
    "Balminil Dm  (3mg/ml Sucrose Free)",
    "Balminil Dm + Decongestant + Expectorant",
    "Benylin Extra Strength Cough Complete",
    "Benylin Extra Strength Dry Cough",
    "Benylin Extra Strength For People With Diabetes",
    "Benylin Extra Strength Mucus & Phlegm",
    "Benylin Extra Strength Mucus & Phlegm Plus Cold Relief Night",
    "Benylin Extra Strength Mucus & Phlegm Plus Cough Control",
    "Benylin Extra Strength Sore Throat & Cough",
    "Benylin For Children All-in-one Cold & Fever",
    "Benylin For Children All-in-one Cold & Fever Nightime",
    "Benylin For Children Cough & Cold",
    "Benylin For Children Cough Night",
    "Benylin For Children Dry Cough",
    "Benylin Regular Strength Cough Plus Chest Congestion Relief",
    "Bupivacaine Hydrochloride In Dextrose Injection Usp",
    "Bupivacaine Injection Bp",
    "Buscopan",
    "Busulfan For Injection",
    "Butorphanol Nasal Spray",
    "Cabazitaxel For Injection",
    "Cabenuva",
    "Caelyx",
    "Calciject Inj 100mg/ml",
    "Calcium Chloride Injection Usp",
    "Calcium Gluconate Injection, Usp 10%",
    "Calmylin",
    "Calmylin Ace",
    "Calmylin Pse With Codeine",
    "Carbocaine 1%",
    "Carbocaine 2%",
    "Carbocaine 2% With Neo-cobefrin",
    "Carbocaine 3%",
    "Carboplatin Injection",
    "Carboplatin Injection Bp",
    "Ceftin",
    "Celestone Soluspan",
    "Cellcept",
    "Cerebyx",
    "Charac-25",
    "Charactol-25",
    "Children's Acetaminophen Dye-free",
    "Children's Acetaminophen Suspension",
    "Children's Advil",
    "Children's Advil Cold",
    "Children's Advil Cold & Flu Multi-symptom",
    "Children's Advil Fever From Colds Or Flu",
    "Children's Allergy Formula",
    "Children's Benadryl Allergy Liquid",
    "Cipro Oral Suspension",
    "Ciprofloxacin Injection Usp",
    "Ciprofloxacin Intravenous Infusion Bp",
    "Cisatracurium Omega Multidose",
    "Cisplatin Injection",
    "Cisplatin Injection Bp",
    "Cisplatin Injection, Bp",
    "Cladribine Injection",
    "Claritin Kids",
    "Clavulin 125 F Oral Sus",
    "Clavulin 200",
    "Clavulin 250 F Oral Sus",
    "Clavulin 400",
    "Clindamycin Injection In 5% Dextrose",
    "Clindamycin Injection Usp",
    "Clindamycin Iv Infusion",
    "Cablivi",
    "Cancidas",
    "Cardiolite",
    "Caripul",
    "Caspofungin For Injection",
    "Cathflo",
    "Cayston",
    "Glucagon",
    "Herceptin",
    "Herzuma",
    "Humatrope",
    "Ic-green",
    "Idarubicin",
    "Imipenem And Cilastatin For Injection Usp",
    "Indocyanine Green For Injection Kit",
    "Indocyanine Green For Injection, Usp",
    "Inflectra",
    "Istodax",
    "Kadcyla",
    "Kanjinti",
    "Kit For The Preparation Of Technetium Tc 99m Sestamibi Injection",
    "Kyprolis",
    "Lutrepulse Pws 0.8mg/vial",
    "Revestive",
    "Riastap",
    "Risperdal Consta",
    "Pharixia Alcohol Free",
    "Pms-benzydamine",
    "Potassium Acetate Injection Usp",
    "Preservative-free Thera Tears Lubricant Eye Drops",
    "Prolensa",
    "Purklenz",
    "Refresh Optive Advanced Sensitive",
    "Refresh Optive Fusion Sensitive",
    "Refresh Optive Gel Drops",
    "Restasis",
    "Restasis Multidose",
    "Sag-m",
    "Sandoz Diclofenac Ophtha",
    "Sandoz Olopatadine",
    "Sandoz Olopatadine 0.2%",
    "Sandoz Travoprost",
    "Simbrinza",
    "Sinufrin",
    "Sinufrin Plus",
    "Smoflipid 20%",
    "Anew Platinum Day Cream",
    "Anew Reversalist Complete Renewal Day Cream",
    "Anew Reversalist Complete Renewal Day Lotion",
    "Anew Skinvincible Day Lotion Broad Spectrum Spf 50 Sunscreen",
    "Anew Ultimate Day Multi-performance Cream",
    "Anew Vitale Day Cream",
    "Anew Vitale Day Lotion",
    "Anthelios Dermo-kids",
    "Anthelios Lotion Corps Ultra-fluide",
    "Anthelios Mist",
    "Anthelios Xl Melt-in Cream",
    "Anti-aging Complex Emulsion Broad Spectrum Spf 30",
    "Anti-aging Complex Eye Treatment Broad Spectrum Spf 15",
    "Anti-aging Moisturizer Broad Spectrum Spf 30 | Pa+++",
    "Anti-brillance Lotion Toucher Sec",
    "Beach Defense Kids Spf 60",
    "Benefiance Wrinkleresist24 Day Cream",
    "Benefiance Wrinkleresist24 Day Emulsion",
    "Benzagel Spot-on Acne Gel",
    "Benzalkonium Chloride Antiseptic Towelette",
    "Benzamycin",
    "Beteflam",
    "Beyond Color Lip Conditioner Spf 15",
    "Beyond Color Lipstick Spf 15",
    "Biacna Topical Gel",
    "Blue Therapy Moisturizing Cream Dry Skin Spf 15",
    "Blue Therapy Moisturizing Cream Normal/combination Skin Spf 15",
    "Bm-san",
    "Bobbi Brown Extra Repair Moisturizing Balm Spf 25",
    "Bobbi Brown Lip Balm Spf 15",
    "Bobbi Brown Primer Plus Protection Spf 50",
    "Bobbi Brown Primer Plus Radiance Spf 35",
    "Bobbi Brown Skin Foundation Spf 15",
    "Bobbi Brown Skin Weightless Long-wear Foundation Spf15 Full Cover Oil-free Shine Control",
    "Clinique Even Better Skin Tone Correcting Moisturizer Spf 20",
    "Clinique Fit Workout Makeup Spf 40",
    "Clinique For Men Spf 21 Moisturizer",
    "Clinique For Men Super Energizer Spf 25 Anti-fatigue Hydrating Concentrate",
    "Clinique Moisture Surge Cc Cream Hydrating Colour Corrector Spf 30",
    "Clinique Pep-start Hydrorush Moisturizer Spf 20",
    "Clinique Redness Solutions Makeup Spf 15 With Probiotic Technology",
    "Clinique Repairwear Laser Focus Line Smoothing Cream Spf 15 Combination Oily To Oily",
    "Clinique Repairwear Laser Focus Line Smoothing Cream Spf 15 Very Dry To Dry Combination",
    "Clinique Repairwear Uplifting Firming Cream Spf 15 Dry Combination To Combination Oily",
    "Clinique Repairwear Uplifting Firming Cream Spf 15 Very Dry To Dry",
    "Clinique Smart Spf 15 Custom-repair Moisturizer Combination Oily To Oily",
    "Clinique Smart Spf 15 Custom-repair Moisturizer Dry Combination",
    "Clinique Smart Spf 15 Custom-repair Moisturizer Very Dry To Dry",
    "Clinique Spf 30 Face Cream",
    "Coppertone Sunscreen Lotion Spf 8 Defend & Glow",
    "Coppertone Sunscreen Stick Waterbabies",
    "Correction Code (a.m.) Daily Moisturizer Broad Spectrum Spf 25",
    "Cover Girl Advanced Radiance Age Defying Make-up",
    "Covergirl Outlast All Day Stay Fabulous 3-in-1 Foundation",
    "Crème De Jour",
    "Crème Solaire Corps Fps 30",
    "Crème Solaire Visage Toucher Sec Fps 30",
    "Crème Solaire Visage Toucher Sec Fps 50+",
    "Crest Gum Care",
    "Crest Pro-health Bacteria Guard",
    "Crest Pro-health Invigorating Clean Multi-protection",
    "Crest Pro-health Multi Protection",
    "Critic-aid Clear",
    "Cystadrops",
    "Daily Acne Wash",
    "Daily Moisturizing Lotion Spf 15",
    "Dailyscreen",
    "Dandruff",
    "Day Moisturizer Broad Spectrum Spf 30 With Skin Firming Retinol",
    "Invisiblur Perfecting Shield Broad Spectrum Spf 30 Pa+++",
    "Iope Air Cushion",
    "Island Sport Sunscreen Lotion Spf 30",
    "Itch Relief Balm",
    "Itch Relief Lotion",
    "Jamp Diclofenac Topical Solution",
    "Jampocaine 5%",
    "Jampzinc-hc",
    "Jublia",
    "Kids Spray",
    "Kids Sunscreen Continuous Spray Spf 50+",
    "Kids Sunscreen Continuous Spray Spf/fps 60",
    "Kids Sunscreen Lotion 50+",
    "Kids Sunscreen Lotion Spf 50+",
    "Kids Sunscreen Lotion Spf/fps 60",
    "Kids Sunscreen Stick Écran Solaire En Bâtonnet Pour Enfants Spf Fps 50",
    "Kids Sunscreen Stick Spf 50+",
    "Kleenex Foam Hand Sanitizer",
    "Klere",
    "La Mer The Soft Fluid Long Wear Foundation Spf 20",
    "Dom-metoprolol-l",
    "Dom-montelukast Fc",
    "Dom-pregabalin",
    "Dom-quetiapine",
    "Dom-ramipril",
    "Dom-risedronate",
    "Dom-rizatriptan Rdt",
    "Dom-rosuvastatin",
    "Dom-sertraline",
    "Dom-sumatriptan",
    "Dom-terbinafine",
    "Dom-topiramate",
    "Dom-valacyclovir",
    "Dom-zopiclone",
    "Domperidone",
    "Domperidone-10",
    "Donepezil",
    "Hymenoptera Venom Product-mixed Vespid Venom Protein (1650 Mcg)",
    "Hymenoptera Venom Product-wasp Venom Protein (550 Mcg)",
    "Hymenoptera Venom Product-white-faced Hornet Venom Protein (550 Mcg)",
    "Hymenoptera Venom Products-yellow Hornet Venom Protein (550 Mcg)",
    "Kinevac",
    "Levothyroxine Sodium For Injection",
    "Netspot",
    "Nplate",
    "Octreoscan",
    "Pharmalgen Honey Bee Venom",
    "Alesse 21",
    "Alesse 28",
    "Alysena 21",
    "Alysena 28",
    "Arthrotec 50",
    "One Alpha Caps 1mcg",
    "Ovima 21",
    "Ovima 28",
    "Pms-diclofenac-misoprostol",
    "Rocaltrol",
    "Seebri Breezhaler",
    "Spiriva",
    "Synthroid",
    "Taro-calcitriol",
    "Teva-liothyronine",
    "Triquilar 21",
    "Triquilar 28",
    "Ultibro Breezhaler",
    "Kynmobi",
    "Ametop Gel 4%",
    "Antibiotic Cream",
    "Antibiotic Cream For Kids",
    "Antibiotic Cream Plus Pain Relief",
    "Antibiotic Cream Plus Pain Relief For Kids",
    "Antibiotic Plus Pain Relief Cream",
    "Cathejell",
    "Colyte",
    "Dalacin Vaginal Cream",
    "Diprosalic",
    "Dovobet Gel",
    "Dovobet Ointment",
    "Erythromycin Ophthalmic Ointment Usp",
    "Lipiodol Ultra Fluid",
    "Metvix",
    "Isovue 370 Injection",
    "Isovue Multipack-300",
    "Isovue Multipack-370",
    "Jamp-timolol",
    "Ketoderm Cream 2%",
    "Ketorolac",
    "Keystone Antibacterial Foam Hand Soap",
    "Keystone Foam Hand Sanitizer",
    "Kids Sunscreen Continuous Spray",
    "Kids/enfants Spf/fps 50",
    "Kwellada-p Crème Rinse",
    "Kwellada-p Lotion",
    "Lansoyl Gel 78%",
    "Lansoyl Sugar Free - Jelly - 78%",
    "Lax-a-day",
    "Lax-a-day Men",
    "Levulan Kerastick",
    "Lice Killing Shampoo",
    "Lidemol Emollient Cream 0.05%",
    "Lidex",
    "Lidocaine",
    "Lidocaine Hydrochloride Topical Solution Usp",
    "Mary Kay Spf 30 Sunscreen",
    "Maxilene 4",
    "Maxilene 5",
    "Medi-white Petroleum Jelly",
    "Medical Air 100%",
    "Medicated Lip Balm",
    "Medline Remedy Essentials Protectant Paste",
    "Mesoestetic Sun Protection Spf 30",
    "Mesoestetic Sun Protection Spf 50",
    "Methylene Bleu Liq 1%",
    "Methylene Bleu Liq 2%",
    "Metrogel 0.75%",
    "Metrogel 1%",
    "Micatin Powder Spray     - Unscented 2%",
    "Miconazole Nitrate Vaginal Cream 2%",
    "Micozole",
    "Micrell Antibacterial Lotion Soap With Chloroxylenol",
    "Mineral Oil",
    "Minerale Legere Huile",
    "Minims Prednisolone Sodium Phosphate",
    "Miostat Ophthalmic Liq 0.01%",
    "Monicure Combo",
    "Monistat 1 Combination Pack",
    "Monistat 3 Dual-pak",
    "Monistat 3 Vaginal Cream",
    "Monistat 7 Dual-pak",
    "Monistat 7 Vaginal Cream",
    "Monistat Derm Cream",
    "Muscle & Joint No Odour Extra Strength",
    "Muscle & Joint No Odour Regular Strength",
    "Mylan-clobetasol Cream",
    "Mylan-clobetasol Ointment",
    "Mylan-clobetasol Scalp Application",
    "Nanonumb",
    "Naphcon A",
    "Neutrogena T/gel Therapeutic Shampoo",
    "Neutrogena Ultra Sheer Body Mist Sunscreen Spf 30",
    "Neutrogena Ultra Sheer Body Mist Sunscreen Spf 45",
    "Nitrogen 100%",
    "Nitrogen N.f.",
    "Nitrogen Nf",
    "Nitrogen Nf 99%",
    "Nitrous Oxide 100%",
    "Nitrous Oxide U.s.p.",
    "Nitrous Oxide Usp 99%",
    "Nix Creme Rinse",
    "Oxygen",
    "Oxygen (compressed)",
    "Oxygen 100%",
    "Oxygen 99.0%",
    "Oxygen 99%",
    "Oxygen Carbon Dioxide Mixture",
    "Oxygen U.s.p.",
    "Oxygen Usp",
    "Oxygen Usp - Gas 100%",
    "Oxygen Usp, Helium Usp, Medical Gas Mixture",
    "Oxygen Usp, Nitrogen Nf, Medical Gas Mixture",
    "Oxygen, Compressed",
    "Oxygene - Gas Inh",
    "Pear Ab Hand Soap",
    "Peg 3350",
    "Penthrox",
    "Perfecting Day Cream Broad Spectrum Spf 30 Pa +++",
    "Perfecting Makeup Broad Spectrum Spf 25",
    "Perichlor",
    "Peridex Oral Rinse",
    "Petroleum Jelly",
    "Phelityl Day Lotion Spf 15",
    "Phenol Saline Inj",
    "Photo Regul Cream / Crème",
    "Photoderm Spf/fps 40 Spray",
    "Photoderm Spf/fps 50+ Crème",
    "Photoderm Spf/fps 50+ Lait",
    "Pliaglis",
    "Pms-moxifloxacin",
    "Pms-sodium Cromoglycate",
    "Polysporin Itch Relief",
    "Polysporin Poly To Go",
    "Positively Radiant Daily Moisturizer",
    "Positively Radiant Daily Moisturizer Spf 15",
    "Pramox Hc Cream",
    "Pramox Hc Lotion",
    "Pred Forte",
    "Pred Mild",
    "Premium Sunscreen Spray Sun Bum 30",
    "Premium Sunscreen Spray Sun Bum 50",
    "Prevora Stage 1",
    "Prime Source Antibacterial Foam Soap",
    "Prime Source Antimicrobial Foaming Hand Soap With Chloroxylenol",
    "Sandoz Escitalopram",
    "Sandoz Esomeprazole",
    "Sandoz Everolimus",
    "Sandoz Ezetimibe",
    "Sandoz Famciclovir",
    "Sandoz Felodipine",
    "Sandoz Fenofibrate E",
    "Sandoz Fenofibrate S",
    "Sandoz Finasteride",
    "Sandoz Finasteride A",
    "Sandoz Fingolimod",
    "Sandoz Fluoxetine",
    "Sandoz Folic Acid",
    "Sandoz Gefitinib",
    "Sandoz Gliclazide Mr",
    "Sandoz Glimepiride",
    "Sandoz Irbesartan",
    "Sandoz Irbesartan Hct",
    "Sandoz Lacosamide",
    "Sandoz Lansoprazole",
    "Sandoz Leflunomide",
    "Sandoz Letrozole",
    "Sandoz Levetiracetam",
    "Sandoz Levofloxacin",
    "Sandoz Linezolid",
    "Sandoz Lisinopril",
    "Sandoz Lisinopril Hct",
    "Sandoz Olanzapine",
    "Sandoz Olanzapine Odt",
    "Sandoz Olmesartan",
    "Sandoz Omeprazole",
    "Sandoz Ondansetron",
    "Sandoz Opium & Belladonna",
    "Sandoz Orphenadrine",
    "Sandoz Oxycodone/acetaminophen",
    "Sandoz Pantoprazole",
    "Sandoz Perindopril Erbumine",
    "Sandoz Perindopril Erbumine/ Indapamide",
    "Sandoz Perindopril Erbumine/ Indapamide Hd",
    "Sandoz Perindopril Erbumine/ Indapamide Ld",
    "Sandoz Pioglitazone",
    "Sandoz Posaconazole",
    "Sandoz Pramipexole",
    "Sandoz Pravastatin Tablets",
    "Sandoz Pregabalin",
    "Sandoz Prochlorperazine",
    "Sandoz Proctomyxin Hc Suppositories",
    "Sandoz Quetiapine",
    "Sandoz Quetiapine Xrt",
    "Sandoz Rabeprazole",
    "Sandoz Ranitidine",
    "Sandoz Repaglinide",
    "Sandoz Risedronate",
    "Sandoz Risperidone",
    "Sandoz Rivastigmine",
    "Sandoz Rizatriptan Odt",
    "Sandoz Trandolapril",
    "Sandoz Valacyclovir",
    "Sandoz Valsartan",
    "Sandoz Valsartan Hct",
    "Sandoz Venlafaxine Xr",
    "Sandoz Voriconazole",
    "Sandoz Zolmitriptan",
    "Sandoz Zolmitriptan Odt",
    "Sandoz Zopiclone Tablet",
    "Sandoz-carbamazepine Cr",
    "Sandoz-diclofenac",
    "Sandoz-diclofenac Sr",
    "Brevicon 1/35 Tablets (28-day Pack)",
    "Brilinta",
    "Bromocriptine",
    "Buckley's Complete + Mucus Relief",
    "Buckley's Complete Extra Strength Cough, Cold & Flu Day",
    "Buckley's Complete Extra Strength Cough, Cold And Flu Night",
    "Buckley's Complete Nighttime Softgels",
    "Buckley's Nighttime Cold And Sinus",
    "Buckleys Cold & Sinus",
    "Budesonide",
    "Bupropion Sr",
    "Burinex",
    "Buspirone",
    "Buspirone-10 - Tab 10mg",
    "Bystolic",
    "Cabometyx",
    "Caduet",
    "Calquence",
    "Campral",
    "Ccp-ondansetron",
    "Ccp-rizatriptan Odt",
    "Ccp-zolmitriptan",
    "Ceenu",
    "Celebrex",
    "Celecoxib",
    "Celexa 20 Mg",
    "Celexa 40 Mg",
    "Celsentri",
    "Cepacol Children's Fruity Strawberry",
    "Cepacol Sensations",
    "Cepacol Sensations Sore Throat & Blocked Nose",
    "Cepacol Sensations Sore Throat & Cough",
    "Cephalexin",
    "Cephalexin-500",
    "Cerdelga",
    "Cesamet",
    "Cetirizine",
    "Champix",
    "Charco Caps",
    "Children's Benadryl Allergy Chewables",
    "Children's Tylenol Chewables",
    "Chlorax",
    "Chlordiazepoxide",
    "Chlorthalidone",
    "Cialis",
    "Cimetidine",
    "Cipralex   -10mg",
    "Cipralex   -20mg",
    "Cipro Xl",
    "Ciprofloxacin",
    "Saphris",
    "Sdz Celecoxib",
    "Seasonale",
    "Seasonique",
    "Selax Cap 100mg",
    "Select 1/35 (21-day)",
    "Select 1/35 (28-day)",
    "Senna Laxative And Docusate Sodium Tablets",
    "Senna S. Tablets",
    "Senokot S",
    "Sensipar",
    "Septa-amlodipine",
    "Serc",
    "Seroquel",
    "Seroquel Xr",
    "Sertraline",
    "Sertraline-100",
    "Sertraline-25",
    "Sertraline-50",
    "Sialor",
    "Sildenafil",
    "Silenor",
    "Silver Bullet Suppository",
    "Sleep-eze Extra Strength Gelcaps",
    "Sleep-eze Extra Strength Minis",
    "Sleep-eze Regular Strength Caplets",
    "Sns-asa Ec",
    "Soflax",
    "Soflax Capsules 100mg",
    "Solifenacin",
    "Soriatane",
    "Sovaldi",
    "Sporanox",
    "Sprycel",
    "Stalevo",
    "Statex Suppositories 20mg",
    "Statex Suppositories 30mg",
    "Statex Suppositories 5mg",
    "Statex Tab 10mg",
    "Statex Tab 5mg",
    "Statex Tablet 25mg",
    "Statex Tablets 50mg",
    "Statex-suppositories 10mg",
    "Staxyn",
    "Stivarga",
    "Stomach Relief Chewable Tablets",
    "Stool Softener",
    "Strattera",
    "Strepsils Anaesthetic Formula",
    "Strepsils Extra Black Cherry",
    "Stribild",
    "Stromectol",
    "Sublinox",
    "Suboxone",
    "Sudafed Sinus Advance",
    "Sulfatrim",
    "Sulfatrim Ds",
    "Sulfatrim Pediatric",
    "Sumatriptan",
    "Sumatriptan Df",
    "Supeudol",
    "Supeudol 10",
    "Supeudol 20",
    "Supeudol 5",
    "Suprax",
    "Suprefact Depot 2 Months",
    "Suprefact Depot 3 Months",
    "Sustiva 200mg",
    "Sustiva 50mg",
    "Sustiva Tablets",
    "Sutent",
    "Suvexx",
    "Symdeko",
    "Symtuza",
    "Synjardy",
    "Synphasic 21 Tablets",
    "Synphasic 28 Tablets",
    "Tadalafil",
    "Tafinlar",
    "Tagrisso",
    "Talwin",
    "Tamiflu",
    "Tamiflu Capsule 75mg",
    "Taminol Caplets",
    "Tamsulosin Cr",
    "Tapazole",
    "Tarceva",
    "Targin",
    "Taro-acitretin",
    "Taro-amlodipine",
    "Taro-anastrozole",
    "Taro-atenolol",
    "Taro-atorvastatin",
    "Taro-bosentan",
    "Taro-bupropion Xl",
    "Taro-candesartan",
    "Taro-capecitabine",
    "Taro-carbamazepine",
    "Taro-carbamazepine Chewable Tablets 100mg",
    "Taro-carbamazepine Chewable Tablets 200mg",
    "Taro-cefprozil",
    "Lait Solaire Corps Fps 50+",
    "Lait Solaire Corps Lotion Protectrice Corps Fps 30",
    "Lait Solaire Corps Lotion Protectrice Corps Fps 50 Plus",
    "Lamisil",
    "Laneige Bb Cushion",
    "Lax-a-day Pharma",
    "Le Fond De Teint",
    "Lice Shampoo",
    "Lidocaine Plus Menthol",
    "Life Brand Sport Sunscreen Broad Spectrum Spray",
    "Life Brand Sport Sunscreen Continuous Spray No Pumping Needed",
    "Life Brand Sunscreen Continuous Spray No Pumping Needed Spf/fps 85",
    "Lift Spf 15",
    "Liftactiv Uv",
    "Lip Conditioner Spf 15",
    "Lip Protector Spf 15 Sunscreen",
    "Teva-losartan",
    "Teva-losartan/hctz",
    "Teva-medroxyprogesterone",
    "Teva-meloxicam",
    "Teva-metoprolol",
    "Teva-mexiletine",
    "Teva-mirtazapine",
    "Teva-modafinil",
    "Smooth And Silky Lisse Et Soyeux Dandruff Pyrithione Zinc Shampoo",
    "Soft Care Defend Foam",
    "Softcide Handwash",
    "Softlips Slims",
    "Sojourn Sevoflurane",
    "Solarcaine First Aid Lidocaine Spray",
    "Solarcaine Medicated First Aid Lotion",
    "Solarcaine Medicated Lidocaine Gel",
    "Soluprep Aq",
    "Soluprep Qd Swab",
    "Soluprep Qd Wipe",
    "Soothe Night Time",
    "Soothe Restore",
    "Spf 30 Spray-on Alcohol-free Sunscreen",
    "Spf 45 Sport Clear Continuous Spray",
    "Spf/fps 30 Broad Spectrum Alcohol Free Sunscreen",
    "Spf/fps 60 Continuous Spray",
    "Spot Clearing Lotion",
    "Stanhexidine 2% With Isopropyl Alcohol 4%",
    "Stanhexidine 4% With Isopropyl Alcohol 4%",
    "Stanhexidine Aqueous 2% With 4% Isopropyl Alcohol",
    "Taro-terconazole Cream",
    "Taro-testosterone Gel",
    "Tazorac",
    "Tears Naturale Forte",
    "Tears Plus 1.4%",
    "Testim 1%",
    "Teva-clobetasol",
    "Teva-ectosone",
    "Teva-prednisolone",
    "Teva-proctosone",
    "Teva-topilene",
    "The Radiant Skintint Spf 30",
    "Tiamol Cream 0.05%",
    "Adasept Liq",
    "Albalon",
    "Avon Sun Lip Balm Spf 15",
    "Bacti-stat",
    "Bacti-stat Ae",
    "Blistex Ultra Lip Balm",
    "Canesten 1% Topical Cream",
    "Carbon Dioxide 7.1% W Oxygen",
    "Cetrimide Cream",
    "Cetrimide Tincture 0.5%",
    "Chlorhexidine And Isopropyl Alcohol Prep Pads",
    "Chlorhexidine And Isopropyl Alcohol Swabsticks",
    "Clotrimaderm Cream",
    "Clotrimazole Cream Usp",
    "Crown Antiseptic Hand Soap",
    "Dexidin 0.5 Solution",
    "Dexidin 20",
    "Dormer 211 Face Cream Spf 15",
    "Germi Stat Gel",
    "Helium-oxygen Mix Gas",
    "Huile Minerale Lourde Liq 100% Usp",
    "Iopidine",
    "Isovue 200 Injection",
    "Lamisil Crm",
    "Light Mineral Oil 100% Nf",
    "Lip Conditioner Lip Balm",
    "Sodium Chloride Injection Usp 0.9%",
    "Sodium Chloride Injection, Usp",
    "Sodium Chloride Irrigation Usp",
    "Sodium Nitroprusside For Injection",
    "Sodium Phosphates Injection Usp",
    "Sodium Thiosulfate Injection Usp",
    "Soflax Syrup 4mg/ml",
    "Sofracort",
    "Soframycin Nasal Spray",
    "Soliris",
    "Sorbitol Mannitol Irrigation",
    "Spinraza",
    "Sporanox Oral Solution 10mg/ml",
    "Stannous Disida Kit",
    "Stannous Maa Kit",
    "Stannous Mdp Kit",
    "Stannous Pyp Kit",
    "Stelara",
    "Stomaax Plus",
    "Strensiq",
    "Sublocade",
    "Succinylcholine Chloride Injection Usp",
    "Succinylcholine Chloride Injection, Usp",
    "Sulfur Colloid Kit",
    "Survanta",
    "Synacthen Depot",
    "Synagis",
    "Takhzyro",
    "Taltz",
    "Tomvi",
    "Topotecan Hydrochloride For Injection",
    "Topotecan Injection",
    "Toradol Im",
    "Torisel",
    "Total Cold And Flu Extra Strength",
    "Tpn Electrolytes",
    "Tranexamic Acid Injection",
    "Tranexamic Acid Injection Bp",
    "Travasol",
    "Tremfya",
    "Tremfya One-press",
    "Triamcinolone Acetonide Injectable Suspension Usp",
    "Triesence",
    "Trileptal Oral Suspension",
    "Trisenox",
    "Trispan",
    "Tromboject 1% Inj 10mg/ml",
    "Tromboject 3% Inj 30mg/ml",
    "Trulicity",
    "Truxima",
    "Tysabri",
    "Ulone",
    "Ultracaine D-s Forte Injection",
    "Ultracaine D-s Injection",
    "Unituxin",
    "Uromitexan",
    "Vasotec Iv",
    "Vectibix",
    "Venofer",
    "Ventolin I.v. Infusion Solution 5.0mg Salbutamol In 5ml (1000mcg/ml)",
    "Ventolin Nebules P.f. - 2.5mg/2.5ml",
    "Ventolin Nebules P.f. - 5mg/2.5ml",
    "Ventolin Respirator Solution",
    "Verapamil Hydrochloride Injection Usp",
    "Neupro",
    "Nitro-dur 0.2",
    "Nitro-dur 0.4",
    "Nitro-dur 0.6",
    "Nitro-dur 0.8",
    "Oxytrol",
    "Sandoz Rivastigmine Patch 10",
    "Sandoz Rivastigmine Patch 5",
    "Transderm-nitro 0.2",
    "Transderm-nitro 0.4",
    "Transderm-nitro 0.6",
    "Trinipatch 0.2",
    "Trinipatch 0.4",
    "Trinipatch 0.6",
    "Cervidil",
    "Arestin Microspheres",
    "(20 Mmol/l) Potassium Chloride In 3.3% Dextrose And 0.3% Sodium Chloride Injection Usp",
    "(20 Mmol/l) Potassium Chloride In 5% Dextrose And 0.9% Sodium Chloride Injection Usp",
    "(20 Mmol/l) Potassium Chloride In 5% Dextrose Injection Usp",
    "(20mmol/l) Potassium Chloride In 0.9% Sodium Chloride Injection Usp",
    "(20mmol/l) Potassium Chloride In 5% Dextrose And 0.45% Sodium Chloride Injection Usp",
    "(40 Mmol/l) Potassium Chloride In 0.9% Sodium Chloride Injection Usp",
    "(40 Mmol/l) Potassium Chloride In 5% Dextrose Injection Usp",
    "5% Dextrose And 0.225% Sodium Chloride",
    "5% Dextrose And 0.45% Sodium Chloride",
    "5% Dextrose And 0.45% Sodium Chloride Injection Usp",
    "5% Dextrose And 0.9% Sodium Chloride",
    "5% Dextrose And 0.9% Sodium Chloride Injection Usp",
    "5% Dextrose Injection Usp",
    "Abelcet",
    "Acetaminophen Injection",
    "Acetaminophen Oral Sol For Children Usp",
    "Acetaminophene - Liq 160 Mg/5 Ml",
    "Acetylcysteine Solution Usp",
    "Aclasta",
    "Act Dorzotimolol",
    "Act Latanoprost/timolol",
    "Act Progesterone Injection",
    "Actemra",
    "Acyclovir Sodium Injection",
    "Adenocard Injection -pre-filled Syringe",
    "Adenosine Injection",
    "Adrenalin Chloride Sol 1:1000",
    "Adrenalin Chloride Sol 1:1000 Amp",
    "Adult Honey Works",
    "Advil Pediatric Drops",
    "Advil Pediatric Drops Fever From Colds Or Flu",
    "Aerius Kids",
    "Aggrastat",
    "Aimovig",
    "Ajovy",
    "Aldurazyme",
    "Allergy Formula",
    "Allergy Formula Elixir",
    "Allergy Formula Liquid",
    "Allerject",
    "Allernix Elixir",
    "Almagel Plus Sus",
    "Apo-lactulose",
    "Apo-ranitidine",
    "Apresoline",
    "Argatroban",
    "Arixtra",
    "Arsenic Trioxide For Injection",
    "Arsenic Trioxide Solution For Injection",
    "Articaine Hydrochloride And Epinephrine Bitartrate Injection",
    "Ascor L 500",
    "Atarax Syrup 2mg/ml",
    "Atgam",
    "Atriance",
    "Atropine Injection Bp",
    "Atropine Sulfate Injection",
    "Atropine Sulfate Injection Usp",
    "Auralgan",
    "Sandoz Brimonidine",
    "Sandoz Dorzolamide",
    "Sandoz Fluorometholone",
    "Sandoz Prednisolone",
    "Sandoz Proctomyxin Hc",
    "Sandoz Timolol",
    "Sandoz Tobramycin",
    "Scott Antimicrobial Foam Skin Cleanser",
    "Scott Foam Hand Sanitizer",
    "Sebcur-t",
    "Septiline Ii Antimicrobial Lotion Soap",
    "Sevoflurane",
    "Sevorane Af",
    "Shampooing 2 En 1 Antipelliculaire",
    "Sheer Touch Toucher Soyeux Oil-free Sunscreen Écran Solaire Sans Huile Spf/fps 50+",
    "Shiseido Benefiance Nutriperfect Day Cream Spf 15",
    "Silk Hydration Weightless Clear Sunscreen Spray Spf 30",
    "Simply Botanical Sensation Soothing Skin",
    "Skin Renewing Day Cream",
    "Smart Tone Broad-spectrum Sunscreen Spf 50",
    "Sun Protection Cream Spf 30",
    "Sunscreen Continuous Spray No Pumping Needed",
    "Sunscreen Continuous Spray Spf 30 Sport",
    "Sunscreen Lotion Spf 30",
    "Sunscreen Lotion With Hydrating Ribbons Spf/fps 15",
    "Superfruit Soother",
    "Synalar",
    "Systane Ointment",
    "T/gel Daily Control 2 In 1",
    "T/gel Therapeutic Shampoo Extra Strength",
    "Tanning Oil Huile Bronzante 15",
    "Tardan Shp",
    "Targel",
    "Targel Sa",
    "Taro-amcinonide",
    "Taro-clindamycin",
    "Taro-clobetasol Cream Usp, 0.05%",
    "Taro-clobetasol Ointment Usp, 0.05%",
    "Taro-clobetasol Topical Solution Usp, 0.05%",
    "Taro-mupirocin",
    "Taro-sone",
    "Ultravist 300",
    "Ultravist 370",
    "Uncomplikated Spf",
    "Uv 50 Ecran Teinté Multi-protection Spf 50",
    "Uv Lip Color Splash Touche Couleur Lèvres Protection Uv Tahiti Blue",
    "Valisone-g Cream",
    "Valisone-g Ointment",
    "Valour Antiseptic Hand Cleanser",
    "Vaporisateur Nasal Decongestionnant",
    "Adynovate",
    "Alprolix",
    "Antithrombin Iii Nf",
    "Baciject 50,000 Units/vial",
    "Bacitracin Usp",
    "Benefix",
    "Berinert 1500",
    "Erwinase",
    "Nyaderm Vag Crm 25000unit/gm",
    "Ozonol Antibiotics Plus",
    "Pms-quetiapine",
    "Pms-quinapril",
    "Pramipexole",
    "Pravastatin",
    "Pravastatin-10",
    "Pravastatin-20",
    "Pravastatin-40",
    "Praxis Asa Ec 81 Mg Daily Low Dose",
    "Ddavp Rhinyle",
    "Decapeptyl",
    "Defitelio",
    "Delatestryl",
    "Depakene",
    "Depo-medrol (with Preservative) 20 Mg/ml",
    "Depo-medrol (with Preservative) 40 Mg/ml",
    "Depo-medrol (with Preservative) 80 Mg/ml",
    "Depo-medrol 40 Mg/ml",
    "Depo-medrol 80 Mg/ml",
    "Depo-medrol With Lidocaine",
    "Depo-provera Sterile Aqueous Suspension 150 Mg/ml",
    "Depo-testosterone Inj 100mg/ml",
    "Dexamethasone Omega Unidose",
    "Dexamethasone Sod Phosph Inj 10mg/ml Usp",
    "Dexamethasone Sodium Phosphate Inj Usp 4mg/ml",
    "Dm Cough Syrup",
    "Dm Expectorant (extra Strength) Syrup",
    "Dm-decongestant Children's Syrup",
    "Dm-decongestant-expectorant (extra Strength) Syrup",
    "Dm-decongestant-expectorant Syrup",
    "Dm-expectorant Syrup",
    "Dobutamine Injection Usp",
    "Midazolam Injection",
    "Nighttime Complete",
    "Dormiphen Extra-fort Capsule",
    "Dormiphen Extra-fort Comprime",
    "Dostinex",
    "Dovato",
    "Doxycin Tab 100mg",
    "Doxycycline Capsules",
    "Doxycycline Tablets",
    "Doxytab",
    "Duavive",
    "Epuris",
    "Erivedge",
    "Erleada",
    "Eryc Delayed-release Capsules",
    "Erythro-base",
    "Esbriet",
    "Escitalopram",
    "Esomeprazole",
    "Estrace",
    "Estring",
    "Etibi",
    "Ezetimibe",
    "Ezetrol",
    "Famotidine Tablets",
    "Fampyra",
    "Famvir",
    "Femara 2.5mg",
    "Fetzima",
    "Finasteride",
    "Fiorinal",
    "Fiorinal-c 1/2",
    "Fiorinal-c 1/4",
    "Firdapse",
    "Flexeril",
    "Flomax Cr",
    "Florinef",
    "Flu Relief",
    "Gln-gabapentin",
    "Gln-olmesartan",
    "Gln-olmesartan Hctz",
    "Glucobay",
    "Gluconorm 0.5mg",
    "Gluconorm 1.0mg",
    "Gluconorm 2.0mg",
    "Glucophage",
    "Glumetza",
    "Glyburide",
    "Glyxambi",
    "Gravol Chewables",
    "Gravol Immediate Release & Long Acting Caplets",
    "Gravol Liquid Gels",
    "Gravol Suppositories",
    "Gravol Tablets",
    "Harvoni",
    "Heartburn Control",
    "Hepsera",
    "Histantil Tab 50mg",
    "Dimenhydrinate Injection Usp",
    "Diphenhydramine Hcl Children's Liquid",
    "Diphenhydramine Hydrochloride Elixir Usp",
    "Diphenhydramine Hydrochloride Injection",
    "Diphenhydramine Hydrochloride Injection Usp",
    "Diphenist 50mg/ml",
    "Diprivan 1%",
    "Dipyridamole Injection, Usp",
    "Montelukast Sodium Tablets",
    "Morphine Sr",
    "Motrin 200mg",
    "Motrin 300mg",
    "Motrin 400mg",
    "Motrin Liquid Gels 200mg",
    "Motrin Liquid Gels 400 Mg",
    "Motrin Platinum Muscle & Body",
    "Movantik",
    "Movisse",
    "Moxifloxacin",
    "Ms Contin Srt 100mg",
    "Ms Contin Srt 15mg",
    "Ms Contin Srt 200mg",
    "Ms Contin Srt 30mg",
    "Ms Contin Srt 60mg",
    "Mylan-amlodipine",
    "Mylan-atazanavir",
    "Mylan-atorvastatin",
    "Mylan-atovaquone/proguanil",
    "Mylan-baclofen",
    "Mylan-bupropion Xl",
    "Mylan-cilazapril",
    "Mylan-cinacalcet",
    "Mylan-divalproex",
    "Mylan-efavirenz",
    "Nardil",
    "Nat-abiraterone",
    "Nat-anastrozole",
    "Nat-bosentan",
    "Nat-cetirizine",
    "Nat-citalopram",
    "Nat-donepezil",
    "Nat-erlotinib",
    "Nat-escitalopram",
    "Nat-gefitinib",
    "Nat-granisetron",
    "Nat-imatinib",
    "Nat-lanthanum",
    "Nat-letrozole",
    "Sandostatin Lar 10mg",
    "Sandostatin Lar 20mg",
    "Sandostatin Lar 30mg",
    "Signifor Lar",
    "Simulect",
    "Solu-cortef 100 Mg Act-o-vial",
    "Solu-cortef 250 Mg Act-o-vial",
    "Zevtera",
    "Zinecard",
    "Zithromax For Intravenous Injection",
    "Zyprexa Intramuscular",
    "24 Hour Allergy Remedy",
    "Aa-amilzide",
    "Aa-atenidone",
    "Aa-clozapine",
    "Aa-diltiaz",
    "Aa-feno-micro",
    "Aa-levocarb Cr",
    "Aa-theo La",
    "Abilify",
    "Ach-amlodipine",
    "Ach-anastrozole",
    "Ach-atorvastatin Calcium",
    "Ach-bicalutamide",
    "Ach-candesartan",
    "Ach-capecitabine",
    "Ach-donepezil",
    "Ach-escitalopram",
    "Ach-ezetimibe",
    "Ach-finasteride",
    "Hemosate Ultra Hs2125",
    "Hemosate Ultra Hs2150",
    "Hemosate Ultra Hs3125",
    "Hemosate Ultra Hs4125",
    "K + 45",
    "Magnesium-45 0.5-4.5",
    "Naturalyte H-200",
    "Naturalyte H-201",
    "Naturalyte H-206",
    "Naturalyte H-208",
    "Naturalyte H-225",
    "Naturalyte H-226",
    "Naturalyte H-227",
    "Olimel 4.4% E",
    "Olimel 5.7%",
    "Olimel 5.7% E",
    "Olimel 7.6% E",
    "Periolimel 2.5% E",
    "Physioneal 40 Glucose 1.36% W/v 13.6mg/ml Clear-flex",
    "Physioneal 40 Glucose 1.36% W/v 13.6mg/ml Solution For Peritoneal Dialysis",
    "Physioneal 40 Glucose 2.27% W/v 22.7 Mg/ml Clear-flex",
    "Cystosol W 3% Hexitols",
    "Fomepizole For Injection",
    "Friar's Balsam Benzoin Tincture",
    "Gamunex",
    "Glycine 1.5% Irrigation Usp Sol",
    "Heparin Sodium 20000units In 5% Dextrose Inj",
    "Heparin Sodium 25000units In 5% Dextrose Inj",
    "Igivnex",
    "Nitroglycerin In 5% Dextrose Inj.-200mcg/ml",
    "Nitroglycerin In 5% Dextrose Inj.-400mcg/ml",
    "Normosol-r",
    "Octaplasma",
    "Potassium Chloride 20 Meq In 0.9% Sodium Chloride",
    "Potassium Chloride 20 Meq In 3.3% Dextrose And 0.3% Sodium Chloride",
    "Potassium Chloride 20 Meq In 5% Dextrose",
    "Potassium Chloride 20 Meq In 5% Dextrose And 0.45% Sodium Chloride",
    "Stramucin",
    "Strongarm Hand Sanitizer",
    "Stubborn Acne Cleanser",
    "Stubborn Acne Daily Leave-on Mask",
    "Stubborn Acne Solution",
    "Stubborn Acne Spot Gel",
    "Stud 100",
    "Sulwhasoo Perfecting Cushion",
    "Sun And Snow Sport Spf 15",
    "Sun Expert",
    "Sun Protector Weightless Lotion For Face And Body",
    "Sun Protector Weightless Lotion For Face And Body Spf 30",
    "Sun Silk Drops",
    "Sun Ultimate Face Cream / Crème Visage",
    "Sun Ultimate Spray Spf/fps 30",
    "Suncare Spf 50 Sunscreen",
    "Sunright 50",
    "Sunscreen Continuous Spray",
    "Sunscreen Continuous Spray Spf 30",
    "Sunscreen Continuous Spray Spf 50 Kids",
    "Ultra Facial Moisturizer Spf 30",
    "Ultra Fluide Visage",
    "Ultra Lift Anti-wrinkle Firming Moisturizing Cream",
    "Ultra Light Sunscreen Broad Spectrum Spf 50",
    "Ultra Sheer Body Mist Sunscreen Spf 30",
    "Ultra Sheer Dry-touch Sunscreen Spf 110",
    "Ultra Sheer Dry-touch Sunscreen Spf 30",
    "Ultra Sheer Dry-touch Sunscreen Spf 60",
    "Ultra Sheer Face & Body Stick Sunscreen Spf 50+",
    "Ultra Sheer Face Mist Sunscreen",
    "Ultra Sheer Face Sunscreen Spf 60",
    "Ultra Sheer Water Light",
    "Teva-diclofenac Sr",
    "Teva-diclofenac-k",
    "Teva-diltiazem Cd",
    "Teva-diltiazem Hcl Er Capsules",
    "Teva-dimenate",
    "Teva-docusate Sodium",
    "Teva-domperidone",
    "Teva-donepezil",
    "Teva-doxazosin",
    "Teva-doxycycline",
    "Teva-duloxetine",
    "Teva-dutasteride",
    "Teva-efavirenz",
    "Teva-efavirenz/emtricitabine/tenofovir",
    "Teva-eletriptan",
    "Teva-emtec-30",
    "Teva-emtricitabine/tenofovir",
    "Teva-entacapone",
    "Teva-erlotinib",
    "Teva-escitalopram",
    "Teva-esomeprazole",
    "Teva-everolimus",
    "Teva-exemestane",
    "Teva-ezetimibe",
    "Teva-famotidine",
    "Teva-febuxostat",
    "Teva-finasteride",
    "Teva-fingolimod",
    "Teva-fluconazole",
    "Teva-fluoxetine",
    "Teva-flurbiprofen",
    "Teva-fluvastatin",
    "Teva-fosinopril",
    "Teva-frovatriptan",
    "Teva-furosemide",
    "Teva-gabapentin",
    "Teva-gemfibrozil",
    "Teva-gliclazide",
    "Teva-glyburide",
    "Teva-haloperidol",
    "Teva-hydrochlorothiazide",
    "Teva-hydromorphone",
    "Teva-imatinib",
    "Teva-indomethacin",
    "Teva-irbesartan",
    "Teva-irbesartan Hctz",
    "Teva-ketoconazole",
    "Teva-lacosamide",
    "Teva-lamivudine/zidovudine",
    "Teva-lamotrigine",
    "Teva-lansoprazole",
    "Teva-leflunomide",
    "Teva-lenoltec No. 1",
    "Teva-lenoltec No. 2",
    "Teva-lenoltec No. 3",
    "Teva-lenoltec No. 4",
    "Teva-letrozole",
    "Teva-levetiracetam",
    "Teva-levocarbidopa",
    "Teva-lisinopril (type P)",
    "Teva-lisinopril (type Z)",
    "Teva-lisinopril/hctz (type P)",
    "Teva-lisinopril/hctz (type Z)",
    "Teva-loperamide",
    "Teva-lorazepam",
    "Teva-nabilone",
    "Teva-naproxen",
    "Teva-naproxen Ec",
    "Teva-naproxen Sodium",
    "Teva-naproxen Sodium Ds",
    "Teva-naratriptan",
    "Teva-nitrofurantoin",
    "Teva-olanzapine",
    "Teva-omeprazole",
    "Teva-oxybutynin",
    "Teva-oxycocet",
    "Teva-oxycodan",
    "Teva-pantoprazole",
    "Teva-pantoprazole Magnesium",
    "Teva-paroxetine",
    "Teva-perindopril",
    "Teva-perindopril/indapamide",
    "Teva-pheniram",
    "Teva-pindolol",
    "Teva-piroxicam",
    "Teva-pravastatin",
    "Teva-prazosin",
    "Teva-prednisone",
    "Teva-pregabalin",
    "Teva-profen",
    "Teva-progesterone",
    "Teva-propranolol",
    "Teva-quetiapine",
    "Extra Strength Tylenol Complete Cold, Cough & Flu Nighttime",
    "Extra Strength Tylenol Flu Daytime",
    "Extra Strength Tylenol Flu Nighttime",
    "Extra Strength Tylenol Nighttime",
    "Extra Strength Tylenol Sinus Daytime",
    "Extra Strength Tylenol Sinus Nighttime",
    "Extra Strength Tylenol Sinus Pressure & Pain",
    "Flu, Cough & Cold Complete",
    "Flu, Cough & Cold Complete Day And Night",
    "Fluanxol 0.5mg - Tab",
    "Fluanxol 3mg - Tab",
    "Fluconazole 150",
    "Fludara",
    "Flunarizine",
    "Fluoxetine",
    "Fluphenazine",
    "Flurazepam",
    "Flurbiprofen",
    "Flutamide",
    "Fluvoxamine-100",
    "Fluvoxamine-50",
    "Folic Acid",
    "Foquest",
    "Forxiga",
    "Fosamax",
    "Fosinopril",
    "Fosinopril-10",
    "Fosinopril-20",
    "Fosrenol",
    "Freya 21",
    "Freya 28",
    "Frova",
    "Furosemide",
    "Furosemide 20 Tab",
    "Furosemide 40mg",
    "Furosemide-80 Tab 80mg",
    "Fycompa",
    "Gabapentin",
    "Gabapentin Capsules Usp",
    "Gabapentin Tablets Usp",
    "Galafold",
    "Galantamine Er",
    "Gas Relief Tablets",
    "Gas X Ultra Strength",
    "Gas-x Extra Strength",
    "Gaviscon Nausea",
    "Gd-amlodipine/atorvastatin",
    "Gd-eletriptan",
    "Gd-tranexamic Acid",
    "Gelusil Antacid And Anti-gas",
    "Gen-clozapine",
    "Genvoya",
    "Gilenya",
    "Giotrif",
    "Gleevec",
    "Gliclazide",
    "Gliclazide-80",
    "Gln-ezetimibe",
    "Histenol Ii",
    "Humatin Cap 250mg",
    "Hydrea Cap 500mg",
    "Hydrochlorothiazide",
    "Hydromorph Contin",
    "Hydromorph Contin-controlled Release Cap - 12mg",
    "Hydromorph Contin-controlled Release Cap - 18mg",
    "Hydromorph Contin-controlled Release Cap - 24mg",
    "Hydromorph Contin-controlled Release Cap - 30mg",
    "Hydromorph Contin-controlled Release Cap - 3mg",
    "Hydromorph Contin-controlled Release Cap - 6mg",
    "Hydroxyzine",
    "Hyzaar",
    "Hyzaar 50/12.5mg",
    "Hyzaar Ds 100/25 Mg",
    "Ibavyr",
    "Ibrance",
    "Ibsrela",
    "Ibuprofen",
    "Ibuprofen Caplets",
    "Ibuprofen Caplets 200 Mg",
    "Ibuprofen Extra Strength Caplets",
    "Ibuprofen Liquid Capsules",
    "Ibuprofen Liquid Gel Capsules",
    "Ibuprofen Muscle And Joint",
    "Ibuprofen Tablets",
    "Midazolam Injection Usp",
    "Milrinone Lactate Injection",
    "Milrinone Lactate Injection, Usp",
    "Mitoxantrone Injection",
    "Monoferric",
    "Morphine Hp 50 - 50mg/ml Usp",
    "Morphine Lp Epidural",
    "Morphine Sulfate Inj 10mg/ml Usp",
    "Morphine Sulfate Inj 15mg/ml Usp",
    "Morphine Sulfate Injection Bp",
    "Morphine Sulfate Injection Sdz",
    "Morphine Sulfate Injection Usp",
    "Morphine Sulfate Injection, Usp",
    "Movapo",
    "Moxifloxacin Injection",
    "Mozobil",
    "Mucus & Phlegm Relief Extra Strength",
    "Mucus & Phlegm Relief With Cough Control Extra Strength",
    "Multi 1000",
    "Multihance",
    "Murine",
    "Mvasi",
    "Naglazyme",
    "Naloxone Hcl Injection - 0.4mg/ml Usp",
    "Naloxone Hcl Injection - 1mg/ml Usp",
    "Naloxone Hydrochloride Injection",
    "Naloxone Hydrochloride Injection Usp",
    "Naloxone Injectable",
    "Narcan Nasal Spray",
    "Naropin",
    "Neo-medrol Acne Lotion",
    "Neo-synephrine",
    "Neoral Oral Solution 100mg/ml",
    "Neostigmine Methylsulfate Injection Usp",
    "Neostigmine Omega",
    "Neulasta",
    "Nighttime Cold And Flu Relief",
    "Nighttime Sleep Aid Liquid",
    "Nighttime Sleep-aid",
    "Nipride",
    "Nitroject Inj 5mg/ml",
    "Norditropin Nordiflex",
    "Norepinephrine Bitartrate Inj 1mg/ml Usp",
    "Nutropin Aq Nuspin 10",
    "Nutropin Aq Nuspin 20",
    "Nutropin Aq Nuspin 5",
    "Nyquil Complete + Vicks Vapocool Cold & Flu Liquid",
    "Nyvepria",
    "Ocrevus",
    "Octocaine Hcl 2% Epinephrine 1:100000",
    "Octocaine Hcl 2% Epinephrine 1:50000",
    "Odan Itraconazole",
    "Odan Levocarnitine",
    "Odan-fluoxetine",
    "Odan-methadone",
    "Omnipaque 180",
    "Omnipaque 240",
    "Omnipaque 300",
    "Omnipaque 350",
    "Omniscan",
    "Omnitrope",
    "Ondansetron Hydrochloride Dihydrate Injection",
    "Ondansetron Injection Usp",
    "Ondansetron Injection Usp     -(preservative Free)",
    "Ondansetron Injection Usp     -(with Preservative)",
    "Ondansetron Injection, Usp",
    "Onivyde",
    "Onpattro",
    "Opdivo",
    "Orabloc 1:100,000",
    "Orabloc 1:200,000",
    "Oraverse",
    "Ovol Drops",
    "Oxaliplatin",
    "Oxaliplatin Injection",
    "Paclitaxel For Injection",
    "Paclitaxel Injection Usp",
    "Pamidronate Disodium For Injection",
    "Pamidronate Disodium Omega 6 Mg/ml",
    "Pamidronate Disodium Omega 9 Mg/ml",
    "Panzyga",
    "Papaverine Hydrochloride Injection Usp",
    "Patent Blue Sodium Injection",
    "Pdp-acetaminophen Solution 160mg/5ml",
    "Pdp-amantadine Hydrochloride Syrup",
    "Pdp-amlodipine",
    "Pdp-hydrocodone",
    "Pdp-levetiracetam",
    "Pediacol",
    "Pediapharm Naproxen Suspension",
    "Pediapred",
    "Pediatrix",
    "Dulcocomfort Stool Softener",
    "Dulcolax",
    "Dulcolax For Women",
    "Duloxetine",
    "Duloxetine Dr",
    "Durela",
    "Dutasteride",
    "Duvoid Tablets 10 Mg",
    "Duvoid Tablets 25 Mg",
    "Duvoid Tablets 50 Mg",
    "Ebixa",
    "Enalapril Maleate/hctz",
    "Endometrin",
    "Entecavir Tablets",
    "Enteric Coated Asa Tablets 325mg",
    "Enteric Coated Asa Tablets 650mg",
    "Enteric Coated Daily Low Dose Asa 81mg",
    "Entex La",
    "Entocort",
    "Entresto",
    "Entrophen",
    "Entrophen Chewable",
    "Envarsus Pa",
    "Epclusa",
    "Epival",
    "Euro-colchicine",
    "Evista (60mg)",
    "Exelon 1.5 Mg",
    "Exjade",
    "Extra Strength Acetaminophen",
    "Extra Strength Acetaminophen Caplets",
    "Extra Strength Acetaminophen Tablets 500 Mg",
    "Extra Strength Allergy Formula Liquid Capsules",
    "Extra Strength Allergy Relief",
    "Extra Strength Allergy Sinus Medication",
    "Extra Strength Allergy Total",
    "Extra Strength Benadryl Allergy",
    "Extra Strength Benadryl Allergy Nighttime",
    "Extra Strength Cold Medication Daytime Relief",
    "Extra Strength Cold Medication Nighttime Relief",
    "Extra Strength Dormex Caplets",
    "Extra Strength Flu Relief Daytime",
    "Extra Strength Ibuprofen",
    "Extra Strength Ibuprofen Liquid Capsules",
    "Extra Strength Ibuprofen Liquid Gel Capsules",
    "Extra Strength Mucous Relief Chest",
    "Extra Strength Mucous Relief Cough",
    "Extra Strength Muscle & Back Pain Asa 500 Mg Methocarbamol 400 Mg & Acetylsalicylic Acid 500 Mg",
    "Extra Strength Muscle & Back Pain Relief",
    "Extra Strength Muscle & Back Pain Relief With Asa",
    "Extra Strength Nytol Quickgels",
    "Extra Strength Nytol Tab 50mg",
    "Extra Strength Sinus Relief Daytime",
    "Extra Strength Sinutab Sinus & Allergy",
    "Extra Strength Sinutab Sinus Daytime",
    "Extra Strength Sinutab Sinus Nighttime",
    "Extra Strength Sudafed Head Cold & Sinus",
    "Extra Strength Tylenol Back Pain",
    "Extra Strength Tylenol Body Pain Night",
    "Extra Strength Tylenol Cold & Sinus Daytime",
    "Extra Strength Tylenol Cold & Sinus Nighttime",
    "Extra Strength Tylenol Cold Daytime",
    "Extra Strength Tylenol Cold Nighttime",
    "Extra Strength Tylenol Complete Cold, Cough & Flu",
    "Extra Strength Tylenol Complete Cold, Cough & Flu Daytime",
    "Spf 60 Sport Clear Continuous Spray",
    "Spf 60 Sport Endurance",
    "Spf 60 Ultra Light Advanced Lotion",
    "Spf 60 Ultra Light Advanced Weightless Face Lotion",
    "Spf Fps 100 Sun Protection Lotion",
    "Spf Fps 30 Sport Sunscreen Continuous Spray",
    "Spf Fps 30 Sun Protection Lotion",
    "Spf Fps 40 Lotion",
    "Spf Fps 50+ Sunscreen Lotion",
    "Spf Fps 60 Sun Protection Lotion",
    "Spf/fps 15",
    "Spf/fps 30",
    "Spf/fps 30 Body/corps",
    "Spf/fps 30 Eco-lux Size/format Écolux Body / Corps",
    "Spf/fps 30 Lipbalm",
    "Spf/fps 50 Broad Spectrum Alcohol Free Sunscreen",
    "Sunscreen Stick Spf 50+",
    "Sunthera3 Kids/enfants Spf/fps 50 Continuous Spray",
    "Sunthera3 Sensitive Skin/peau Sensible Spf/fps 60",
    "Sunthera3 Sport Spf/fps 30 Continuous Spray",
    "Sunzone Family Spf 45",
    "Sunzone Family Spf 50",
    "Sunzone Kids Spf 45",
    "Sunzone Kids Spf 50",
    "Sunzone Sport Spf 45",
    "Sunzone Sunscreen Écran Solaire Spray Wet 60 Spf/fps",
    "Super Fluid Uv Defense Spf 50",
    "Super Sheer Sunscreen Lotion Spf 50",
    "Superdefense City Block Daily Energy + Face Protector Spf 50",
    "Superdefense Fatigue + 1st Signs Of Age Multi-correcting Cream Crème Multi-correction Fatigue + 1ers Signes De L'âge Combination Oily To Oily / Mixte À Grasse Spf 25 Fps",
    "Superdefense Fatigue + 1st Signs Of Age Multi-correcting Cream Crème Multi-correction Fatigue + 1ers Signes De L'âge Very Dry To Dry Combination / Très Sèche À Mixte Spf 25 Fps",
    "Pms-entecavir",
    "Pms-erlotinib",
    "Pms-escitalopram",
    "Pms-ezetimibe",
    "Pms-famciclovir",
    "Pms-finasteride",
    "Pms-fingolimod",
    "Pms-fluconazole",
    "Pms-montelukast Fc",
    "Pms-nabilone",
    "Pms-nifedipine Er",
    "Pms-nitrofurantoin Bid",
    "Pms-olanzapine",
    "Pms-olanzapine Odt",
    "Pms-olmesartan",
    "Pms-omeprazole",
    "Pms-ondansetron",
    "Pms-oxycodone",
    "Pms-oxycodone Cr",
    "Pms-pantoprazole",
    "Pms-paroxetine",
    "Pms-perindopril",
    "Pms-pravastatin",
    "Pms-pregabalin",
    "Pms-progesterone",
    "Pms-valacyclovir",
    "Pms-valproic Acid E.c.",
    "Pms-venlafaxine Xr",
    "Pms-zolmitriptan Odt",
    "Pms-zolpidem Odt",
    "Pms-zopiclone",
    "Pomalyst",
    "Portia 21",
    "Portia 28",
    "Pradaxa",
    "Fentanyl Injection Bp",
    "Fluad",
    "Fluad Pediatric",
    "Flucelvax Quad",
    "Flulaval Tetra",
    "Fluviral",
    "Fluzone High-dose",
    "Fluzone Quadrivalent",
    "Forteo",
    "Gardasil 9",
    "Neupogen",
    "Nimenrix",
    "Nivestym",
    "Octostim Liq Inj. 15mcg/ml",
    "Octreotide Acetate Omega",
    "One-alpha",
    "Orgalutran",
    "Osnuvo",
    "Ovidrel",
    "Pediacel",
    "Zyban",
    "Zydelig",
    "Zykadia",
    "Zyloprim",
    "Zyprexa",
    "Zyprexa - 10mg",
    "Zyprexa - 5mg",
    "Alkeran",
    "Gammagard S/d",
    "Melphalan For Injection",
    "Ph 12 Sterile Diluent For Flolan",
    "Pregnyl",
    "Entocort Enema",
    "Priorix",
    "Varilrix",
    "Yf-vax",
    "Zostavax Ii",
    "Inomax",
    "Kinox",
    "Noxivent",
    "Tubersol",
    "Hypertet S/d",
    "Rabavert",
    "Rotateq",
    "Antibiotic Ointment",
    "Antibiotic Ointment Usp",
    "Bacitin",
    "Bacitracin Zinc Ointment Usp",
    "Band-aid Brand Adhesive Bandages Plus Antibiotic",
    "Bioderm Ointment",
    "Complete Antibiotic Ointment",
    "First Aid Antibiotic Ointment",
    "Jampolycin",
    "Nyaderm Crm 100000unit/gm",
    "Polyderm Ointment Usp",
    "Polysporin Antibiotic Ointment",
    "Polysporin Singles",
    "Ratio-nystatin",
    "Santyl",
    "Sterisporin",
    "Viaderm Kc Ont",
    "Creon Minimicrospheres Micro",
    "Admelog",
    "Admelog Solostar",
    "Allergenic Extract - Mixture Of 4 Standardized Grass Pollen",
    "Allergenic Extract - Mixture Of 5 Standardized Grass Pollen",
    "Allergenic Extract - Non-pollens",
    "Allergenic Extract - Pollens",
    "Allergenic Extract - Standardized Orchard Grass Pollen",
    "Allergenic Extract - Standardized Perennnial Rye Grass Pollen",
    "Allergenic Extract - Standardized Redtop Grass Pollen",
    "Allergenic Extract - Standardized Sweet Vernal Grass Pollen",
    "Allergenic Extract - Standardized Timothy Grass Pollen",
    "Allergenic Extract Non Pollens",
    "Allergenic Extract Pollens",
    "Allergenic Extract Standardized Mite Df (10,000 Au/ml)",
    "Allergenic Extract Standardized Mite Df (30,000 Au/ml)",
    "Allergenic Extract-standardized Cat Hair",
    "Allergenic Extract, Standardardized Mite, D. Farinae",
    "Allergenic Extract, Standardized Mite Mixed",
    "Allergenic Extract, Standardized Mite, D.pteronyssinus",
    "[f-18]-fludeoxyglucose (fdg) Injection",
    "Fludeoxyglucose (f-18)",
    "Fluglucoscan Injection",
    "Fluorohmet (citrate)",
    "Fluorohmet (phosphate)",
    "Yttriga",
    "Xofigo",
    "Sehcat",
    "Hema Bp-38",
    "Adacel-polio",
    "Incruse Ellipta",
    "Inspiolto Respimat",
    "Ipravent",
    "Mylan-beclo Aq",
    "Mylan-budesonide Aq",
    "Nasacort Allergy 24hr",
    "Nasacort Aq",
    "Nasonex",
    "Omnaris",
    "Oxeze Turbuhaler",
    "Pms-fluticasone Hfa",
    "Pms-fluticasone Propionate/salmeterol Dpi",
    "Pulmicort Turbuhaler",
    "Qvar",
    "Sandoz Estradiol Derm 100",
    "Sandoz Estradiol Derm 50",
    "Sandoz Estradiol Derm 75",
    "Sandoz Fentanyl Patch",
    "Teva-fentanyl",
    "Act-hib",
    "Adacel",
    "Addnutriv",
    "Afluria Tetra",
    "Ag-cyclobenzaprine",
    "Ag-duloxetine",
    "Ag-emtricitabine / Tenofovir Disoproxil Fumarate",
    "Ag-escitalopram",
    "Ag-ezetimibe",
    "Agrylin",
    "Akynzeo",
    "Aldactone 100 Mg",
    "Aldactone 25 Mg",
    "Alecensaro",
    "Alendronate",
    "Alendronate-70",
    "Alertec",
    "Aleve Back And Body Pain",
    "Aleve Liquid Gels",
    "Aleve Nighttime",
    "Aleve Tablets",
    "Alfuzosin",
    "Alka-seltzer Flavoured",
    "Allegra 12 Hour",
    "Allegra 24 Hour",
    "Allegra-d",
    "Aller-relief",
    "Allergy Formula Caplets",
    "Allergy Formula Liquid Capsules",
    "Allergy Liquid Gel Capsules",
    "Allergy Relief",
    "Allergy Relief Liquid Gels",
    "Allergy Remedy",
    "Allergy Tablets 25mg",
    "Allergy Tablets Extra Strength",
    "Allernix",
    "Allernix Extra Strength",
    "Allertin",
    "Allopurinol-100",
    "Allopurinol-200",
    "Allopurinol-300",
    "Almotriptan",
    "Alprazolam",
    "Alprazolam-0.25",
    "Alprazolam-0.5",
    "Alta-docusate Sodium",
    "Altace",
    "Altace Hct",
    "Alunbrig",
    "Apo-abiraterone Film Coated Tablets",
    "Apo-acebutolol",
    "Apo-acetaminophen",
    "Apo-acetaminophen Caplets",
    "Apo-acetaminophen Caplets Extra Strength",
    "Apo-acetaminophen Extra Strength",
    "Apo-acyclovir",
    "Apo-acyclovir - Tab 200mg",
    "Apo-acyclovir - Tab 400mg",
    "Apo-adefovir",
    "Apo-alendronate",
    "Apo-alfuzosin",
    "Apo-allopurinol",
    "Apo-alpraz",
    "Apo-alpraz Ts",
    "Apo-ambrisentan",
    "Apo-amiodarone Tablets",
    "Apo-amitriptyline",
    "Apo-amlodipine",
    "Apo-amlodipine-atorvastatin",
    "Ach-fluoxetine",
    "Ach-letrozole"
]

